msgid ""
msgstr ""
"POT-Creation-Date: 2021-01-14 11:53+0100\n"
"Mime-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: Poedit 3.0\n"
"Language: de\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"
"MIME-Version: 1.0\n"

msgid "“{description}”"
msgstr "„{description}“"

msgid "({freeMembers} free)"
msgstr "({freeMembers} kostenlos)"

msgid "(expired today)"
msgstr "(heute abgelaufen)"

msgid "(expiring today)"
msgstr "(läuft heute ab)"

msgid "(Recycle bin)"
msgstr "(Papierkorb)"

msgid "(total {loginCount})"
msgstr "(insgesamt {loginCount})"

msgid "(total {userCount})"
msgstr "(insgesamt {userCount})"

#. placeholder {0}: -remainingTrialDays
msgid "{0, plural, one {(expired # day ago)} other {(expired # days ago)}}"
msgstr "{0, plural, one {(seit # Tag abgelaufen)} other {(seit # Tagen abgelaufen)}}"

#. placeholder {0}: accounts.length
msgid "{0, plural, one {# Account} other {# Accounts}}"
msgstr "{0, plural, one {# Account} other {# Accounts}}"

#. placeholder {0}: childOrganization.delegatedAdmins.length
#. placeholder {0}: delegatedAdmins.length
msgid "{0, plural, one {# admin (delegated)} other {# admins (delegated)}}"
msgstr "{0, plural, one {# Admin (delegiert)} other {# Admins (delegiert)}}"

#. placeholder {0}: apps.length
msgid "{0, plural, one {# App/Platform} other {# Apps/Platforms}}"
msgstr "{0, plural, one {# App/Plattform} other {# Apps/Plattformen}}"

#. placeholder {0}: mergedBreaches.length
msgid "{0, plural, one {# Breach} other {# Breaches}}"
msgstr "{0, plural, one {# Vorfall} other {# Vorfälle}}"

#. placeholder {0}: events?.totalCount ?? 0
msgid "{0, plural, one {# event} other {# events}}"
msgstr "{0, plural, one {# Ereignis} other {# Ereignisse}}"

#. placeholder {0}: sortedChildOrgs.length
msgid "{0, plural, one {# Organization} other {# Organizations}}"
msgstr "{0, plural, one {# Organisation} other {# Organisationen}}"

#. placeholder {0}: Object.entries(filteredRolesWithCount).length
msgid "{0, plural, one {# Role} other {# Roles}}"
msgstr "{0, plural, one {# Rolle} other {# Rollen}}"

#. placeholder {0}: invalidEmailUserLines.length
#. placeholder {1}: invalidEmailUserLines.length
#. placeholder {2}: invalidEmailUserLines.join(', ')
msgid "{0, plural, one {# row} other {# rows}} skipped due to invalid email. {1, plural, one {Line number} other {Line numbers}}: {2}"
msgstr "{0, plural, one {# Zeile wurde} other {# Zeilen wurden}} aufgrund einer ungültigen E-Mail-Adresse übersprungen. {1, plural, one {Zeilennummer} other {Zeilennummern}}: {2}"

#. placeholder {0}: syncedGroups.length
msgid "{0, plural, one {# synchronized group} other {# synchronized groups}}"
msgstr "{0, plural, one {# synchronisierte Gruppe} other {# synchronisierte Gruppen}}"

#. placeholder {0}: blockedUsers.length
msgid "{0, plural, one {# user must be enabled in Microsoft Entra before sending a start code} other {# users must be enabled in Microsoft Entra before sending a start code}}"
msgstr "{0, plural, one {# Nutzer muss in Microsoft Entra aktiviert werden, bevor ein Startcode gesendet werden kann} other {# Nutzer müssen in Microsoft Entra aktiviert werden, bevor Startcodes gesendet werden können}}"

#. placeholder {0}: (csv.users && Object.keys(csv.users).length) ?? 0
#. placeholder {0}: (googleWorkspace.users && Object.keys(googleWorkspace.users).length) ?? 0
#. placeholder {0}: entra.userCount ?? 0
msgid "{0, plural, one {# user} other {# users}}"
msgstr "{0, plural, other {# Nutzer}}"

#. placeholder {0}: selectedUsers.size
msgid "{0, plural, one {# user} other {# users}} selected"
msgstr "{0, plural, other {# Nutzer}} ausgewählt"

#. placeholder {0}: users.length
msgid "{0, plural, one {Cannot remove user} other {Cannot remove users}}"
msgstr "{0, plural, one {Dieser Nutzer kann nicht entfernt werden} other {Diese Nutzer können nicht entfernt werden}}"

#. placeholder {0}: splitStartCodes.revoked.length
msgid "{0, plural, one {Create new start code} other {Create # new start codes}}"
msgstr "{0, plural, one {Neuen Startcode erzeugen} other {# neue Startcodes erzeugen}}"

#. placeholder {0}: splitStartCodes.revoked.length
msgid "{0, plural, one {Creating new start code} other {Creating new start codes}}"
msgstr "{0, plural, one {Neuer Startcode wird erzeugt} other {Neue Startcodes werden erzeugt}}"

#. placeholder {0}: loginIds.length
msgid "{0, plural, one {Delete # entry?} other {Delete # entries?}}"
msgstr "{0, plural, one {# Eintrag löschen?} other {# Einträge löschen?}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnect login device for this user?} other {Disconnect login device for # users?}}"
msgstr "{0, plural, one {Verbindung zum Login-Gerät trennen für diesen Nutzer?} other {Verbindung zum Login-Gerät trennen für # Nutzer?}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnect login device} other {Disconnect # login devices}}"
msgstr "{0, plural, one {Verbindung zum Login-Gerät trennen} other {Verbindung zu # Login-Geräten trennen}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnect phone for this user?} other {Disconnect phone for # users?}}"
msgstr "{0, plural, one {Handy-Verbindung trennen für diesen Nutzer?} other {Handy-Verbindung trennen für # Nutzer?}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnect phone} other {Disconnect # phones}}"
msgstr "{0, plural, one {Handy-Verbindung trennen} other {# Handy-Verbindungen trennen}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnect security key for this user?} other {Disconnect security key for # users?}}"
msgstr "{0, plural, one {Sicherheitsschlüssel trennen für diesen Nutzer?} other {Sicherheitsschlüssel trennen für # Nutzer?}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnect security key} other {Disconnect # security keys}}"
msgstr "{0, plural, one {Sicherheitsschlüssel trennen} other {# Sicherheitsschlüssel trennen}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnect user} other {Disconnect # users}}"
msgstr "{0, plural, one {Verbindung trennen} other {# Verbindungen trennen}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnecting this account conflicts with another account that has the same email address.} other {Disconnecting some of these accounts conflicts with another account that has the same email address.}}"
msgstr "{0, plural, one {Beim Trennen der Verbindung tritt ein Konflikt mit einem anderen Account mit derselben E-Mail-Adresse auf.} other {Beim Trennen einiger dieser Verbindungen tritt ein Konflikt mit einem anderen Account mit derselben E-Mail-Adresse auf.}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Disconnecting this account would result in a managed organization being left without an admin.} other {Disconnecting some of these accounts would result in a managed organization being left without an admin.}}"
msgstr "{0, plural, other {Beim Trennen der Verbindung verliert eine verwaltete Organisation ihren letzten Admin.}}"

#. placeholder {0}: loginMoveInfos.filter((lmi) => canMoveLoginsToVault([lmi], targetVault)).length
#. placeholder {1}: targetVault.label
#. placeholder {2}: targetVault.label
msgid "{0, plural, one {Move # login to {1}} other {Move # logins to {2}}}"
msgstr "{0, plural, one {# Login nach {1} verschieben} other {# Logins nach {2} verschieben}}"

#. placeholder {0}: deletableUsers.length
msgid "{0, plural, one {Remove # user?} other {Remove # users?}}"
msgstr "{0, plural, one {# Nutzer entfernen?} other {# Nutzer entfernen?}}"

#. placeholder {0}: deletableUsers.length
msgid "{0, plural, one {Remove # user} other {Remove # users}}"
msgstr "{0, plural, one {# Nutzer entfernen} other {# Nutzer entfernen}}"

#. placeholder {0}: users.length
msgid "{0, plural, one {Remove user} other {Remove users}}"
msgstr "{0, plural, one {Nutzer entfernen} other {Nutzer entfernen}}"

#. placeholder {0}: users.length
msgid "{0, plural, one {Resend email invite} other {Resend # email invites}}"
msgstr "{0, plural, one {E-Mail-Einladung erneut schicken} other {# E-Mail-Einladungen erneut schicken}}"

#. placeholder {0}: splitStartCodes.usable.length
#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {Revoke start code} other {Revoke # start codes}}"
msgstr "{0, plural, one {Startcode widerrufen} other {# Startcodes widerrufen}}"

#. placeholder {0}: splitStartCodes.usable.length
msgid "{0, plural, one {Revoking start code} other {Revoking start codes}}"
msgstr "{0, plural, one {Startcode wird widerrufen} other {Startcodes werden widerrufen}}"

#. placeholder {0}: users.length
msgid "{0, plural, one {Send email invite} other {Send # email invites}}"
msgstr "{0, plural, one {E-Mail-Einladung schicken} other {# E-Mail-Einladungen schicken}}"

#. placeholder {0}: splitStartCodes.usable.length
msgid "{0, plural, one {Send start code via email} other {Send # start codes via email}}"
msgstr "{0, plural, one {Startcode per E-Mail übermitteln} other {# Startcodes per E-Mail übermitteln}}"

#. placeholder {0}: splitStartCodes.usable.length
msgid "{0, plural, one {Sending start code} other {Sending start codes}}"
msgstr "{0, plural, one {Startcode wird übermittelt} other {Startcodes werden übermittelt}}"

#. placeholder {0}: users.length
msgid "{0, plural, one {Show start code} other {Show start code for # users}}"
msgstr "{0, plural, one {Startcode anzeigen} other {Startcode für # Nutzer anzeigen}}"

#. placeholder {0}: splitStartCodes.revoked.length
msgid "{0, plural, one {Start code created} other {Start codes created}}"
msgstr "{0, plural, one {Startcode neu erzeugt} other {Startcodes neu erzeugt}}"

#. placeholder {0}: splitStartCodes.usable.length
msgid "{0, plural, one {Start code revoked} other {Start codes revoked}}"
msgstr "{0, plural, one {Startcode widerrufen} other {Startcodes widerrufen}}"

#. placeholder {0}: splitStartCodes.usable.length
msgid "{0, plural, one {Start code sent} other {Start codes sent}}"
msgstr "{0, plural, one {Startcode wurde übermittelt} other {Startcodes wurden übermittelt}}"

#. placeholder {0}: 7
msgid "{0, plural, one {The links expire after # day.} other {The links expire after # days.}}"
msgstr "{0, plural, one {Die Links laufen nach # Tag ab.} other {Die Links laufen nach # Tagen ab.}}"

#. placeholder {0}: users.length
msgid "{0, plural, one {The role for this user cannot be changed.} other {The role for these users cannot be changed.}}"
msgstr "{0, plural, one {Die Rolle kann für diesen Benutzer nicht geändert werden.} other {Die Rolle kann für diese Benutzer nicht verändert werden.}}"

#. placeholder {0}: users.length
msgid "{0, plural, one {This user cannot be removed.} other {These users cannot be removed.}}"
msgstr "{0, plural, one {Dieser Nutzer kann nicht entfernt werden.} other {Diese Nutzer können nicht entfernt werden.}}"

#. placeholder {0}: deletableUsers.length
msgid "{0, plural, one {This user is the only admin in a managed organization and cannot be removed. Please make sure all managed organizations have another admin and try again.} other {One of these users is the only admin in a managed organization and cannot be removed. Please make sure all managed organizations have another admin and try again.}}"
msgstr "{0, plural, one {Dieser Nutzer ist der einzige Admin in einer verwalteten Organisation und kann nicht entfernt werden. Bitte stelle sicher, dass alle verwalteten Organisationen einen weiteren Admin haben und versuche es erneut.} other {Einer der Nutzer ist der einzige Admin in einer verwalteten Organisation und kann nicht entfernt werden. Bitte stelle sicher, dass alle verwalteten Organisationen einen weiteren Admin haben und versuche es erneut.}}"

#. placeholder {0}: userGroup.users.length
msgid "{0, plural, one {You can connect a new login device for this user afterwards.} other {You can connect a new login device for the users afterwards.}}"
msgstr "{0, plural, one {Du kannst danach ein neues Login-Gerät für diesen Nutzer verbinden.} other {Du kannst danach ein neues Login-Gerät für diese Nutzer verbinden.}}"

#. placeholder {0}: manager.email
#. placeholder {0}: parentOrgProfile.email
#. placeholder {0}: user.email
msgid "{0} (You)"
msgstr "{0} (Du)"

#. placeholder {0}: keptUsers[0].email ?? t`Unknown user`
msgid "{0} cannot be removed."
msgstr "{0} kann nicht entfernt werden."

#. placeholder {0}: selectedGroups.length
#. placeholder {1}: groupsList.length
msgid "{0} of {1, plural, one {# group} other {# groups}} selected"
msgstr "{0} von {1, plural, one {# Gruppe} other {# Gruppen}} ausgewählt"

#. placeholder {0}: keptUsers.length
msgid "{0} users cannot be removed."
msgstr "{0} Nutzer können nicht entfernt werden."

#. placeholder {0}: singularCandidate.name
msgid "{0} will have full access to this organization."
msgstr "{0} erhält vollen Zugriff auf diese Organisation."

#. placeholder {0}: vaultMetadata.owner.email
msgid "{0}’s personal logins are empty. You can <0>import entries</0> or <1>add a new entry</1> to fill them."
msgstr "Die persönlichen Logins von {0} sind leer. Du kannst <0>Einträge importieren</0> oder <1>einen neuen Eintrag hinzufügen</1>, um sie zu füllen."

msgid "{activeShareLinkCount, plural, one {There is # active share link.} other {There are # active share links.}}"
msgstr "{activeShareLinkCount, plural, one {Es gibt # aktiven geteilten Link.} other {Es gibt # aktive geteilte Links.}}"

msgid "{activeShareSecretCount, plural, one {There is # encrypted link.} other {There are # encrypted links.}}"
msgstr "{activeShareSecretCount, plural, one {Es gibt # verschlüsselten Link.} other {Es gibt # verschlüsselte Links.}}"

msgid "{amount} / monthly"
msgstr "{amount} / monatlich"

msgid "{amount} / yearly"
msgstr "{amount} / jährlich"

msgctxt "date-fns format string"
msgid "{atAbsoluteDate}"
msgstr "'am' {atAbsoluteDate}"

msgid "{billableUsers, plural, one {# user} other {# users}}"
msgstr "{billableUsers, plural, other {# Nutzer}}"

#. placeholder {0}: getOsDescription(t, parsed.os)
msgid "{browserName} on {0}"
msgstr "{browserName} auf {0}"

msgid "{c, plural, one {# account count} other {# account counts}}"
msgstr "{c, plural, one {# Account-Anzahl} other {# Account-Anzahlen}}"

msgid "{c, plural, one {# admin (delegated)} other {# admins (delegated)}}"
msgstr "{c, plural, one {# Admin (delegiert)} other {# Admins (delegiert)}}"

msgid "{c, plural, one {# event type} other {# event types}}"
msgstr "{c, plural, one {# Ereignis-Typ} other {# Ereignis-Typen}}"

msgid "{c, plural, one {# group} other {# groups}}"
msgstr "{c, plural, one {# Gruppe} other {# Gruppen}}"

msgid "{c, plural, one {# leak check} other {# leak checks}}"
msgstr "{c, plural, one {# Leak-Check} other {# Leak-Checks}}"

msgid "{c, plural, one {# location} other {# locations}}"
msgstr "{c, plural, one {# Speicherort} other {# Speicherorte}}"

msgid "{c, plural, one {# login location} other {# login locations}}"
msgstr "{c, plural, one {# Login-Speicherort} other {# Login-Speicherorte}}"

msgid "{c, plural, one {# login} other {# logins}}"
msgstr "{c, plural, one {# Login} other {# Logins}}"

msgid "{c, plural, one {# origin} other {# origins}}"
msgstr "{c, plural, one {# Herkunft} other {# Herkünfte}}"

msgid "{c, plural, one {# password strength} other {# password strength}}"
msgstr "{c, plural, one {# Passwortstärke} other {# Passwortstärken}}"

msgid "{c, plural, one {# policy check} other {# policy checks}}"
msgstr "{c, plural, one {# Policy-Check} other {# Policy-Checks}}"

msgid "{c, plural, one {# role} other {# roles}}"
msgstr "{c, plural, one {# Rolle} other {# Rollen}}"

msgid "{c, plural, one {# target user} other {# target users}}"
msgstr "{c, plural, one {# Ziel-Nutzer} other {# Ziel-Nutzer}}"

msgid "{c, plural, one {# team} other {# teams}}"
msgstr "{c, plural, one {# Team} other {# Teams}}"

msgid "{c, plural, one {# user} other {# users}}"
msgstr "{c, plural, other {# Nutzer}}"

msgid "{c, plural, other {# status}}"
msgstr "{c, plural, other {# Status}}"

msgid "{connected} connected"
msgstr "{connected} verbunden"

msgid "{count, plural, one {# user} other {# users}}"
msgstr "{count, plural, one {# Nutzer} other {# Nutzer}}"

msgid "{disabledCount, plural, other {# disabled}}"
msgstr "{disabledCount, plural, other {# deaktiviert}}"

msgid "{disconnected} not connected"
msgstr "{disconnected} nicht verbunden"

msgid "{entraSyncGroupCount, plural, one {# group synchronized} other {# groups synchronized}}"
msgstr "{entraSyncGroupCount, plural, one {# Gruppe synchronisiert} other {# Gruppen synchronisiert}}"

msgid "{formattedFrom} – {formattedTo}"
msgstr "{formattedFrom} – {formattedTo}"

msgid "{formattedStartDate} to {formattedEndDate}"
msgstr "{formattedStartDate} bis {formattedEndDate}"

msgid "{importedUsersCount, plural, one {# user} other {# users}} imported from CSV."
msgstr "{importedUsersCount, plural, other {# Nutzer}} aus CSV-Datei importiert."

msgid "{label} is disabled on this device"
msgstr "{label} ist auf diesem Gerät deaktiviert"

msgid "{loginCount, plural, one {# entry} other {# entries}}"
msgstr "{loginCount, plural, one {# Eintrag} other {# Einträge}}"

msgid "{loginCount, plural, one {# team login} other {# team logins}}"
msgstr "{loginCount, plural, one {# Team-Login} other {# Team-Logins}}"

msgid "{matchingTeamMemberCount, plural, one {# matching user already is a team member.} other {# matching users already are team members.}}"
msgstr "{matchingTeamMemberCount, plural, one {# passender Nutzer ist bereits Team-Mitglied.} other {# passende Nutzer sind bereits Team-Mitglieder.}}"

msgid "{memberCount, plural, one {# user} other {# users}}"
msgstr "{memberCount, plural, other {# Nutzer}}"

msgid "{minutes, plural, one {# minute} other {# minutes}}"
msgstr "{minutes, plural, one {# Minute} other {# Minuten}}"

msgid "{nonMemberCount, plural, one {# not member} other {# not member}}"
msgstr "{nonMemberCount, plural, one {# nicht Mitglied} other {# nicht Mitglied}}"

msgid "{nonMemberCount, plural, one {Add # user} other {Add # users}}"
msgstr "{nonMemberCount, plural, other {# Nutzer hinzufügen}}"

msgid "{nonMemberCount, plural, one {Add} other {Add # users}}"
msgstr "{nonMemberCount, plural, one {Hinzufügen} other {# Nutzer hinzufügen}}"

msgid "{nonMemberCount, plural, one {Not member} other {# not member}}"
msgstr "{nonMemberCount, plural, one {Nicht Mitglied} other {# nicht Mitglied}}"

msgid "{organizationName} logo"
msgstr "Logo von {organizationName}"

msgid "{profileName} (All organization teams)"
msgstr "{profileName} (Alle Organisations-Teams)"

msgid "{profileName} (My teams)"
msgstr "{profileName} (Meine Teams)"

#. placeholder {0}: userCount - profileUserCount
msgid "{profileUserCount, plural, =1 {# account} other {# accounts}}, {0, plural, =1 {# user} other {# users}} without account"
msgstr "{profileUserCount, plural, =1 {# Account} other {# Accounts}}, {0, plural, other {# Nutzer}} ohne Account"

msgid "{recentlyPairedSessionName} was set up successfully"
msgstr "{recentlyPairedSessionName} erfolgreich eingerichtet"

msgid "{remainingTrialDays, plural, one {(# day remaining)} other {(# days remaining)}}"
msgstr "{remainingTrialDays, plural, one {(# Tag verbleibend)} other {(# Tage verbleibend)}}"

msgid "{revisionTimeEl} – by {editProfileEmail}"
msgstr "{revisionTimeEl} – von {editProfileEmail}"

msgid "{selectedLoginCount, plural, one {Delete entry} other {Delete entries}}"
msgstr "{selectedLoginCount, plural, one {Eintrag löschen} other {Einträge löschen}}"

msgid "{selectedLoginCount, plural, one {Restore entry} other {Restore entries}}"
msgstr "{selectedLoginCount, plural, one {Eintrag wiederherstellen} other {Einträge wiederherstellen}}"

msgid "{selectedLoginCount} of {filteredLoginCount} entries selected"
msgstr "{selectedLoginCount} von {filteredLoginCount} Einträgen ausgewählt"

msgid "{selectedUserCount, plural, one {Activate account in heylogin} other {Activate # accounts in heylogin}}"
msgstr "{selectedUserCount, plural, one {Account in heylogin aktivieren} other {# Accounts in heylogin aktivieren}}"

msgid "{selectedUserCount} of {filteredUserCount, plural, one {# user} other {# users}} selected"
msgstr "{selectedUserCount} von {filteredUserCount, plural, one {# Nutzer} other {# Nutzern}} ausgewählt"

msgid "{selectionSize, plural, one {# login selected} other {# logins selected}}"
msgstr "{selectionSize, plural, one {# Login ausgewählt} other {# Logins ausgewählt}}"

msgid "{title} (CSV)"
msgstr "{title} (CSV)"

msgid "{totalTrialDays}-day test phase"
msgstr "Testphase ({totalTrialDays} Tage):"

msgid "{trialDurationDays, plural, one {Trial ends tomorrow} other {Trial ends in # days}}"
msgstr "{trialDurationDays, plural, one {Testphase endet morgen} other {Testphase endet in # Tagen}}"

msgid "{userCount, plural, one {(# user)} other {(# users)}}"
msgstr "{userCount, plural, other {(# Nutzer)}}"

msgid "{userCount, plural, one {# guest member} other {# guest members}}"
msgstr "{userCount, plural, one {# Gast-Mitglied} other {# Gast-Mitglieder}}"

msgid "{userCount, plural, one {# team member} other {# team members}}"
msgstr "{userCount, plural, one {# Teammitglied} other {# Teammitglieder}}"

msgid "{userCount, plural, one {# user} other {# users}}"
msgstr "{userCount, plural, other {# Nutzer}}"

msgid "{withStartCode} not connected (waiting for registration)"
msgstr "{withStartCode} nicht verbunden (wartet auf Registrierung)"

msgid "*All prices plus VAT"
msgstr "*Alle angezeigten Preise zzgl. MwSt."

msgid "/user/month*"
msgstr "/Nutzer/Monat*"

msgid "#@$"
msgstr "#@$"

msgid "< 100%"
msgstr "< 100%"

msgid "< 50%"
msgstr "< 50%"

msgid "<0>Install heylogin Autotype <1/></0> on your system."
msgstr "<0>Installiere heylogin Autotype <1/></0> auf deinem System."

msgid "<0>Note:</0> If the import doesn't work, try changing your StickyPassword language to English before exporting."
msgstr "<0>Hinweis:</0> Sollte der Import nicht funktionieren, versuche die Sprache in StickyPassword vor dem Export auf Englisch umzustellen."

msgid "<0>Personal Logins</0> stores logins of your organization only used by you. Admins <1>cannot</1> see passwords here."
msgstr "In <0>Persönliche Logins</0> werden Logins von deiner Organisation gespeichert, die nur du verwendest. Admins können hier Passwörter <1>nicht</1> einsehen."

msgid "€3.99"
msgstr "€ 3,99"

msgid "€4.99"
msgstr "€ 4,99"

msgid "0{nonBreakingHyphen}9"
msgstr "0{nonBreakingHyphen}9"

msgid "1. Configure sync"
msgstr "1. Synchronisation konfigurieren"

msgid "1. Connect to Entra"
msgstr "1. Mit Entra verbinden"

msgid "100%"
msgstr "100%"

msgid "100% GDPR-compliant and confidential handling"
msgstr "100% DSGVO-konforme und vertrauliche Handhabung"

msgid "1Password"
msgstr "1Password"

msgid "2-factor automation (TOTP)"
msgstr "2-Faktor-Automatisierung (TOTP)"

msgid "2. Configure sync"
msgstr "2. Synchronisation konfigurieren"

msgid "2. Review sync settings"
msgstr "2. Einstellung überprüfen"

msgid "3. Review sync settings"
msgstr "3. Einstellung überprüfen"

msgid "A – Z"
msgstr "A – Z"

msgid "A group can only be removed if it contains no logins."
msgstr "Gruppen können nur entfernt werden, wenn sie keine Logins enthalten."

msgid "A label name cannot contain a slash"
msgstr "Ein Labelname darf keinen Schrägstrich enthalten"

msgid "A second admin can recover your account if you lose access to your login devices."
msgstr "Ein zweiter Admin kann deinen Account wiederherstellen, falls du keinen Zugriff mehr auf deine Login-Geräte hast."

msgid "a{nonBreakingHyphen}z"
msgstr "a{nonBreakingHyphen}z"

msgid "A{nonBreakingHyphen}Z"
msgstr "A{nonBreakingHyphen}Z"

msgid "Account"
msgstr "Account"

msgid "Account balances"
msgstr "Kontostände"

msgid "Account count"
msgstr "Account-Anzahl"

msgid "Account holder"
msgstr "Kontoinhaber"

msgid "Account name"
msgstr "Accountname"

msgctxt "KeeperImport"
msgid "Account number"
msgstr "Kontonummer"

msgctxt "KeeperImport"
msgid "Account type"
msgstr "Kontotyp"

msgid "Accounts"
msgstr "Accounts"

msgid "Accounts on this device"
msgstr "Accounts auf diesem Gerät"

msgid "Action canceled"
msgstr "Aktion abgebrochen"

msgid "Action confirmed"
msgstr "Aktion bestätigt"

msgid "Activate"
msgstr "Aktivieren"

msgid "Activate “heylogin – Password Manager”"
msgstr "Aktiviere „heylogin – Passwort-Manager“"

msgid "Activate on this device"
msgstr "Auf diesem Gerät aktivieren"

msgid "Activate plan"
msgstr "Plan aktivieren"

msgid "Activate plan for “{organizationName}”"
msgstr "Plan aktivieren für „{organizationName}“"

msgid "Activate plan: heylogin Enterprise MSP"
msgstr "Plan aktivieren: heylogin Enterprise MSP"

msgid "Activate the heylogin Enterprise MSP plan for this customer."
msgstr "Aktiviere den heylogin Enterprise MSP-Plan für diesen Kunden."

msgid "Activating {selectedUserCount, plural, one {account} other {accounts}}…"
msgstr "{selectedUserCount, plural, one {Account wird} other {Accounts werden}} aktiviert…"

msgid "Activating the <0>heylogin Enterprise MSP</0> plan for this organization is a billable event."
msgstr "Das Aktivieren des Plans <0>heylogin Enterprise MSP</0> ist zahlungspflichtig."

msgid "Active"
msgstr "Aktiv"

msgid "Active links"
msgstr "Aktive Links"

msgid "Active until"
msgstr "Aktiv bis"

msgid "Active user"
msgstr "Aktiver Nutzer"

msgid "Add"
msgstr "Hinzufügen"

msgid "Add admin (delegated)"
msgstr "Admin (delegiert) hinzufügen"

msgid "Add description"
msgstr "Beschreibung hinzufügen"

msgid "Add filter"
msgstr "Filter hinzufügen"

msgid "Add icon"
msgstr "Icon hinzufügen"

msgid "Add label…"
msgstr "Label hinzufügen…"

msgid "Add link and copy"
msgstr "Link erstellen und kopieren"

msgid "Add login manually"
msgstr "Login manuell hinzufügen"

msgid "Add login to"
msgstr "Login hinzufügen zu"

msgid "Add logins manually"
msgstr "Logins manuell hinzufügen"

msgid "Add logo"
msgstr "Logo hinzufügen"

msgid "Add member"
msgstr "Mitglied hinzufügen"

msgid "Add member to {targetVaultName}"
msgstr "Mitglied zu {targetVaultName} hinzufügen"

msgid "Add new organization member to team"
msgstr "Neues Organisationsmitglied zu Team hinzufügen"

msgid "Add new user"
msgstr "Neuen Nutzer hinzufügen"

msgid "Add new user to organization"
msgstr "Neuen Nutzer zur Organisation hinzufügen"

msgid "Add organization member"
msgstr "Organisationsmitglied hinzufügen"

msgid "Add recipient profile picture"
msgstr "Empfänger-Profilbild hinzufügen"

msgid "Add service user"
msgstr "Service-Nutzer hinzufügen"

msgid "Add team logins"
msgstr "Team-Logins hinzufügen"

msgid "Add the app name (e.g. Teams.exe) to the respective login in heylogin, just like a website. You can use the keyboard shortcut above to find the app name."
msgstr "Füge den App-Namen (z. B. Teams.exe) bei dem jeweiligen Login in heylogin hinzu, wie eine Webseite. Nutze das Tastenkürzel oben, um den App-Namen herauszufinden."

msgid "Add to Chrome"
msgstr "Hinzufügen zu Chrome"

msgid "Add to Firefox"
msgstr "Zu Firefox hinzufügen"

msgid "Add to heylogin"
msgstr "Zu heylogin hinzufügen"

msgid "Add to Opera"
msgstr "Zu Opera hinzufügen"

msgid "Add user"
msgstr "Nutzer hinzufügen"

msgid "Add user to team"
msgstr "Nutzer zum Team hinzufügen"

msgid "Add your contact information"
msgstr "Füge deine Kontaktinformationen hinzu"

msgid "Adding…"
msgstr "Wird hinzugefügt…"

msgid "Additional columns will be imported as well and can be used to filter users"
msgstr "Weitere Spalten werden ebenfalls importiert und können zum Filtern benutzt werden"

msgid "Additional login devices"
msgstr "Zusätzliche Login-Geräte"

msgid "Additional security key"
msgstr "Zusätzlicher Sicherheitsschlüssel"

msgctxt "KeeperImport"
msgid "Address"
msgstr "Adresse"

msgid "Address book contacts"
msgstr "Adressbuchkontakte"

msgid "Adjust domains?"
msgstr "Domains anpassen?"

msgid "Admin"
msgstr "Admin"

msgid "Admin (delegated)"
msgstr "Admin (delegiert)"

msgid "Admin access"
msgstr "Admin-Zugriff"

msgid "Admins (delegated)"
msgstr "Admins (delegiert)"

msgid "Affected accounts:"
msgstr "Betroffene Accounts:"

msgid "Affected data:"
msgstr "Betroffene Daten:"

msgid "After enabling the user in Entra, the user can be reconnected"
msgstr "Der Nutzer kann wieder verbunden werden, nachdem er in Entra aktiviert wurde"

msgid "After that tap “Manage Extensions”"
msgstr "Tippe anschließend auf „Erweiterungen verwalten“"

msgid "Age groups"
msgstr "Altersgruppen"

msgid "Age recipient"
msgstr "Age-Empfänger"

#. placeholder {0}: shareSecretData.ageRecipient
msgid "Age recipient: <0>{0}</0>"
msgstr "Age-Empfänger: <0>{0}</0>"

msgid "Ages"
msgstr "Alter"

msgid "all accessible logins"
msgstr "alle zugreifbaren Logins"

msgid "All delegated admins are in this team automatically."
msgstr "Alle delegierten Admins sind automatisch in diesem Team."

msgid "All functions of Business"
msgstr "Alle Funktionen von Business"

msgid "All functions of Free"
msgstr "Alle Funktionen von Free"

msgid "All groups already synchronized"
msgstr "Alle Gruppen werden bereits synchronisiert"

msgid "All login activities at one glance"
msgstr "Alle Login-Aktivitäten immer im Blick"

#. placeholder {0}: profileInfo.label
msgid "All logins in the organization “{0}” will no longer be accessible to you."
msgstr "Du kannst nicht mehr auf Logins in der Organisation „{0}“ zugreifen."

msgid "All logins in the organization will be deleted."
msgstr "Alle Logins in dieser Organisation werden gelöscht."

msgid "All members of the organization are also members of this team."
msgstr "Alle Mitglieder der Organisation sind bereits Mitglieder in diesem Team."

msgid "All organization members already are delegated admins of this managed organization."
msgstr "Alle Organisations-Mitglieder sind bereits delegierte Admins dieser verwalteten Organisation."

msgid "All organization users are in this team automatically."
msgstr "Alle Nutzer in der Organisation sind automatisch Mitglieder dieses Teams."

msgid "All personal logins will be deleted."
msgstr "Alle persönlichen Logins werden gelöscht."

msgid "All teams"
msgstr "Alle Teams"

msgid "All user accounts in the organization will be removed."
msgstr "Alle Nutzer-Accounts in dieser Organisation werden entfernt."

msgid "All Users"
msgstr "Alle Nutzer"

msgid "Allow access on all pages"
msgstr "Zugriffsrechte für jede Webseite erlauben"

msgid "Already extended"
msgstr "wurde bereits verlängert"

msgid "An account has been prepared for this email address in an organization. Please install the heylogin app on your phone or use a security key to continue."
msgstr "Für diese E-Mail-Adresse wurde ein Account in einer Organisation vorbereitet. Bitte installiere die heylogin-App auf deinem Handy oder nutze einen Sicherheitsschlüssel, um fortzufahren."

msgid "An admin of the managing organization needs to remove the last delegated admin from this organization."
msgstr "Der letzte delegierte Admin dieser Organisation kann nur von einem Admin der verwaltenden Organisation entfernt werden."

msgid "An email invite will be sent to every person"
msgstr "Eine E-Mail-Einladung wird an jede Person geschickt"

msgid "an hour"
msgstr "einer Stunde"

msgid "An internal error occurred, please <0>contact support</0>"
msgstr "Ein interner Fehler ist aufgetreten, bitte <0>kontaktiere den Support</0>"

msgid "An overview of your login devices. You can connect new devices for unlocking heylogin here."
msgstr "Eine Übersicht deiner Login-Geräte. Hier kannst du zusätzliche Geräte zum Entsperren mit heylogin verbinden."

msgid "An unknown error occurred, please <0>contact support</0>"
msgstr "Ein unbekannter Fehler ist aufgetreten, bitte <0>kontaktiere den Support</0>"

msgid "Android App (Play Store Beta)"
msgstr "Android-App (Play-Store-Beta)"

msgid "Android or iPhone"
msgstr "Android oder iPhone"

msgid "Another login inbox with the same email is already enabled. Disable it to enable this login inbox."
msgstr "Ein anderer Login-Posteingang mit dieser E-Mail-Adresse ist aktiv. Deaktiviere ihn, um diesen Login-Posteingang zu aktivieren."

msgctxt "KeeperImport"
msgid "Answer"
msgstr "Antwort"

msgid "App overview"
msgstr "App-Übersicht"

msgid "App/Platform"
msgstr "App/Plattform"

msgid "Apple Passwords"
msgstr "Apple Passwörter"

msgctxt "KeeperImport"
msgid "Application title"
msgstr "Anwendungstitel"

msgid "Apply"
msgstr "Anwenden"

msgid "Apply as filter"
msgstr "Als Filter anwenden"

msgid "Appointments"
msgstr "Termine"

msgid "Apps"
msgstr "Apps"

msgid "Apps installed on devices"
msgstr "Auf Geräten installierte Apps"

msgid "Assign team access to others"
msgstr "Anderen Team-Zugriff geben"

msgid "Assign team access to self"
msgstr "Sich selbst Team-Zugriff geben"

msgid "Assigned roles provide clarity and structure, as not every employee requires the same level of administrative freedom. heylogin offers a range of roles with different permissions to meet these needs."
msgstr "Zugewiesene Rollen schaffen Klarheit und Struktur, da nicht jeder Mitarbeitende den gleichen Verwaltungsspielraum braucht. heylogin bietet Ihnen dafür verschiedene Rollen mit unterschiedlichen Berechtigungen."

msgid "Astrological signs"
msgstr "Sternzeichen"

msgid "At least one user must be admin. It is recommended to have at least two admins."
msgstr "Mindestens ein Nutzer muss Admin sein. Es wird empfohlen, mindestens zwei Admins zu haben."

msgid "Attach screenshot (Images only, max 3 MB)"
msgstr "Screenshot anhängen (nur Bilder, max. 3 MB)"

msgid "Audio recordings"
msgstr "Audioaufnahmen"

msgid "Audit log"
msgstr "Audit-Log"

msgid "Auth tokens"
msgstr "Auth-Token"

msgid "Auto save with heylogin"
msgstr "Auto-Speichern mit heylogin"

msgid "Automatic provisioning"
msgstr "Automatische Provisionierung"

msgid "Automatically create users in heylogin from selected Entra groups"
msgstr "Automatisches Erstellen von Nutzern in heylogin aus ausgewählten Entra-Gruppen"

msgid "Automatically disconnect users in heylogin that are disabled in Entra"
msgstr "Automatisches Trennen von in Entra deaktivierten Nutzern in heylogin"

msgid "Autotype"
msgstr "Autotype"

msgid "Autotype for Windows"
msgstr "Autotype für Windows"

msgid "Autotype instruction screenshot"
msgstr "Autotype-Anleitungs-Screenshot"

msgid "Autotype is not installed"
msgstr "Autotype nicht installiert"

msgid "Autotype is outdated"
msgstr "Autotype ist nicht aktuell"

msgctxt "KeeperImport"
msgid "Autotype keystrokes"
msgstr "Autotype-Tasteneingaben"

msgid "Available Entra groups"
msgstr "Verfügbare Entra-Gruppen"

msgid "Avatars"
msgstr "Avatare"

msgid "Back"
msgstr "Zurück"

msgid "Backup Code"
msgstr "Backup-Code"

msgctxt "KeeperImport"
msgid "Bank account"
msgstr "Bankkonto"

msgid "Bank account numbers"
msgstr "Bank-Kontonummern"

msgid "Beauty ratings"
msgstr "Schönheitsbewertungen"

msgid "Beta"
msgstr "Beta"

msgid "Beta program"
msgstr "Beta-Programm"

msgid "BIC/SWIFT code"
msgstr "BIC"

msgid "Billing"
msgstr "Abrechnung"

msgid "Billing date"
msgstr "Rechnungsdatum"

msgid "Billing email"
msgstr "Rechnungs-E-Mail"

msgid "Biometric data"
msgstr "Biometrische Daten"

msgid "Bios"
msgstr "Biografien"

msgctxt "KeeperImport"
msgid "Birth date"
msgstr "Geburtsdatum"

msgid "Bitwarden"
msgstr "Bitwarden"

msgid "Book appointment"
msgstr "Termin buchen"

msgid "Breach date:"
msgstr "Vorfallsdatum:"

msgid "Browse to the location where you want to save the new CSV file, and then click “Save”."
msgstr "Wähle einen Speicherort für die neue Datei aus und klicke auf „Speichern“."

msgid "Browser Extensions"
msgstr "Browser-Extensions"

msgid "Browser user agent details"
msgstr "Browser-User-Agent-Details"

msgid "Browsing histories"
msgstr "Browsing-Verlauf"

msgid "Business"
msgstr "Business"

msgid "Buy additional licenses"
msgstr "Zusätzliche Lizenzen kaufen"

msgid "Buying big? Contact our sales team for better deals!"
msgstr "Großeinkauf? Kontaktiere unseren Vertrieb für einen besseren Deal!"

msgid "Buying preferences"
msgstr "Kaufpräferenzen"

msgid "Can assign delegated admins to all managed organizations"
msgstr "Kann in allen verwalteten Organisationen delegierte Admins hinzufügen"

msgid "Can connect new devices"
msgstr "Kann neue Geräte verbinden"

msgid "Can manage users, roles and integrations"
msgstr "Kann Nutzer, Rollen und Integrationen verwalten"

msgid "Can manage users, roles, integrations and child organizations"
msgstr "Kann Nutzer, Rollen, Integrationen und verwaltete Organisationen verwalten"

msgid "Can unlock devices"
msgstr "Kann Geräte entsperren"

msgid "Can unlock this device"
msgstr "Kann dieses Gerät entsperren"

msgid "Can use and edit logins and manage members."
msgstr "Kann Logins benutzen und bearbeiten und Mitglieder verwalten."

msgid "Can use and edit logins."
msgstr "Kann Logins benutzen und bearbeiten."

msgid "Can use and view logins."
msgstr "Kann Logins benutzen und einsehen."

msgid "Can use logins. Passwords are hidden."
msgstr "Kann Logins benutzen. Passwörter sind verborgen."

msgid "Can view managed organizations the user is not delegated admin in"
msgstr "Kann verwaltete Organisationen sehen, in denen der Nutzer kein delegierter Admin ist"

msgid "Can't change: Team must have at least one admin."
msgstr "Keine Änderung möglich: Team muss mindestens einen Admin haben."

msgid "Cancel"
msgstr "Abbrechen"

msgid "Cancel and back"
msgstr "Abbrechen und zurück"

msgid "Cancel change"
msgstr "Änderung abbrechen"

msgid "Cancel deletion"
msgstr "Löschung abbrechen"

msgid "Cancel your license first to convert to a managed organization."
msgstr "Kündige zuerst deine Lizenz, um die Organisation in eine verwaltete Organisation umzuwandeln."

msgid "Cancelled"
msgstr "Beendet"

msgid "Car ownership statuses"
msgstr "Fahrzeugbesitzstatus"

msgid "Card holder"
msgstr "Karteninhaber"

msgid "Career levels"
msgstr "Karrierestufen"

msgid "Cellular network names"
msgstr "Mobilfunknetzwerke"

msgid "Change billing email"
msgstr "Rechnungs-E-Mail ändern"

msgid "Change Email"
msgstr "E-Mail ändern"

msgid "Change email address"
msgstr "E-Mail-Adresse ändern"

msgid "Change icon"
msgstr "Icon ändern"

msgid "Change keyboard shortcut"
msgstr "Tastenkürzel ändern"

msgid "Change logo"
msgstr "Logo ändern"

msgid "Change plan"
msgstr "Plan ändern"

msgid "Change role"
msgstr "Rolle ändern"

msgid "Change settings"
msgstr "Einstellungen ändern"

msgid "Changed:"
msgstr "Geändert:"

msgid "Changed: {joinedDifferences}"
msgstr "Geändert: {joinedDifferences}"

#. placeholder {0}: differences.length
msgid "Changed: <0>{0, plural, one {# field} other {# fields}}</0>"
msgstr "Geändert: <0>{0, plural, one {# Feld} other {# Felder}}</0>"

#. placeholder {0}: values.email
msgid "Changing your email address to {0} would result in conflicting login inboxes, as a login inbox exists in this account and in another account with that email address. You can only have one login inbox per email address."
msgstr "Das Ändern deiner E-Mail-Adresse zu {0} würde zu zwei Login-Posteingängen mit der gleichen Adresse führen, da du bereits einen Login-Posteingang für {0} hast. Du kannst pro E-Mail-Adresse nur einen Login-Posteingang haben."

msgid "Charitable donations"
msgstr "Spenden"

msgid "Chat logs"
msgstr "Chatprotokolle"

msgid "Check again"
msgstr "Erneut prüfen"

msgid "Check your e-mails for the latest verification link, or request a new one."
msgstr "Schau in deine E-Mails nach dem aktuellen Bestätigungs-Link, oder fordere einen neuen an."

msgid "Checking logins for policy compliance"
msgstr "Logins werden auf Policy-Konformität überprüft"

msgid "Checking start code…"
msgstr "Startcode wird überprüft…"

#. placeholder {0}: import { plural, t } from '@lingui/core/macro'; import { Trans } from '@lingui/react/macro'; import classNames from 'classnames'; import React, { useCallback, useEffect, useMemo, useState } from 'react'; import { Email, ProfileId } from 'backend-client-web'; import { InlineProgressButton, Loading, NativeSelect, LinkButton } from 'client-web-sdk'; import Modal from 'src/components/modal/Modal'; import { ReactComponent as NextIcon } from './next.svg'; import { ReactComponent as PreviousIcon } from './previous.svg'; import styles from './StartCodeModal.module.css'; type ProfileStartCodes = { profileId: ProfileId; email: Email | undefined; startCode: string | undefined; }[]; export default function StartCodeModal({ isOpen, close, profileStartCodes, renewStartCodes, revokeStartCodes, sendStartCodeEmails, }: { isOpen: boolean; close: () => void; profileStartCodes?: ProfileStartCodes; renewStartCodes: (profileIds: ProfileId[]) => Promise<void>; revokeStartCodes: (profileIds: ProfileId[]) => Promise<void>; sendStartCodeEmails?: (profileIds: ProfileId[]) => Promise<void>; }) { const [showGuide, setShowGuide] = useState(false); return ( <Modal isOpen={isOpen} onRequestClose={close} width={showGuide ? '42rem' : '24rem'} className={classNames(styles.Modal, showGuide && styles.showGuide)} fullscreenClassName={styles.fullscreen} windowedClassName={styles.windowed} contentClassName={styles.ModalContent} > {profileStartCodes ? <ProfileStartCodeDisplay showGuide={showGuide} setShowGuide={setShowGuide} profileStartCodes={profileStartCodes} renewStartCodes={renewStartCodes} revokeStartCodes={revokeStartCodes} sendStartCodeEmails={sendStartCodeEmails} /> : <Loading />} </Modal> ); } function ProfileStartCodeDisplay({ showGuide, setShowGuide, profileStartCodes, renewStartCodes, revokeStartCodes, sendStartCodeEmails, }: { showGuide: boolean; setShowGuide: React.Dispatch<React.SetStateAction<boolean>>; profileStartCodes: ProfileStartCodes; renewStartCodes: (profileIds: ProfileId[]) => Promise<void>; revokeStartCodes: (profileIds: ProfileId[]) => Promise<void>; sendStartCodeEmails?: (profileIds: ProfileId[]) => Promise<void>; }) { return ( <div className={styles.Sections}> <StartCodeSection profileStartCodes={profileStartCodes} renewStartCodes={renewStartCodes} revokeStartCodes={revokeStartCodes} sendStartCodeEmails={sendStartCodeEmails} showGuide={showGuide} setShowGuide={setShowGuide} /> <GuideSection hidden={!showGuide} /> </div> ); } function GuideSection({ hidden }: { hidden: boolean }) { const [guide, setGuide] = useState<'phone' | 'securityKey'>('phone'); const securityKeyUri = `${window.location.host}/start`; return ( <section className={styles.GuideSection} aria-hidden={hidden}> <p className={styles.GuideChooser}> <label> <Trans>Guide for:</Trans>{' '} <NativeSelect className={styles.GuideSelect} value={guide} onChange={(e) => setGuide(e.currentTarget.value as any)} > <option value="phone">{t`Phone`}</option> <option value="securityKey">{t`Security Key`}</option> </NativeSelect> </label> </p> <ol className={styles.SetupSteps}> {guide === 'phone' ? <> <li> <Trans> Download the <strong>heylogin app</strong> </Trans> </li> <li> <Trans> Enter <strong>company email</strong> </Trans> </li> <li> <Trans> Enter <strong>start code</strong> </Trans> </li> </> : <> <li> <Trans> Open <strong>{securityKeyUri}</strong> in a desktop browser </Trans> </li> <li> <Trans> {/* Separate translation for inner string so it always matches the label in the actual UI in translation */} Choose <strong>“{t`Use a security key`}”</strong> </Trans> </li> <li> <Trans> Enter <strong>email</strong> and <strong>start code</strong> </Trans> </li> </> } </ol> </section> ); } function StartCodeSection({ profileStartCodes, renewStartCodes, revokeStartCodes, sendStartCodeEmails, showGuide, setShowGuide, }: { profileStartCodes: ProfileStartCodes; renewStartCodes: (profileIds: ProfileId[]) => Promise<void>; revokeStartCodes: (profileIds: ProfileId[]) => Promise<void>; sendStartCodeEmails?: (profileIds: ProfileId[]) => Promise<void>; showGuide: boolean; setShowGuide: React.Dispatch<React.SetStateAction<boolean>>; }) { const { visibleProfile, showPagination, profileIndex, changePage } = useProfilePagination(profileStartCodes); const [splitStartCodes, setSplitStartCodes] = useState({ usable: profileStartCodes, revoked: [] as ProfileStartCodes, }); const updateStartCodes = useCallback((scs: ProfileStartCodes) => { const usable: ProfileStartCodes = []; const revoked: ProfileStartCodes = []; for (const sc of scs) { if (sc.startCode) { usable.push(sc); } else { revoked.push(sc); } } setSplitStartCodes({ usable, revoked }); }, []); // Allow temporarily pausing start code updates, so we can finish the success animation with the // old state before the new state is shown const [startCodeUpdateHold, setStartCodeUpdateHold] = useState(false); useEffect(() => { if (startCodeUpdateHold) { return; } updateStartCodes(profileStartCodes); }, [profileStartCodes, startCodeUpdateHold, updateStartCodes]); if (!visibleProfile) { return <Loading />; } return ( <section className={styles.StartCodeSection}> <div className={styles.Subsection}> <p className={styles.StartCodeFor}> <Trans>Start code for:</Trans> </p> <p className={styles.StartCodeEmail}>{visibleProfile.email ?? t`Service User`}</p> </div> <div className={styles.Subsection}> <p className={classNames( styles.StartCode, visibleProfile.startCode === undefined && styles.placeholder, )} > <strong>{visibleProfile.startCode ?? 'XX-XXXX'}</strong> </p> {showPagination && ( <p className={styles.Pagination}> <button className={styles.IconButton} onClick={() => changePage(-1)} disabled={profileIndex === 0} > <PreviousIcon title={t`Previous`} /> </button> <span> <Trans> Start code {profileIndex + 1} of {profileStartCodes.length} </Trans> </span> <button className={styles.IconButton} onClick={() => changePage(1)} disabled={profileIndex === profileStartCodes.length - 1} > <NextIcon title={t`Next`} /> </button> </p> )} </div> <div className={styles.Subsection}> {splitStartCodes.usable.length > 0 && ( <> <InlineProgressButton className={styles.RevokeStartCode} performAction={async () => { setStartCodeUpdateHold(true); try { await revokeStartCodes(splitStartCodes.usable.map((p) => p.profileId)); } finally { setTimeout(() => setStartCodeUpdateHold(false), 1500); } }} getErrorLabel={() => t`Failed to revoke`} initialLabel={plural(splitStartCodes.usable.length, { one: 'Revoke start code', other: 'Revoke # start codes', })} inProgressLabel={plural(splitStartCodes.usable.length, { one: 'Revoking start code', other: 'Revoking start codes', })} successLabel={plural(splitStartCodes.usable.length, { one: 'Start code revoked', other: 'Start codes revoked', })} successRedoActionLabel={plural(splitStartCodes.usable.length, { one: 'Revoke start code', other: 'Revoke # start codes', })} errorRedoActionLabel={t`Retry`} /> {sendStartCodeEmails && ( <InlineProgressButton className={styles.SendMail} performAction={async () => { await sendStartCodeEmails(splitStartCodes.usable.map((p) => p.profileId)); }} getErrorLabel={() => t`Failed to send`} initialLabel={plural(splitStartCodes.usable.length, { one: 'Send start code via email', other: 'Send # start codes via email', })} inProgressLabel={plural(splitStartCodes.usable.length, { one: 'Sending start code', other: 'Sending start codes', })} successLabel={plural(splitStartCodes.usable.length, { one: 'Start code sent', other: 'Start codes sent', })} successRedoActionLabel={t`Send again`} errorRedoActionLabel={t`Retry`} /> )} </> )} {splitStartCodes.revoked.length > 0 && ( <InlineProgressButton className={styles.RevokeStartCode} performAction={async () => { setStartCodeUpdateHold(true); try { await renewStartCodes(splitStartCodes.revoked.map((p) => p.profileId)); } finally { setTimeout(() => setStartCodeUpdateHold(false), 1500); } }} getErrorLabel={() => t`Failed to renew`} initialLabel={plural(splitStartCodes.revoked.length, { one: 'Create new start code', other: 'Create # new start codes', })} inProgressLabel={plural(splitStartCodes.revoked.length, { one: 'Creating new start code', other: 'Creating new start codes', })} successLabel={plural(splitStartCodes.revoked.length, { one: 'Start code created', other: 'Start codes created', })} successRedoActionLabel={plural(splitStartCodes.revoked.length, { one: 'Create new start code', other: 'Create # new start codes', })} errorRedoActionLabel={t`Retry`} /> )} <LinkButton className={styles.Instructions} onClick={() => setShowGuide((g) => !g)}> {showGuide ? <Trans>Hide instructions</Trans> : <Trans>Show instructions</Trans>} </LinkButton> </div> </section> ); } function useProfilePagination(profileStartCodes: ProfileStartCodes) { const [visibleProfileId, setVisibleProfileId] = useState<ProfileId>(); const profileIndex = useMemo(() => { if (!visibleProfileId) { return 0; } const idx = profileStartCodes.findIndex((s) => s.profileId === visibleProfileId); if (idx === -1) { return 0; } return idx; }, [visibleProfileId, profileStartCodes]); const changePage = useCallback( (direction: -1 | 1) => { const newProfileIndex = clamp(0, profileIndex + direction, profileStartCodes.length - 1); const newVisibleProfileId = profileStartCodes[newProfileIndex]?.profileId; setVisibleProfileId(newVisibleProfileId); }, [profileIndex, profileStartCodes], ); const visibleProfile = profileIndex < profileStartCodes.length ? profileStartCodes[profileIndex] : undefined; return { visibleProfile, showPagination: profileStartCodes.length > 1, profileIndex, changePage }; } function clamp(min: number, num: number, max: number) { return Math.max(min, Math.min(max, num)); } 
msgid "Choose <0>“{0}”</0>"
msgstr "Wähle <0>„{0}“</0> aus"

msgid "Choose a file name and click “Save”."
msgstr "Wähle einen Dateinamen und klicke auf „Speichern“."

msgid "Chrome Extension (Beta)"
msgstr "Chrome-Extension (Beta)"

msgctxt "Storybook"
msgid "Chrome on macOS"
msgstr "Chrome auf macOS"

msgid "Citizenship statuses"
msgstr "Staatsbürgerschaftsstatus"

msgctxt "KeeperImport"
msgid "City"
msgstr "Stadt"

msgid "Clear"
msgstr "Zurücksetzen"

msgid "Clear selection"
msgstr "Auswahl aufheben"

msgid "Click “Export passwords...”."
msgstr "Klicke auf „Passwörter exportieren...“."

msgctxt "EdgeImportGuide"
msgid "Click “Export passwords...”."
msgstr "Klicke auf „Kennwörter exportieren...“."

msgid "Click “Export...”."
msgstr "Klicke auf „Export...“."

msgctxt "FirefoxImportGuide"
msgid "Click “Export...”."
msgstr "Klicke auf „Exportieren...“."

msgid "Click “File” in the top left corner."
msgstr "Wähle oben links „Datei“ aus."

msgid "Click “Save”."
msgstr "Klicke auf „Speichern“."

msgid "Click on “Export”."
msgstr "Klicke auf „Export“."

msgid "Click on “File”."
msgstr "Öffne oben links „File“."

msgid "Click on the Save-Icon."
msgstr "Klicke auf das Speichern-Symbol."

msgid "Click the 3 dots at the top right."
msgstr "Klicke oben rechts auf die drei Punkte."

msgid "Click the 3 dots in the upper right corner to open the menu."
msgstr "Klicke oben rechts auf die 3 Punkte."

msgid "Click the 3 dots next to “Saved Passwords”."
msgstr "Klicke neben „Gespeicherte Passwörter“ auf die 3 Punkte."

msgctxt "EdgeImportGuide"
msgid "Click the 3 dots next to “Saved Passwords”."
msgstr "Klicke neben „Gespeicherte Kennwörter“ auf die 3 Punkte."

msgid "Click the button below to open the CSV importer. Then drag the file into the marked area in the CSV importer."
msgstr "Klicke auf den Button unten, um den CSV-Importer zu öffnen. Ziehe dann die Datei in den markierten Bereich im CSV-Importer."

msgid "Click the heylogin icon in the toolbar and choose <0>“Always allow on every website…”</0>"
msgstr "Klicke auf das heylogin-Icon in der Werkzeugleiste und dann auf <0>„Auf jeder Webseite immer erlauben…“</0>"

msgid "Click the save icon."
msgstr "Klicke auf das Speichern-Symbol."

msgid "Click the three lines in the top right corner."
msgstr "Klicke oben rechts auf die drei Linien."

msgid "Click your e-mail address"
msgstr "Klicke auf die E‑Mail"

msgid "Close"
msgstr "Schließen"

msgid "Clothing sizes"
msgstr "Kleidergrößen"

msgid "Configure Entra"
msgstr "Entra konfigurieren"

msgid "Configure Microsoft Entra"
msgstr "Microsoft Entra konfigurieren"

msgid "Configure your sync settings to sync users with Microsoft Entra"
msgstr "Konfiguriere deine Synchronisationseinstellungen, um Nutzer mit Microsoft Entra zu synchronisieren"

msgid "Confirm"
msgstr "Übernehmen"

msgid "Confirm action"
msgstr "Aktion bestätigen"

msgid "Confirm code"
msgstr "Code bestätigen"

msgid "Confirm the first dialog with <0>“Always Allow…”</0>"
msgstr "Bestätige den ersten Dialog mit <0>„Immer erlauben…“</0>"

msgid "Confirm the second dialog with <0>“Always allow on Every Website”</0>"
msgstr "Bestätige den zweiten Dialog mit <0>„Auf jeder Webseite immer erlauben“</0>"

msgid "Confirm with security key (FIDO2), Touch ID or Windows Hello"
msgstr "Bestätige mit einem Sicherheitsschlüssel (FIDO2), Touch ID oder Windows Hello"

msgid "Confirm with smartphone"
msgstr "Bestätigen mit Smartphone"

msgid "Connect"
msgstr "Verbinden"

msgid "Connect devices"
msgstr "Geräte verbinden"

msgid "Connect login device"
msgstr "Login-Gerät verbinden"

msgid "Connect now"
msgstr "Jetzt verbinden"

msgid "Connect security key"
msgstr "Sicherheitsschlüssel verbinden"

msgid "Connect to Entra"
msgstr "Mit Entra verbinden"

msgid "Connect users"
msgstr "Nutzer verbinden"

msgid "Connect via PIN"
msgstr "Per PIN verbinden"

msgid "Connected"
msgstr "Verbunden"

msgid "Connected to Entra"
msgstr "Mit Entra verbunden"

#. placeholder {0}: browserSupport.browserDescription
msgid "Connecting new devices using a security key is not supported by your browser ({0})."
msgstr "Das Verbinden neuer Geräte mittels Sicherheitsschlüssel wird von deinem Browser ({0}) nicht unterstützt."

msgid "Connecting new devices with a security key requires Windows 11 version 22H2 or newer. Please upgrade Windows to use this feature."
msgstr "Das Verbinden neuer Geräte mittels Sicherheitsschlüssel erfordert Windows 11 Version 22H2 oder neuer. Bitte aktualisiere Windows, um dieses Feature zu verwenden."

msgid "Connecting with security key failed."
msgstr "Verbinden eines neuen Geräts mit Sicherheitsschlüssel fehlgeschlagen."

msgid "Connecting…"
msgstr "Wird verbunden…"

msgid "Connection failed!"
msgstr "Verbindung fehlgeschlagen!"

msgid "Connection is being established…"
msgstr "Verbindung wird hergestellt…"

msgid "Connection successful!"
msgstr "Verbindung erfolgreich!"

msgid "Contact"
msgstr "Ansprechpartner"

msgid "Contact profile picture"
msgstr "Ansprechpartner-Profilbild"

msgid "Contact sales"
msgstr "Kontakt zum Vertrieb"

msgid "Contact support"
msgstr "Support kontaktieren"

msgid "Contact Support"
msgstr "Support kontaktieren"

msgid "Contained empty custom field name"
msgstr "Enthielt leeren Feldnamen"

msgid "Continue"
msgstr "Weiter"

msgid "Continue plan"
msgstr "Plan fortsetzen"

msgid "Continue to configure"
msgstr "Weiter zu Einstellungen"

msgid "Continue to my logins"
msgstr "Weiter zu meinen Logins"

msgid "Continue to review"
msgstr "Weiter zur Überprüfung"

msgid "Continuous monitoring of <0>{localizedTotalPwnCountBillions} bn stolen accounts</0> on the web*"
msgstr "Kontinuierliche Überwachung von <0>{localizedTotalPwnCountBillions} Milliarden gestohlenen Accounts</0> im Web*"

msgid "Contract period:"
msgstr "Laufzeit:"

msgid "Contract period: <0>{formattedStartDate} to {formattedEndDate}</0>"
msgstr "Laufzeit: <0>{formattedStartDate} bis {formattedEndDate}</0>"

msgid "Convert"
msgstr "Umwandeln"

#. placeholder {0}: organization.name
msgid "Convert {0} to an independent organization"
msgstr "{0} in eine eigenständige Organisation umwandeln"

#. placeholder {0}: organization.name
msgid "Convert {0} to an independent organization?"
msgstr "{0} in eine eigenständige Organisation umwandeln?"

msgid "Convert to a managed organization?"
msgstr "In verwaltete Organisation umwandeln?"

msgid "Convert to independent organization"
msgstr "In eigenständige Organisation umwandeln"

msgid "Convert to managed organization"
msgstr "In verwaltete Organisation umwandeln"

#. placeholder {0}: singularCandidate.name
msgid "Convert to organization managed by {0}?"
msgstr "In von {0} verwaltete Organisation umwandeln?"

msgctxt "KeeperImport"
msgid "Country"
msgstr "Land"

msgid "Coupon successfully redeemed."
msgstr "Gutschein erfolgreich eingelöst."

msgid "Create"
msgstr "Erstellen"

msgid "Create an organization or a private account to export your logins."
msgstr "Erstelle eine Organisation oder einen privaten Account, um Logins zu exportieren."

msgid "Create an organization or a private account to import logins."
msgstr "Erstelle eine Organisation oder einen privaten Account, um Logins zu importieren."

msgid "Create an organization or a private account to manage your logins."
msgstr "Erstelle eine Organisation oder einen privaten Account, um deine Logins zu verwalten."

msgid "Create encrypted link"
msgstr "Verschlüsselten Link anlegen"

msgid "Create encrypted links to retrieve the login password via HTTP API. The link content is encrypted to the specified age recipient."
msgstr "Erstelle verschlüsselte Links, um das Login-Passwort mittels HTTP-API abzurufen. Der Link-Inhalt wird an den angegebenen Age-Empfänger verschlüsselt."

msgid "Create login inbox"
msgstr "Login-Posteingang erstellen"

msgid "Create managed organizations"
msgstr "Verwaltete Organisationen erstellen"

msgid "Create new"
msgstr "Neu erstellen"

msgid "Create new account"
msgstr "Neuen Account erstellen"

msgid "Create new organization"
msgstr "Neue Organisation erstellen"

msgid "Create new role"
msgstr "Neue Rolle anlegen"

msgid "Create organization"
msgstr "Organisation erstellen"

msgid "Create private account"
msgstr "Privaten Account anlegen"

msgid "Create teams"
msgstr "Teams anlegen"

msgid "Create teams that automatically keep members consistent with an Entra group"
msgstr "Erstellen von Teams, die Mitglieder automatisch mit einer Entra-Gruppe konsistent halten"

msgid "Create your account"
msgstr "Lege deinen Account an"

msgid "Create your heylogin account"
msgstr "Erstelle deinen heylogin-Account"

msgid "Create your organization on <0>heylogin.app</0>"
msgstr "Erstelle deine Organisation auf <0>heylogin.app</0>"

msgid "Created"
msgstr "Neu angelegt"

msgid "Created at"
msgstr "Erstellt am"

msgid "Created at {formattedCreationTime}."
msgstr "Erstellt am {formattedCreationTime}."

msgid "Created at {formattedCreationTime}. Not opened yet."
msgstr "Erstellt am {formattedCreationTime}. Noch nicht geöffnet."

msgid "Created on"
msgstr "Erstellt am"

msgid "Credential Exchange"
msgstr "Zugangsdaten-Austausch"

msgid "Credit card CVV"
msgstr "Kreditkarten-CVV"

msgid "Credit card expiration date"
msgstr "Kreditkarten-Ablaufdatum"

msgid "Credit card holder"
msgstr "Kreditkarteninhaber"

msgid "Credit card information"
msgstr "Kreditkarten-Informationen"

msgid "Credit card number"
msgstr "Kreditkartennummer"

msgid "Credit card pin"
msgstr "Kreditkarten-PIN"

msgid "Credit card security code"
msgstr "Kreditkarten-Sicherheitscode"

msgid "Credit cards"
msgstr "Kreditkarten"

msgid "Credit status information"
msgstr "Kreditstatusinformationen"

msgid "CSV"
msgstr "CSV"

msgid "CSV File"
msgstr "CSV-Datei"

msgid "CSV file accepted"
msgstr "CSV-Datei wurde erkannt"

msgid "Ctrl"
msgstr "Strg"

msgid "Current Plan"
msgstr "Derzeitiger Plan"

msgid "Current version"
msgstr "Aktuelle Version"

msgid "Currently there are no betas available."
msgstr "Aktuell sind keine Betas verfügbar."

msgid "Currently viewing recycle bin"
msgstr "Papierkorb geöffnet"

msgid "Currently viewing settings"
msgstr "Einstellungen geöffnet"

msgid "Currently, no organizations are managed by {parentOrgName}"
msgstr "Momentan werden keine Organisationen von {parentOrgName} verwaltet"

msgid "Custom"
msgstr "Benutzerdefiniert"

msgid "Custom password policy"
msgstr "Individuelle Passwort-Policy"

msgid "Custom roles (RBAC)"
msgstr "Benutzerdefinierte Rollen (RBAC)"

msgid "Customer feedback"
msgstr "Kundenfeedback"

msgid "Customer Inc."
msgstr "Kunde GmbH"

msgid "Customer interactions"
msgstr "Kundeninteraktionen"

msgid "Dashlane"
msgstr "Dashlane"

msgid "Data provided by <0>haveibeenpwned.com</0>"
msgstr "Daten bereitgestellt von <0>haveibeenpwned.com</0>"

msgid "Date"
msgstr "Datum"

msgctxt "KeeperImport"
msgid "Date"
msgstr "Datum"

msgctxt "KeeperImport"
msgid "Date active"
msgstr "Aktiv seit"

msgctxt "KeeperImport"
msgid "Date issued"
msgstr "Ausstellungsdatum"

#. placeholder {0}: entry.formattedImportDate
msgid "Date: {0}"
msgstr "Datum: {0}"

msgid "Dates of birth"
msgstr "Geburtsdaten"

msgid "Deceased date"
msgstr "Sterbedatum"

msgid "Deceased statuses"
msgstr "Verstorbenen-Status"

msgid "Delegated admin"
msgstr "Delegierter Admin"

msgid "Delegated Admins"
msgstr "Delegierte Admins"

msgid "Delegated admins cannot be disconnected."
msgstr "Delegierte Admins können nicht getrennt werden."

msgid "Delegated admins cannot be removed."
msgstr "Delegierte Admins können nicht entfernt werden."

msgid "Delegated admins may not have personal logins"
msgstr "Delegierte Admins können keine persönlichen Logins haben"

msgid "Delete"
msgstr "Löschen"

msgid "Delete edit history"
msgstr "Bearbeitungsverlauf löschen"

msgid "Delete edit history for all logins?"
msgstr "Bearbeitungsverlauf für alle Logins löschen?"

msgid "Delete login inbox"
msgstr "Login-Posteingang löschen"

msgid "Delete organization"
msgstr "Organisation löschen"

#. placeholder {0}: organization.name
msgid "Delete organization – {0}"
msgstr "Organisation löschen – {0}"

msgid "Delete private account"
msgstr "Privaten Account löschen"

msgid "Delete private heylogin account?"
msgstr "Privaten heylogin-Account löschen?"

msgid "Delete role"
msgstr "Rolle löschen"

msgid "Delete team"
msgstr "Team löschen"

msgid "Deleted by"
msgstr "Gelöscht von"

msgid "Deleted on"
msgstr "Gelöscht am"

msgid "Deleting…"
msgstr "Wird gelöscht…"

msgid "Deletion cancelled"
msgstr "Löschanfrage abgebrochen"

msgid "Deletion requested by"
msgstr "Löschung angefragt von"

msgid "Delimiter not found"
msgstr "Trennzeichen nicht gefunden"

msgid "Delivery instructions"
msgstr "Lieferanweisungen"

msgid "Demo License (NFR)"
msgstr "Demo-Lizenz (NFR)"

msgid "Description"
msgstr "Beschreibung"

msgid "Deselect all"
msgstr "Alle abwählen"

msgid "Details"
msgstr "Details"

msgid "Device information"
msgstr "Geräteinformationen"

msgid "Device is locked after <0/> without activity."
msgstr "Gerät wird nach <0/> ohne Aktivität gesperrt."

msgid "Device serial numbers"
msgstr "Geräteseriennummern"

msgid "Device usage tracking data"
msgstr "Gerätenutzungsdaten"

msgid "Devices are locked after at most <0/> without activity."
msgstr "Geräte werden nach höchstens <0/> ohne Aktivität gesperrt."

msgid "Disable sync for accounts"
msgstr "Synchronisation für Accounts deaktivieren"

msgid "disabled on this device"
msgstr "auf diesem Gerät deaktiviert"

msgid "Disconnect"
msgstr "Verbindung trennen"

msgid "Disconnect security key"
msgstr "Verbindung zum Sicherheitsschlüssel trennen"

msgid "Disconnect security key?"
msgstr "Verbindung zum Sicherheitsschlüssel trennen?"

msgid "Disconnecting…"
msgstr "Wird getrennt…"

msgid "Display name"
msgstr "Anzeigename"

msgid "Displayed name"
msgstr "Angezeigter Name"

msgid "Do you have additional questions? Please contact our <0>support team</0>"
msgstr "Du hast weitere Fragen? Bitte wende dich an unser <0>Support-Team</0>"

msgid "Do you like heylogin?"
msgstr "Dir gefällt heylogin?"

msgid "Do you want to delete this organization and all its data?"
msgstr "Möchtest du diese Organisation mit sämtlichen Daten endgültig löschen?"

msgid "Don't enable Swipe to Login for all websites"
msgstr "Swipe to Login für alle Webseiten nicht nutzen"

msgid "Don’t forget to delete the ZIP file after the import!"
msgstr "Vergiss nicht, die ZIP-Datei nach dem Import zu löschen!"

msgid "Done"
msgstr "Fertig"

msgid "Download"
msgstr "Herunterladen"

msgid "Download the <0>heylogin app</0>"
msgstr "<0>heylogin-App</0> herunterladen"

msgid "Drag the CSV file into the marked area."
msgstr "Ziehe die CSV-Datei in den markierten Bereich."

msgid "Drag the file into the marked area."
msgstr "Ziehe die Datei in den markierten Bereich."

msgid "Drag the ZIP file into the marked area below."
msgstr "Ziehe die ZIP-Datei in den markierten Bereich."

msgid "Drinking habits"
msgstr "Trinkgewohnheiten"

msgctxt "KeeperImport"
msgid "Driver's license number"
msgstr "Führerscheinnummer"

msgid "Driver's licenses"
msgstr "Führerscheine"

msgid "Drug habits"
msgstr "Drogenkonsumgewohnheiten"

msgid "Duplicate"
msgstr "Duplikat"

msgid "E-mail"
msgstr "E-Mail"

msgid "E-mail address"
msgstr "E-Mail-Adresse"

msgid "E-mail or username"
msgstr "E-Mail oder Nutzername"

msgid "E-mail verification was successful"
msgstr "Deine E-Mail-Adresse wurde bestätigt"

msgid "Each link can only be used once. The password will be visible."
msgstr "Jeder Link kann nur einmal benutzt werden. Das Passwort ist sichtbar."

msgid "Eating habits"
msgstr "Essgewohnheiten"

msgid "Edge Extension (Beta)"
msgstr "Edge-Extension (Beta)"

msgid "Edit"
msgstr "Bearbeiten"

msgid "Edit email"
msgstr "E-Mail bearbeiten"

msgid "Edit history (last 30 days)"
msgstr "Bearbeitungsverlauf (letzte 30 Tage)"

msgid "Edit history added"
msgstr "Bearbeitungsverlauf hinzugefügt"

msgid "Edit history and trash"
msgstr "Bearbeitungsverlauf und Papierkorb"

msgid "Education levels"
msgstr "Bildungsniveaus"

msgid "eight hours"
msgstr "acht Stunden"

msgid "ELSTER certificate information"
msgstr "ELSTER-Zertifikat-Informationen"

msgid "Email"
msgstr "E-Mail"

msgctxt "KeeperImport"
msgid "Email"
msgstr "E-Mail"

msgid "Email address"
msgstr "E-Mail-Adresse"

msgid "Email addresses"
msgstr "E-Mail-Adressen"

msgid "Email may not be empty!"
msgstr "E-Mail darf nicht leer sein!"

msgid "Email messages"
msgstr "E-Mail-Nachrichten"

msgid "Employers"
msgstr "Arbeitgeber"

msgid "Employment statuses"
msgstr "Beschäftigungsstatus"

msgid "Empty"
msgstr "Leer"

msgid "Enable"
msgstr "Aktivieren"

msgid "Enable account"
msgstr "Account aktivieren"

msgid "Enable automatic disconnect"
msgstr "Automatisches Trennen aktivieren"

msgid "Enable automatic provisioning"
msgstr "Automatische Provisionierung aktivieren"

msgid "Enable custom roles (RBAC)"
msgstr "Benutzerdefinierte Rollen (RBAC) aktivieren"

msgid "Enable Swipe to Login"
msgstr "Swipe to Login aktivieren"

msgid "Enabled on this device"
msgstr "Auf diesem Gerät aktiviert"

msgid "Encrypted keys"
msgstr "Verschlüsselte Schlüssel"

msgid "Encrypted Links"
msgstr "Verschlüsselte Links"

msgid "End-to-end encryption is enabled."
msgstr "Ende-zu-Ende-Verschlüsselung ist aktiviert."

msgid "Enpass"
msgstr "Enpass"

msgid "Ensure your admin access to {orgName}"
msgstr "Sichere deinen Admin-Zugang zu „{orgName}“"

msgid "Enter <0>company email</0>"
msgstr "<0>Firmen-E-Mail</0> eingeben"

msgid "Enter <0>email</0> and <1>start code</1>"
msgstr "Gib <0>E-Mail</0> und <1>Startcode</1> ein"

msgid "Enter <0>start code</0>"
msgstr "<0>Startcode</0> eingeben"

msgid "Enter age recipient to create a new encrypted link"
msgstr "Age-Empfänger eingeben, um einen verschlüsselten Link anzulegen"

msgid "Enter new label"
msgstr "Gib das neue Label ein"

msgid "Enter the 4-digit code"
msgstr "Gib den 4-stelligen Code ein"

msgid "Enter the code on your smartphone so we know it's you."
msgstr "Damit wir wissen, dass du es bist, gib den Code in die App auf deinem Smartphone ein."

msgid "Enter your master password and save the file."
msgstr "Tippe dein Master-Password ein und speichere die angebotene Datei."

msgid "Enter your master password."
msgstr "Gib dein Master-Password ein."

msgid "Enter your start code"
msgstr "Gib deinen Startcode ein"

msgid "Enterprise"
msgstr "Enterprise"

msgid "Entra"
msgstr "Entra"

msgid "Entra is connected"
msgstr "Entra ist verbunden"

msgid "Entra users in selected groups will be automatically created in heylogin. There are currently <0>{selectedUserCount}</0> selected users."
msgstr "Entra-Nutzer in ausgewählten Gruppen werden automatisch in heylogin angelegt. Aktuell sind <0>{selectedUserCount}</0> Nutzer ausgewählt."

msgid "Entra users in the tenant will be automatically created in heylogin. There are currently <0>{selectedUserCount}</0> users in the tenant."
msgstr "Entra-Nutzer des Tenants werden automatisch in heylogin angelegt. Aktuell sind <0>{selectedUserCount}</0> Nutzer im Tenant."

msgid "Entra users will be automatically disconnected in heylogin when disabled or deleted in Entra."
msgstr "Entra-Nutzer werden automatisch in heylogin getrennt, wenn sie in Entra deaktiviert oder gelöscht werden."

msgid "Entra users will be listed in heylogin but no account will be created"
msgstr "Entra-Nutzer werden in heylogin aufgelistet, aber es wird kein Account erstellt"

msgid "Entry"
msgstr "Eintrag"

msgid "Error connecting to Entra"
msgstr "Fehler beim Verbinden von Entra"

msgid "Error during upload, please try again later."
msgstr "Fehler während des Uploads, bitte versuche es später nochmal."

msgid "Error parsing entry"
msgstr "Eintrag konnte nicht gelesen werden"

msgid "Ethnicities"
msgstr "Ethnien"

msgid "Event type"
msgstr "Ereignis-Typ"

msgid "Event types"
msgstr "Ereignis-Typen"

msgctxt "Storybook"
msgid "Example Company"
msgstr "Beispiel-Firma"

msgid "Example Inc."
msgstr "Beispiel GmbH"

msgid "example.com"
msgstr "beispiel.de"

msgid "Excel"
msgstr "Excel"

msgid "Existing account will be linked to Entra"
msgstr "Bestehender Account wird mit Entra verknüpft"

msgid "Existing account will be unlinked from Entra"
msgstr "Verknüpfung von bestehendem Account wird aufgehoben"

msgctxt "KeeperImport"
msgid "Expiration"
msgstr "Ablaufdatum"

msgid "Expiration date"
msgstr "Ablaufdatum"

msgid "Expired"
msgstr "Abgelaufen"

msgid "Expired at {formattedExpiryTime}. Has not been opened."
msgstr "Abgelaufen am {formattedExpiryTime}. Wurde nicht geöffnet."

msgid "Expires at {formattedExpiryTime}"
msgstr "Läuft am {formattedExpiryTime} ab"

msgid "Export"
msgstr "Export"

msgid "Export – {vaultSelectionLabel}"
msgstr "Exportieren – {vaultSelectionLabel}"

msgid "Export a CSV file from your currently used tool or create one by hand."
msgstr "Exportiere eine CSV-Datei aus dem Programm, das du aktuell nutzt, oder lege sie manuell an."

msgid "Export from"
msgstr "Exportieren aus"

msgid "Export logins"
msgstr "Logins exportieren"

msgid "Export via the <0>heylogin export</0>."
msgstr "Exportiere mittels des <0>heylogin-Exporters</0>."

msgid "Export your logins in the <0>Sticky Password TXT</0> format following the <1>StickyPassword export guide</1>. This will give you a .txt file containing all exported data."
msgstr "Exportiere deine Logins in das <0>Sticky Password TXT</0> Format, folge dafür dem <1>Export-Guide von StickyPassword</1>. Du erhältst eine .txt-Datei."

msgid "Export your logins in the CSV format following the <0>Dashlane export guide</0>. This will give you a .zip file containing all exported data."
msgstr "Exportiere deine Logins in das CSV-Format. Folge dafür dem <0>Export-Guide von Dashlane</0>. Du erhältst eine .zip-Datei."

msgid "Export your logins in the JSON format following the <0>Keeper export guide</0>. This will give you a .json file containing all exported data."
msgstr "Exportiere deine Logins in das JSON-Format. Folge dafür dem <0>Export-Guide von Keeper</0>. Du erhältst eine .json-Datei."

msgctxt "KeeperImport"
msgid "Ext"
msgstr "Durchwahl"

msgid "Extend by 14 days once-only"
msgstr "Einmalig um 14 Tage verlängern"

msgid "Extend test phase"
msgstr "Testzeit verlängern"

msgid "Extensions & Apps"
msgstr "Extensions & Apps"

msgid "External links"
msgstr "Externe Links"

msgid "Failed to renew"
msgstr "Erneuern fehlgeschlagen"

msgid "Failed to revoke"
msgstr "Widerrufen fehlgeschlagen"

msgid "Failed to send"
msgstr "Übermitteln fehlgeschlagen"

msgid "Family members' names"
msgstr "Namen der Familienmitglieder"

msgid "Family plans"
msgstr "Familienpläne"

msgid "Family structure"
msgstr "Familienstruktur"

msgid "Features"
msgstr "Funktionen"

msgid "Feedback on {feature}"
msgstr "Feedback zu {feature}"

msgid "FIDO2 compatible"
msgstr "FIDO2-kompatibel"

msgid "Field copied"
msgstr "Feld kopiert"

msgid "Field inserted"
msgstr "Feld eingefügt"

msgid "Field shown"
msgstr "Feld angezeigt"

msgid "File accepted"
msgstr "Datei wurde erkannt"

msgid "File not recognized"
msgstr "Datei nicht erkannt"

msgid "Filter by group"
msgstr "Nach Gruppe filtern"

msgid "Filter users"
msgstr "Nutzer filtern"

msgid "Filter users by group"
msgstr "Nutzer nach Gruppe filtern"

msgid "Financial investments"
msgstr "Finanzanlagen"

msgid "Financial transactions"
msgstr "Finanztransaktionen"

msgid "Finish"
msgstr "Fertigstellen"

msgid "Finish installing heylogin for Safari"
msgstr "Schließe die Installation von heylogin für Safari ab"

msgid "Finish setup"
msgstr "Einrichtung abschließen"

msgctxt "KeeperImport"
msgid "First name"
msgstr "Vorname"

msgid "Fitness levels"
msgstr "Fitnessniveau"

msgid "five hours"
msgstr "fünf Stunden"

msgid "Flights taken"
msgstr "Informationen über Flüge"

msgid "Folder"
msgstr "Ordner"

msgid "Follow the <0>Export all passwords</0> steps in the <1>Apple Passwords export guide</1> to export your data as a CSV file."
msgstr "Folge den Schritten unter <0>Alle Passwörter exportieren</0> in der <1>Export-Anleitung von Apple Passwörter</1>, um deine Daten als CSV-Datei zu exportieren."

msgid "Follow the <0>LastPass export guide</0> to export your data in the CSV format."
msgstr "Folge der <0>LastPass Export-Anleitung (englisch)</0>, um deine Daten in das CSV-Format zu exportieren."

msgid "For large companies that want to manage complex organizational structures efficiently."
msgstr "Für große Unternehmen, die Organisationsstrukturen digital und effizient abbilden möchten."

msgid "For private users who want to simplify their login process."
msgstr "Für Privatnutzer, die ihren Login-Prozess vereinfachen möchten."

msgid "For small and medium-sized enterprises that want to share logins easily within the team. ‍"
msgstr "Für kleine und mittlere Unternehmen, die Logins einfach im Team nutzen möchten."

msgid "Free"
msgstr "Kostenlos"

msgctxt "export logins"
msgid "from"
msgstr "aus"

msgid "from 1Password"
msgstr "von 1Password"

msgid "from a CSV file"
msgstr "aus einer CSV-Datei"

msgid "from addons.mozilla.org"
msgstr "von addons.mozilla.org"

msgid "from Apple Passwords"
msgstr "aus Apple Passwörter"

msgid "from Bitwarden"
msgstr "von Bitwarden"

msgid "from Dashlane"
msgstr "von Dashlane"

msgid "from Enpass"
msgstr "von Enpass"

msgid "from Excel"
msgstr "von Excel"

msgid "from Google Chrome"
msgstr "von Google Chrome"

msgid "from heylogin"
msgstr "von heylogin"

msgid "from iCloud Keychain"
msgstr "aus dem iCloud-Schlüsselbund"

msgid "from KeePass"
msgstr "von KeePass"

msgid "from Keeper"
msgstr "von Keeper"

msgid "from LastPass"
msgstr "von LastPass"

msgid "from Microsoft Edge"
msgstr "von Microsoft Edge"

msgid "from Mozilla Firefox"
msgstr "von Mozilla Firefox"

msgid "from Nordpass"
msgstr "von Nordpass"

msgid "from Proton Pass"
msgstr "von Proton Pass"

msgid "from Safari"
msgstr "von Safari"

msgid "from StickyPassword"
msgstr "von StickyPassword"

msgid "from the Chrome Web Store"
msgstr "aus dem Chrome Web Store"

msgid "from the Mac App Store"
msgstr "aus dem Mac App Store"

msgid "from the Microsoft Store"
msgstr "aus dem Microsoft Store"

msgid "Functionality of heylogin may be impaired due to incorrect system clock on this device."
msgstr "Die Funktionalität von heylogin könnte eingeschränkt sein aufgrund abweichender Uhrzeit auf diesem Gerät."

msgid "Genders"
msgstr "Geschlechter"

msgid "Generate"
msgstr "Generieren"

msgid "Generate and save passwords"
msgstr "Passwörter generieren und speichern"

msgid "Generate new backup code"
msgstr "Neuen Backup-Code generieren"

msgid "Geographic locations"
msgstr "Geografische Standorte"

msgid "Get an overview of apps/platforms used in your organization. Note: In this beta, only information from teams you have direct access to is displayed."
msgstr "Gibt dir einen Überblick über die Apps/Plattformen in deiner Organisation. Hinweis: In dieser Beta werden nur Daten aus Teams angezeigt, auf die du direkten Zugriff hast."

msgid "Get it in Edge"
msgstr "Abrufen in Edge"

msgid "Get it in Safari"
msgstr "Laden in Safari"

msgid "Give feedback"
msgstr "Feedback geben"

msgid "Give us feedback on <0>{feature}</0>"
msgstr "Gib uns Feedback zu <0>{feature}</0>"

msgid "Go to <0>Managed organizations</0> to remove delegated admins."
msgstr "Öffne <0>Verwaltete Organisationen</0>, um delegierte Admins zu entfernen."

msgid "Go to <0>Management</0> to add or remove organization users."
msgstr "Gehe zu <0>Management</0>, um Organisations-Nutzer hinzuzufügen oder zu entfernen."

msgid "Go to imported logins"
msgstr "Zu den importierten Logins"

msgid "Go to login"
msgstr "Gehe zum Login"

msgid "Go to login location"
msgstr "Gehe zum Login-Speicherort"

msgid "Go to start page"
msgstr "Zur Startseite"

msgid "Google Chrome"
msgstr "Google Chrome"

msgid "Google Workspace"
msgstr "Google Workspace"

msgid "Got any questions? Contact us: <0>support@heylogin.com</0>"
msgstr "Hast du Fragen? Schreib uns: <0>support@heylogin.com</0>"

msgid "Government issued IDs"
msgstr "Von der Regierung ausgestellte Ausweise"

msgid "Group"
msgstr "Gruppe"

msgid "Group (Entra)"
msgstr "Gruppe (Entra)"

msgid "Group was created as a team"
msgstr "Gruppe wurde als Team angelegt"

msgid "Groups"
msgstr "Gruppen"

msgid "Groups (Entra)"
msgstr "Gruppen (Entra)"

msgid "Guest members are only members of this team, not of its organization. Guest members are deprecated, please add organization members instead."
msgstr "Gast-Mitglieder sind nur Mitglieder dieses Teams, nicht seiner Organisation. Gast-Mitglieder werden nicht mehr unterstützt, füge stattdessen Organisations-Mitglieder hinzu."

msgid "Guide for:"
msgstr "Anleitung für:"

msgid "Have a look at some upcoming features in heylogin! Test and help shape features early, before they are released to all users."
msgstr "Das gibt’s Neues bei heylogin! Teste Funktionen frühzeitig und gestalte sie mit, bevor sie für alle Nutzer veröffentlicht werden."

msgid "Health insurance information"
msgstr "Krankenversicherungsinformationen"

msgid "Help Center"
msgstr "Help Center"

msgid "Hey, you made it!"
msgstr "Hey, du hast es geschafft!"

msgid "heylogin"
msgstr "heylogin"

msgid "heylogin Business"
msgstr "heylogin Business"

msgid "heylogin can only be used with physical security keys (e.g. YubiKey)."
msgstr "heylogin kann nur mit physischen Sicherheitsschlüsseln (z.B. YubiKey) verwendet werden."

msgid "heylogin default password policy"
msgstr "heylogin Standard Passwort-Policy"

msgid "heylogin Enterprise (Managed)"
msgstr "heylogin Enterprise (Managed)"

msgid "heylogin Enterprise MSP"
msgstr "heylogin Enterprise MSP"

msgid "heylogin is the first password manager with full hardware-based end-to-end encryption. 2-factor secure by default, developed and hosted in Germany."
msgstr "heylogin ist der erste Passwort-Manager mit hardwarebasierter Ende-zu-Ende-Verschlüsselung. Standardmäßig 2-Faktor-sicher, entwickelt und gehostet in Deutschland."

msgid "heylogin screenshot"
msgstr "Screenshot von heylogin"

msgid "heylogin works best with <0>Chrome, Edge, Firefox or Safari</0>"
msgstr "heylogin funktioniert am besten in <0>Chrome, Edge, Firefox oder Safari</0>"

msgid "heylogin works best with <0>Chrome, Edge, or Firefox</0>"
msgstr "heylogin funktioniert am besten in <0>Chrome, Edge oder Firefox</0>"

msgid "heylogin works best with Chrome, Edge, Firefox or Safari"
msgstr "heylogin funktioniert am besten in Chrome, Edge, Firefox oder Safari"

msgid "heylogin.me"
msgstr "heylogin.me"

msgid "Hide details"
msgstr "Details verbergen"

msgid "Hide instructions"
msgstr "Anleitung ausblenden"

msgid "Hide password"
msgstr "Passwort verbergen"

msgid "Hide passwords for read-only members"
msgstr "Passwörter verbergen für Mitglieder mit Lesezugriff"

msgid "Hint: Write down your backup code and keep it in a safe place."
msgstr "Tipp: Notiere dir deinen Backup-Code und bewahre ihn an einem sicheren Ort auf."

msgid "Historical passwords"
msgstr "Frühere Passwörter"

msgid "HIV statuses"
msgstr "HIV-Status"

msgid "Home ownership statuses"
msgstr "Hausbesitzstatus"

msgid "Homepage URLs"
msgstr "Homepage-URLs"

msgctxt "KeeperImport"
msgid "Host"
msgstr "Host"

msgctxt "KeeperImport"
msgid "Host name"
msgstr "Hostname"

msgid "How did you hear about us?"
msgstr "Wie hast du von uns erfahren?"

msgid "How to update?"
msgstr "Wie kann ich updaten?"

msgid "How to use Autotype"
msgstr "So kannst du Autotype einrichten"

msgid "https://browsehappy.com/?locale=en"
msgstr "https://browsehappy.com/?locale=de_DE"

msgid "https://help.heylogin.com/en"
msgstr "https://help.heylogin.com/de"

#. help center link: on-premise backup
#. help center link: on-premises backup
msgid "https://help.heylogin.com/en/13f8872c7eda8013a6f2fcb7cacceccd"
msgstr "https://help.heylogin.com/de/14b8872c7eda80eba00bc0a355e9bf7e"

#. help center link: secrets api
msgid "https://help.heylogin.com/en/1628872c7eda8085bf0fd79d13b9967b"
msgstr "https://help.heylogin.com/de/1628872c7eda805db950d269ed218292"

#. help center link: update firefox extension
msgid "https://help.heylogin.com/en/2868872c7eda8012b418fd4a5b2f8fc1"
msgstr "https://help.heylogin.com/de/2868872c7eda809e9535e593c0dc20ca"

msgid "https://help.heylogin.com/en/3c18872c7eda80b2aaf5fc20ace4ce71"
msgstr "https://help.heylogin.com/de/3c18872c7eda807b935ddbd831de4f42"

#. help center link: hidden passwords
msgid "https://help.heylogin.com/en/96e629e684bf4d3a89d0d8c47aa78395"
msgstr "https://help.heylogin.com/de/c6e5f4fef9bf4660a977219e8e664f20"

#. help center link: browser support for additional devices
msgid "https://help.heylogin.com/en/e7d73dc2d84c4306ad83129ae969b4d7#21afa0f6639944b893bd47e9565be0b3"
msgstr "https://help.heylogin.com/de/ce898ec247c542d0bc62af6d20f20bd1#a23dab74605947a1845b8f18dbee5cab"

#. help center link: receive passwords from external
msgid "https://help.heylogin.com/en/fb57286bc7f44190b95d16bb9fc2ae17"
msgstr "https://help.heylogin.com/de/f27319fe0db6480b845f12d2bd34db93"

msgid "https://support.apple.com/en-euro/guide/passwords/mchl35b12625/mac#mchlafe418fe"
msgstr "https://support.apple.com/de-de/guide/passwords/mchl35b12625/mac#mchlafe418fe"

msgid "https://support.apple.com/en-us/HT204416"
msgstr "https://support.apple.com/de-de/HT204416"

msgid "https://www.heylogin.com/en/contact-sales"
msgstr "https://www.heylogin.com/de/kontakt-vertrieb"

msgid "https://www.heylogin.com/en/contact-support"
msgstr "https://www.heylogin.com/de/kontakt-support"

msgid "https://www.heylogin.com/en/enterprise"
msgstr "https://www.heylogin.com/de/enterprise"

msgid "https://www.heylogin.com/en/enterprise/"
msgstr "https://www.heylogin.com/de/enterprise/"

msgid "https://www.heylogin.com/en/privacy"
msgstr "https://www.heylogin.com/de/datenschutz"

msgid "https://www.heylogin.com/en/site-notice"
msgstr "https://www.heylogin.com/de/impressum"

msgid "https://www.heylogin.com/en/terms-of-use"
msgstr "https://www.heylogin.com/de/nutzungsbedingungen"

msgid "I am not {username}"
msgstr "Ich bin nicht {username}"

msgid "I can't scan the QR code"
msgstr "Ich kann den QR-Code nicht scannen"

msgid "IBAN"
msgstr "IBAN"

msgid "iCloud Keychain"
msgstr "iCloud-Schlüsselbund"

msgctxt "KeeperImport"
msgid "Identity number"
msgstr "Personalausweisnummer"

msgid "If someone gave you a link to this page, please ask them to check it and send it again."
msgstr "Wenn Sie den Link zu dieser Seite von einer Person erhalten haben, bitten Sie sie, den Link zu überprüfen und Ihnen erneut zu geben."

msgid "If the deletion was not triggered by you or triggered by accident, please contact our <0>support team</0>"
msgstr "Die Löschung wurde nicht von dir oder versehentlich ausgelöst? Dann wende dich bitte an unser <0>Support-Team</0>"

msgid "If this problem persists, please <0>contact support</0>."
msgstr "Wenn das Problem weiterhin besteht, <0>kontaktiere bitte den Support</0>."

msgid "If you have any problems, consult the <0>Excel documentation on CSV export</0> or contact <1>heylogin support</1>"
msgstr "Wenn du Probleme beim Import hast, sieh dir die <0>Excel-Dokumentation zum CSV-Export</0> an oder kontaktiere den <1>heylogin-Support</1>"

msgid "If you have any problems, please consult the <0>Bitwarden export guide</0> or contact <1>heylogin support</1>"
msgstr "Wenn du Probleme beim Import hast, sieh dir den <0>Export-Guide von Bitwarden</0> an oder kontaktiere den <1>heylogin-Support</1>"

msgid "If you have any problems, please consult the <0>Firefox export guide</0> or contact <1>heylogin support</1>"
msgstr "Wenn du Probleme beim Import hast, sieh dir den <0>Export-Guide von Firefox</0> an oder kontaktiere den <1>heylogin-Support</1>"

msgid "If you have any problems, please consult the <0>Nordpass export guide</0> or contact <1>heylogin support</1>"
msgstr "Wenn du Probleme beim Import hast, sieh dir den <0>Export-Guide von Nordpass</0> an oder kontaktiere den <1>heylogin-Support</1>"

msgid "If you have any problems, please contact <0>heylogin support</0>"
msgstr "Wenn du Probleme beim Import hast, kontaktiere den <0>heylogin-Support</0>"

msgid "If you lost access to your secure device, you can use the backup code to add a new device"
msgstr "Falls du keinen Zugriff mehr auf dein verbundenes Gerät hast, kannst du über den Backup-Code ein neues Gerät hinzufügen"

msgid "Image accepted"
msgstr "Bild angenommen"

msgid "Image is not valid"
msgstr "Das Bild ist nicht lesbar"

msgid "Image must be no larger than 500×500 pixels"
msgstr "Bild darf nicht größer als 500×500 Pixel sein"

msgid "Image must be square"
msgstr "Das Bild muss quadratisch sein"

msgid "IMEI numbers"
msgstr "IMEI-Nummern"

msgid "Immediate threat analysis: Targeted measures for at-risk employee accounts."
msgstr "Sofortige Bedrohungsanalyse: Gezielte Maßnahmen für gefährdete Mitarbeiteraccounts."

msgid "Immediately detect at-risk employee accounts"
msgstr "Gefährdete Mitarbeiter-Accounts direkt erkennen"

msgid "Import"
msgstr "Import"

msgctxt "verb"
msgid "Import"
msgstr "Importieren"

msgid "Import details"
msgstr "Import-Details"

msgid "Import from browser"
msgstr "Aus Browser importieren"

msgid "Import from Chrome"
msgstr "Aus Chrome importieren"

msgid "Import from Edge"
msgstr "Aus Edge importieren"

msgid "Import from Firefox"
msgstr "Aus Firefox importieren"

msgid "Import from password manager"
msgstr "Aus Passwortmanager importieren"

msgid "Import from Safari"
msgstr "Aus Safari importieren"

msgid "Import history"
msgstr "Importverlauf"

msgid "Import into"
msgstr "Importieren in"

msgid "Import logins"
msgstr "Logins importieren"

msgid "import now"
msgstr "jetzt importieren"

msgid "Import your employees from a CSV file"
msgstr "Importiere deine Mitarbeiter aus einer CSV-Datei"

msgid "Import your logins"
msgstr "So importierst du deine Logins"

msgid "Important final step"
msgstr "Wichtiger letzter Schritt"

msgid "Imported"
msgstr "Importiert"

msgid "Importer"
msgstr "Importquelle"

msgid "Importer:"
msgstr "Importer:"

msgid "IMSI numbers"
msgstr "IMSI-Nummern"

msgid "In Excel go to “File” > “Save As” and click “Browse”."
msgstr "Gehe in Excel zu „Datei“ > „Speichern unter“ und klicke „Durchsuchen“."

msgid "In organization"
msgstr "In der Organisation"

msgid "In the “Save As” dialog box, under “Save as type”, choose “CSV (Comma delimited)”."
msgstr "Wähle im „Speichern unter“-Dialog im Feld „Dateityp“ die Option „CSV“ aus."

msgid "In the dialog that opens, click <0>“Always allow on every website”</0> again to confirm access."
msgstr "Dann öffnet sich ein Dialog. Wähle darin nochmal <0>„Auf jeder Webseite immer erlauben“</0> aus."

msgid "inactive"
msgstr "inaktiv"

msgid "Inactive"
msgstr "Inaktiv"

msgid "Inactive (30+ days)"
msgstr "Inaktiv (30+ Tage)"

msgid "Included:"
msgstr "Inklusive:"

msgid "including"
msgstr "davon"

msgid "Income levels"
msgstr "Einkommensniveaus"

msgid "Incorrect password and/or key file"
msgstr "Falsches Passwort und/oder Schlüssel-Datei"

msgid "Individual permissions for each user"
msgstr "Individuelle Berechtigungen pro Nutzer"

msgid "Initial entry"
msgstr "Erster Eintrag"

msgid "Innovatech Solutions"
msgstr "Innovatech Solutions"

msgid "Install"
msgstr "Installieren"

msgid "Install browser extension"
msgstr "Browser-Erweiterung installieren"

msgid "Install Firefox"
msgstr "Firefox installieren"

msgid "Install heylogin"
msgstr "heylogin installieren"

msgid "install now"
msgstr "jetzt installieren"

msgid "Install our beta extensions and apps to be the first to test unreleased features."
msgstr "Installiere jetzt unsere Beta-Extensions und Apps, um exklusive, noch nicht veröffentlichte Funktionen als Erster zu testen."

msgid "Instant messenger identities"
msgstr "Instant-Messenger-Identitäten"

msgctxt "KeeperImport"
msgid "Insured's first name"
msgstr "Vorname des Versicherten"

msgctxt "KeeperImport"
msgid "Insured's last name"
msgstr "Nachname des Versicherten"

msgctxt "KeeperImport"
msgid "Insured's middle name"
msgstr "Zweiter Vorname des Versicherten"

msgid "Integrations"
msgstr "Integrationen"

msgid "Integrations: Entra ID, Google Workspace, CSV import"
msgstr "Integrationen: Entra ID, Google Workspace, CSV-Import"

msgid "Invalid"
msgstr "Ungültig"

msgid "Invalid coupon code"
msgstr "Ungültiger Coupon-Code"

msgid "Invalid domain"
msgstr "Ungültige Domain"

msgid "Invalid email"
msgstr "Ungültige E-Mail-Adresse"

msgid "Invalid link"
msgstr "Ungültiger Link"

msgid "Invalid quotes"
msgstr "Ungültige Anführungszeichen"

msgid "Invalid start code"
msgstr "Ungültiger Startcode"

msgid "Invite expired"
msgstr "Einladung abgelaufen"

msgid "Invited"
msgstr "Eingeladen"

msgid "Invoice"
msgstr "Rechnung"

msgid "Invoices"
msgstr "Rechnungen"

msgid "iOS App (Testflight Beta)"
msgstr "iOS-App (Testflight-Beta)"

msgid "IP address"
msgstr "IP-Adresse"

msgid "IP addresses"
msgstr "IP-Adressen"

msgid "Issuing bank"
msgstr "Bank"

msgid "Job applications"
msgstr "Bewerbungen"

msgid "Job titles"
msgstr "Berufsbezeichnungen"

msgid "Join"
msgstr "Beitreten"

msgid "Join organization"
msgstr "Organisation beitreten"

msgid "Joined at: {formattedJoinDate}"
msgstr "Beigetreten am: {formattedJoinDate}"

msgid "Joining failed. Please reload the page to make sure you use the latest version of heylogin and try again."
msgstr "Beitritt fehlgeschlagen. Bitte lade die Seite neu, um sicherzustellen, dass du die aktuelle Version von heylogin verwendest und versuche es nochmal."

msgid "KeePass"
msgstr "KeePass"

msgid "Keeper"
msgstr "Keeper"

msgid "Key file (optional)"
msgstr "Schlüssel-Datei (optional)"

msgctxt "KeeperImport"
msgid "Key pair"
msgstr "Schlüsselpaar"

msgid "Keyboard shortcut:"
msgstr "Tastenkürzel:"

msgid "Known since:"
msgstr "Bekannt seit:"

msgid "Label may not be empty"
msgstr "Label darf nicht leer sein"

msgid "Labels"
msgstr "Labels"

msgid "last"
msgstr "letzten"

msgid "Last 30 days"
msgstr "Letzte 30 Tage"

msgid "Last 7 days"
msgstr "Letzte 7 Tage"

msgid "Last 90 days"
msgstr "Letzte 90 Tage"

msgid "Last active {formattedLastActiveDate}"
msgstr "Zuletzt aktiv {formattedLastActiveDate}"

msgid "Last change"
msgstr "Letzte Änderung"

msgctxt "KeeperImport"
msgid "Last name"
msgstr "Nachname"

msgid "LastPass"
msgstr "LastPass"

msgid "Latest data added:"
msgstr "Neuster Datensatz von:"

msgid "lea@example.com"
msgstr "lea@beispiel.de"

msgid "Leak check result"
msgstr "Leak-Check-Ergebnis"

msgid "Leak check: not ok"
msgstr "Leak-Check: nicht ok"

msgid "Leak check: not performed"
msgstr "Leak-Check: nicht durchgeführt"

msgid "Leak check: ok"
msgstr "Leak-Check: ok"

msgid "Leaked passwords"
msgstr "Passwörter mit Leaks"

msgid "Learn more"
msgstr "Mehr erfahren"

msgid "Learn more about heylogin"
msgstr "Mehr über heylogin erfahren"

msgid "Leave"
msgstr "Verlassen"

msgid "Leave “{profileLabel}”?"
msgstr "„{profileLabel}“ verlassen?"

msgid "Leave beta"
msgstr "Beta verlassen"

msgid "Leave organization"
msgstr "Organisation verlassen"

msgid "Leave team"
msgstr "Team verlassen"

msgid "Leaving…"
msgstr "Team wird verlassen…"

msgid "Length"
msgstr "Länge"

msgctxt "KeeperImport"
msgid "License number"
msgstr "Lizenznummer"

msgid "License plates"
msgstr "Kennzeichen"

msgid "Limit time for automatic device lock after user inactivity"
msgstr "Zeit für automatisches Sperren von Geräten nach Inaktivität begrenzen"

msgid "linda@example.com"
msgstr "linda@beispiel.de"

msgid "Link your employees directly from Google Workspace"
msgstr "Synchronisiere deine Mitarbeiter direkt aus Google Workspace"

msgid "Link your employees directly from Microsoft Entra"
msgstr "Synchronisiere deine Mitarbeiter direkt aus Microsoft Entra"

msgid "Links expired in the last 7 days"
msgstr "Abgelaufene Links der letzten 7 Tage"

msgid "Links used in the last 7 days"
msgstr "Benutzte Links der letzten 7 Tage"

msgid "List personal logins of other users"
msgstr "Persönliche Logins anderer Nutzer auflisten"

msgid "List users from your Entra tenant in heylogin"
msgstr "Auflisten von Nutzern aus deinem Entra-Tenant"

msgid "Living costs"
msgstr "Lebenshaltungskosten"

msgid "Load more"
msgstr "Mehr laden"

msgid "Loading"
msgstr "Wird geladen"

msgid "Loading data"
msgstr "Daten werden erfasst"

msgid "Loading data…"
msgstr "Daten werden geladen…"

msgid "Loading…"
msgstr "Wird geladen…"

msgid "Loan information"
msgstr "Darlehensinformationen"

msgid "Location"
msgstr "Speicherort"

msgid "Log in as another user"
msgstr "Als anderer Nutzer einloggen"

msgid "log in in your browser"
msgstr "im Browser einloggen"

msgid "Log in now"
msgstr "Jetzt einloggen"

msgid "Log in on <0>app.nordpass.com</0>"
msgstr "Logge dich auf <0>app.nordpass.com</0> ein."

msgid "Log in once into a website with username and password."
msgstr "Logge dich einmal mit Benutzernamen und Passwort auf einer Webseite ein."

msgid "Log out"
msgstr "Abmelden"

msgid "Log out this user"
msgstr "Diesen Nutzer ausloggen"

msgid "Login"
msgstr "Login"

msgid "Login created"
msgstr "Login angelegt"

msgid "Login deleted"
msgstr "Login gelöscht"

msgid "Login denied"
msgstr "Login abgelehnt"

msgid "Login device connected"
msgstr "Login-Gerät verbunden"

msgid "Login devices"
msgstr "Login-Geräte"

msgid "Login Devices"
msgstr "Login-Geräte"

msgid "Login edited"
msgstr "Login bearbeitet"

msgid "Login histories"
msgstr "Anmeldeverläufe"

msgid "Login inbox"
msgstr "Login-Posteingang"

msgid "Login Inbox"
msgstr "Login-Posteingang"

msgid "Login inbox enabled"
msgstr "Login-Posteingang aktiv"

msgid "Login information"
msgstr "Login-Informationen"

msgid "Login location"
msgstr "Login-Speicherort"

msgid "Login locations"
msgstr "Login-Speicherorte"

msgid "Login moved"
msgstr "Login verschoben"

msgid "Login moved to recycle bin"
msgstr "Login in Papierkorb verschoben"

msgid "Login recipient"
msgstr "Login-Empfänger"

msgid "Login restored from recycle bin"
msgstr "Login aus dem Papierkorb wiederhergestellt"

msgid "Login scopes"
msgstr "Login-Scopes"

msgid "Login sender"
msgstr "Login-Absender"

msgid "Login successful"
msgstr "Login erfolgreich"

msgid "Logins"
msgstr "Logins"

msgid "Logins are shared to the personal logins of the recipient."
msgstr "Logins werden in den persönlichen Logins des Empfängers angezeigt."

#. placeholder {0}: skippedVaults[0].label
msgid "Logins from “{0}” will be skipped during export because you are not allowed to see passwords."
msgstr "Logins aus „{0}“ werden beim Export übersprungen, da du nicht die Berechtigung hast, Passwörter einzusehen."

msgid "Logins from these locations will be skipped during export because you are not allowed to see passwords:"
msgstr "Logins von den folgenden Orten werden beim Export übersprungen, da du nicht die Berechtigungen hast, Passwörter einzusehen:"

msgid "Logins in all organization teams as well as all accessible logins"
msgstr "Logins in allen Organisations-Teams und alle zugreifbaren Logins"

msgid "Loyalty program details"
msgstr "Details zum Treueprogramm"

msgid "MAC addresses"
msgstr "MAC-Adressen"

msgid "Malformed TOTP secret"
msgstr "Fehlerhafter TOTP-Schlüssel wurde ignoriert"

msgid "Manage all managed organizations"
msgstr "Alle verwalteten Organisationen verwalten"

msgid "Manage plan"
msgstr "Plan ändern"

msgid "Manage users"
msgstr "Nutzer verwalten"

msgid "Managed organizations"
msgstr "Verwaltete Organisationen"

msgid "Managed Organizations"
msgstr "Verwaltete Organisationen"

msgid "Management"
msgstr "Management"

msgctxt "Storybook"
msgid "marie@example.com"
msgstr "marie@beispiel.de"

msgid "Marital statuses"
msgstr "Familienstand"

msgid "Maximize"
msgstr "Maximieren"

msgid "Members of the managing organization that access this organization get this role. It cannot be manually assigned."
msgstr "Mitglieder der verwaltenden Organisation, die auf diese Organisation zugreifen, erhalten diese Rolle. Sie kann nicht manuell zugewiesen werden."

msgid "Message"
msgstr "Nachricht"

msgid "Message (optional)"
msgstr "Nachricht (optional)"

msgid "Message may not be empty!"
msgstr "Nachricht darf nicht leer sein!"

msgid "Microsoft Edge"
msgstr "Microsoft Edge"

msgid "Microsoft Entra"
msgstr "Microsoft Entra"

msgctxt "KeeperImport"
msgid "Middle name"
msgstr "Zweiter Vorname"

msgid "Military service"
msgstr "Militärdienst"

msgid "Minimize"
msgstr "Minimieren"

msgid "Missing age recipient"
msgstr "Kein Age-Empfänger angegeben"

msgid "Missing quotes"
msgstr "Fehlende Anführungszeichen"

msgid "Mnemonic phrases"
msgstr "Mnemotechnische Sätze"

msgid "Monitored Domains"
msgstr "Überwachte Domains"

msgid "Monitoring"
msgstr "Überwachung"

msgid "Monthly"
msgstr "Monatlich"

msgid "More options"
msgstr "Weitere Optionen"

msgid "More security – access only for those who really need it (the principle of least privilege)"
msgstr "Mehr Sicherheit – Zugriff nur für die, die ihn wirklich brauchen (Least-Privilege-Prinzip)"

msgid "More transparency for your logins"
msgstr "Mehr Transparenz für deine Logins"

msgid "Mothers' maiden names"
msgstr "Geburtsnamen der Mutter"

msgid "Move"
msgstr "Verschieben"

msgid "Move logins from team “{truncatedName}” to “{moveOnDeleteTargetName}”."
msgstr "Logins aus dem Team „{truncatedName}“ in „{moveOnDeleteTargetName}“ verschieben"

msgid "Move logins from the login inbox to “{moveOnDeleteTargetName}”."
msgstr "Logins aus dem Posteingang in „{moveOnDeleteTargetName}“ verschieben"

msgid "Move logins to"
msgstr "Logins verschieben nach"

msgid "Mozilla Firefox"
msgstr "Mozilla Firefox"

msgctxt "KeeperImport"
msgid "Multiline"
msgstr "Mehrzeilig"

msgid "Multiple roles"
msgstr "Mehrere Rollen"

msgid "Must be a square image no larger than 500×500 pixels"
msgstr "Muss ein quadratisches Bild sein, das nicht größer als 500×500 Pixel ist"

msgid "Must contain a digit"
msgstr "Muss eine Ziffer enthalten"

msgid "Must contain a lower case letter"
msgstr "Muss einen Kleinbuchstaben enthalten"

msgid "Must contain a special character"
msgstr "Muss ein Sonderzeichen enthalten"

msgid "Must contain an upper case letter"
msgstr "Muss einen Großbuchstaben enthalten"

msgid "My Logins"
msgstr "Meine Logins"

msgid "Name"
msgstr "Name"

msgctxt "KeeperImport"
msgid "Name"
msgstr "Name"

msgid "Name may not be empty!"
msgstr "Name darf nicht leer sein!"

msgid "Names"
msgstr "Namen"

msgid "Nationalities"
msgstr "Nationalitäten"

msgid "Navigate to the Proton Pass settings page."
msgstr "Öffne die Einstellungen in Proton Pass."

msgid "Net worths"
msgstr "Vermögen"

msgid "New accounts / invites"
msgstr "Neue Accounts / Einladungen"

msgid "New accounts will be created"
msgstr "Neue Accounts werden erstellt"

msgid "New beta feature"
msgstr "Neues Beta-Feature"

msgid "New email address"
msgstr "Neue E-Mail-Adresse"

msgid "New entry"
msgstr "Neuer Eintrag"

msgid "New feature"
msgstr "Neues Feature"

msgid "New label"
msgstr "Neues Label"

msgid "New Organization"
msgstr "Neue Organisation"

msgid "New organization created."
msgstr "Neue Organisation erstellt."

msgid "New role created."
msgstr "Neue Rolle erstellt."

msgid "New Support Request"
msgstr "Neue Support-Anfrage"

msgid "New Team"
msgstr "Neues Team"

msgid "New team created."
msgstr "Neues Team erstellt."

msgid "Newly joined"
msgstr "Neu hinzugefügt"

msgid "next"
msgstr "nächsten"

msgid "Next"
msgstr "Vor"

msgid "Next billing at"
msgstr "Nächste Abrechnung"

msgid "Nicknames"
msgstr "Spitznamen"

msgid "No access?"
msgstr "Keinen Zugriff mehr?"

msgid "No accessible organizations match this filter"
msgstr "Keine zugreifbare Organisation für diesen Filter gefunden"

msgid "No account"
msgstr "Kein Account"

msgid "No activity for more than {INACTIVITY_THRESHOLD_DAYS} days"
msgstr "Über {INACTIVITY_THRESHOLD_DAYS} Tage keine Aktivität"

msgid "No change"
msgstr "Keine Änderung"

msgid "No changes to synced users."
msgstr "Keine Änderungen an synchronisierten Nutzern."

msgid "No connection to <0>{integrationName}</0> could be established. Please try again or contact <1>support</1>."
msgstr "Es konnte keine Verbindung zu <0>{integrationName}</0> hergestellt werden. Versuche es erneut oder wende dich direkt an unseren <1>Support</1>."

msgid "No deleted entries found"
msgstr "Keine gelöschten Einträge gefunden"

msgid "No events matching this filter"
msgstr "Keine Ereignisse für diesen Filter gefunden"

msgid "No export source found"
msgstr "Keine Export-Quelle gefunden"

msgid "No groups found"
msgstr "Keine Gruppen gefunden"

msgid "No groups synchronized"
msgstr "Keine Gruppen synchronisiert"

msgid "No import target found"
msgstr "Kein Import-Ziel gefunden"

msgid "No keyboard shortcut set."
msgstr "Kein Tastenkürzel gesetzt."

msgid "No login inbox found"
msgstr "Kein Login-Posteingang gefunden"

msgid "no logins"
msgstr "keine Logins"

msgid "No logins found"
msgstr "Keine Logins gefunden"

msgid "No matching options"
msgstr "Keine Option gefunden"

msgid "No member"
msgstr "Kein Mitglied"

msgid "No move target found"
msgstr "Kein Ziel zum Verschieben verfügbar"

msgid "No organization exists for this email address. Please contact your admin, or use the heylogin app to register a new organization or private account."
msgstr "Für diese E-Mail-Adresse gibt es keine Organisation. Kontaktiere deinen Admin oder nutze die heylogin-App, um eine Organisation oder einen privaten Account zu erstellen."

msgid "No organizations match this filter"
msgstr "Keine Organisationen für diesen Filter gefunden"

msgid "No permission"
msgstr "Keine Berechtigung"

msgid "No permission for this page"
msgstr "Keine Berechtigung für diese Seite"

msgid "No role"
msgstr "Keine Rolle"

msgid "No target found"
msgstr "Kein Ziel gefunden"

msgid "No user found"
msgstr "Kein Nutzer gefunden"

msgid "Non-admins may export {exportSettingsSelect} from this organization."
msgstr "Nicht-Admins dürfen {exportSettingsSelect} aus dieser Organisation exportieren."

msgid "None"
msgstr "Keine"

msgid "Nordpass"
msgstr "Nordpass"

msgid "Not a login"
msgstr "Kein Login"

msgid "Not available on this device"
msgstr "Nicht verfügbar auf diesem Gerät"

msgid "Not connected"
msgstr "Nicht verbunden"

msgid "Not ok"
msgstr "Nicht ok"

msgid "Not performed"
msgstr "Nicht durchgeführt"

msgid "Not policy compliant"
msgstr "Nicht Policy-konform"

msgid "Not supported"
msgstr "Nicht unterstützt"

msgid "Not supported on this device"
msgstr "Nicht unterstützt auf diesem Gerät"

msgid "Note"
msgstr "Notiz"

msgctxt "KeeperImport"
msgid "Note"
msgstr "Notiz"

msgid "Note: This integration must be set up by an Entra user with privileges to list users and groups in your tenant."
msgstr "Hinweis: Die Integration muss von einem Entra-Nutzer eingerichtet werden, welcher die Nutzer und Gruppen des Tenants auflisten darf."

msgid "Notification when leaked accounts are found on the web"
msgstr "Benachrichtigung beim Auffinden geleakter Accounts im Web"

msgctxt "KeeperImport"
msgid "Number"
msgstr "Nummer"

msgid "Number of additional licenses"
msgstr "Anzahl zusätzlicher Lizenzen"

msgid "Number of licenses"
msgstr "Lizenz-Anzahl"

msgid "Number of licenses must be a number"
msgstr "Anzahl der Lizenzen muss eine Zahl sein"

#. placeholder {0}: organization.userCount
msgid "Number of licenses must be at least {0}"
msgstr "Lizenz-Anzahl muss mindestens {0} betragen"

msgid "Number of licenses must be greater than zero"
msgstr "Anzahl der Lizenzen muss größer als Null sein"

#. placeholder {0}: license.licenseCount
msgid "Number of licenses: <0>{0}</0>"
msgstr "Lizenz-Anzahl: <0>{0}</0>"

msgid "Number of users"
msgstr "Anzahl der Nutzer"

msgid "Occupations"
msgstr "Berufe"

msgid "Ok"
msgstr "Ok"

msgid "OK"
msgstr "OK"

msgid "Okay"
msgstr "Okay"

msgid "Okay, got it"
msgstr "Okay, verstanden"

msgid "On all stored webpages"
msgstr "Auf allen gespeicherten Webseiten"

msgid "On request"
msgstr "Auf Anfrage"

msgid "on your laptop or PC for all websites"
msgstr "auf dem Laptop oder PC für alle Webseiten"

msgid "On-premises backup (optional)"
msgstr "On-Premises-Backup (optional)"

msgid "Onboarding support (optional)"
msgstr "Onboarding-Betreuung (optional)"

msgid "Only {recipientName} can read this login."
msgstr "Nur {recipientName} kann dieses Login lesen."

msgid "Only organization admins may create teams"
msgstr "Nur Organisations-Admins dürfen Teams anlegen"

msgid "Only users from selected groups will be loaded from Entra."
msgstr "Nur Nutzer in ausgewählten Gruppen werden aus Entra übertragen."

msgid "Open"
msgstr "Öffnen"

#. placeholder {0}: personalLoginsInfo.email
msgid "Open {0}'s logins"
msgstr "Logins von {0} öffnen"

msgid "Open <0>{securityKeyUri}</0> in a desktop browser"
msgstr "<0>{securityKeyUri}</0> im Desktop-Browser öffnen"

msgid "Open CSV Importer"
msgstr "CSV-Import öffnen"

msgid "Open heylogin.app"
msgstr "heylogin.app öffnen"

msgid "Open login inbox"
msgstr "Login-Posteingang öffnen"

msgid "Open management"
msgstr "Management öffnen"

#. placeholder {0}: organization.name
msgid "Open organization {0}"
msgstr "Organisation {0} öffnen"

msgid "Open settings"
msgstr "Einstellungen öffnen"

msgid "Open update instructions"
msgstr "Update-Anleitung öffnen"

msgid "Opened at {formattedOpenTime}"
msgstr "Geöffnet am {formattedOpenTime}"

msgid "Opera"
msgstr "Opera"

msgid "Order Number"
msgstr "Rechnungsnummer"

msgid "Organization"
msgstr "Organisation"

msgid "Organization already deleted"
msgstr "Organisation bereits gelöscht"

msgid "Organization deleted"
msgstr "Organisation gelöscht"

msgid "Organization domain (optional)"
msgstr "Organisations-Domain (optional)"

msgid "Organization name"
msgstr "Name der Organisation"

msgid "Organization name may not be empty!"
msgstr "Name der Organisation darf nicht leer sein!"

msgid "Organization role"
msgstr "Organisations-Rolle"

msgid "Organization settings"
msgstr "Organisations-Einstellungen"

msgid "Organization:"
msgstr "Organisation:"

msgid "Origin"
msgstr "Herkunft"

msgid "Origins"
msgstr "Herkunft"

msgctxt "KeeperImport"
msgid "Other type"
msgstr "Anderer Typ"

msgid "Page not found"
msgstr "Seite nicht gefunden"

msgid "Parenting plans"
msgstr "Erziehungspläne"

msgid "Partial credit card data"
msgstr "Teilweise Kreditkartendaten"

msgid "Partial dates of birth"
msgstr "Teilweise Geburtsdaten"

msgid "Partial phone numbers"
msgstr "Teilweise Telefonnummern"

msgid "Passkey"
msgstr "Passkey"

msgid "Passkeys"
msgstr "Passkeys"

msgctxt "KeeperImport"
msgid "Passport number"
msgstr "Reisepassnummer"

msgid "Passport numbers"
msgstr "Passnummern"

msgid "Password"
msgstr "Passwort"

msgid "Password copied"
msgstr "Passwort kopiert"

msgid "Password hints"
msgstr "Passworthinweise"

msgid "Password inserted"
msgstr "Passwort eingefügt"

msgid "Password is empty"
msgstr "Passwort ist leer"

msgid "Password is not compliant with the password policy."
msgstr "Passwort ist nicht Policy-konform"

msgid "Password is PIN"
msgstr "Passwort ist PIN"

msgid "Password manager without a Master Password"
msgstr "Der Passwort-Manager ohne Master-Passwort"

msgid "Password policy"
msgstr "Passwort-Policy"

msgid "Password policy active"
msgstr "Passwort-Policy aktiv"

msgid "Password policy check result"
msgstr "Passwort-Policy-Ergebnis"

msgid "Password policy: check not performed"
msgstr "Passwort-Policy: Überprüfung nicht durchgeführt"

msgid "Password policy: not ok"
msgstr "Passwort-Policy: nicht ok"

msgid "Password policy: ok"
msgstr "Passwort-Policy: ok"

msgid "Password security unknown"
msgstr "Passwortsicherheit unbekannt"

msgid "Password shown"
msgstr "Passwort angezeigt"

msgid "Password strength"
msgstr "Passwortstärke"

msgid "Password strengths"
msgstr "Passwortstärken"

msgid "Password was found in a list of leaked passwords."
msgstr "Passwort wurde auf einer Liste von geleakten Passwörtern gefunden."

msgid "Passwords"
msgstr "Passwörter"

msgid "Passwords cannot be viewed"
msgstr "Passwörter können nicht eingesehen werden"

msgid "paul@example.com"
msgstr "paul@beispiel.de"

msgid "Paused"
msgstr "Pausiert"

#. placeholder {0}: format(new Date(subscriptionStatus.pausedAt), 'P', { locale: getDateFnsLocale(), })
msgid "Paused at {0}"
msgstr "Pausiert am {0}"

msgid "Payment"
msgstr "Zahlung"

msgctxt "KeeperImport"
msgid "Payment card"
msgstr "Zahlungskarte"

msgid "Payment histories"
msgstr "Zahlungshistorien"

msgid "Payment methods"
msgstr "Zahlungsmethoden"

msgid "Payment overdue"
msgstr "Unbezahlte Rechnungen"

msgid "Payment pending"
msgstr "Zahlung offen"

msgid "Perhaps you clicked on an old link, or opened an outdated bookmark?"
msgstr "Möglicherweise hast du einen nicht mehr gültigen Link angeklickt oder ein altes Lesezeichen geöffnet?"

msgid "Permanently delete"
msgstr "Endgültig löschen"

msgid "Permissions"
msgstr "Berechtigungen"

msgid "Permissions for this user are set automatically"
msgstr "Berechtigungen für diesen Nutzer werden automatisch konfiguriert"

msgid "Personal descriptions"
msgstr "Persönliche Beschreibungen"

msgid "Personal health data"
msgstr "Persönliche Gesundheitsdaten"

msgid "Personal interests"
msgstr "Persönliche Interessen"

msgid "Personal login"
msgstr "Persönliches Login"

msgid "Personal logins"
msgstr "Persönliche Logins"

msgid "Personal Logins"
msgstr "Persönliche Logins"

msgid "Personal logins and teams"
msgstr "Persönliche Logins und Teams"

msgid "Personal logins and teams the user is joined in"
msgstr "Persönliche Logins und Teams, in denen der Nutzer Mitglied ist"

msgid "Phone"
msgstr "Handy"

msgctxt "KeeperImport"
msgid "Phone"
msgstr "Telefonnummer"

msgid "Phone connected"
msgstr "Handy verbunden"

msgid "Phone numbers"
msgstr "Telefonnummern"

msgid "Photos"
msgstr "Fotos"

msgid "Physical addresses"
msgstr "Physische Adressen"

msgid "Physical attributes"
msgstr "Physische Merkmale"

msgid "PIN"
msgstr "PIN"

msgctxt "KeeperImport"
msgid "PIN code"
msgstr "PIN-Code"

msgid "PIN copied"
msgstr "PIN kopiert"

msgid "PIN inserted"
msgstr "PIN eingefügt"

msgid "PIN shown"
msgstr "PIN angezeigt"

msgid "PINs"
msgstr "PINs"

msgid "Places of birth"
msgstr "Geburtsorte"

msgid "Plan"
msgstr "Plan"

msgid "Plan paused"
msgstr "Plan pausiert"

msgid "Please <0>contact support</0> if you want to delete your organization but have no access to heylogin."
msgstr "Bitte <0>kontaktiere den Support</0>, wenn du deine Organisation löschen möchtest, aber keinen Zugang zu heylogin mehr hast."

msgid "Please <0>contact support</0>."
msgstr "Bitte <0>kontaktiere den Support</0>."

msgid "Please <0>create an account</0> first to file support requests."
msgstr "Bitte <0>erstelle erst einen Account</0>, um den Support zu kontaktieren."

msgid "Please check your <0>integration settings</0>."
msgstr "Bitte überprüfe die <0>Integrations-Einstellungen</0>."

#. placeholder {0}: deletionInfo.organizationName
msgid "Please confirm the deletion by typing “<0>{0}</0>” in the field below. Please note that this action cannot be undone."
msgstr "Bitte bestätige die Löschung, indem du „<0>{0}</0>“ in das Feld eingibst. Bitte beachte, dass dieser Vorgang nicht rückgängig gemacht werden kann."

msgid "Please enter a name"
msgstr "Bitte gib einen Namen ein"

msgid "Please enter a password or select a key file"
msgstr "Bitte gibt ein Passwort ein oder wähle eine Schlüssel-Datei aus"

msgid "Please grant heylogin access to use Swipe to Login."
msgstr "Bitte gib heylogin die nötigen Rechte, um Swipe to Login zu nutzen."

msgid "Please install a supported browser to use the autotype feature."
msgstr "Bitte installiere einen unterstützten Browser, um das Autotype-Feature zu benutzen."

msgid "Please install a supported browser to use the quick access feature."
msgstr "Bitte installiere einen unterstützten Browser, um das Schnellzugriffs-Feature zu benutzen."

msgid "Please install the heylogin extension to use this feature."
msgstr "Bitte installiere die heylogin-Browser-Erweiterung, um dieses Feature zu benutzen."

msgid "Please make sure all managed organizations are assigned another delegated admin."
msgstr "Bitte stelle sicher, dass alle verwalteten Organisationen einen weiteren delegierten Admin haben."

msgid "Please note: This integration only works with Google accounts that belong to a Google Workspace."
msgstr "Hinweis: Die Integration funktioniert nur mit Google-Accounts, die zu einem Google Workspace gehören."

msgid "Please select a file"
msgstr "Bitte wähle eine Datei aus"

msgid "Please update your browser"
msgstr "Bitte aktualisiere deinen Browser"

msgid "Please update your heylogin browser extension to use this feature."
msgstr "Aktualisiere deine Browser-Erweiterung, um dieses Feature zu verwenden."

msgid "Political donations"
msgstr "Politische Spenden"

msgid "Political views"
msgstr "Politische Ansichten"

msgctxt "KeeperImport"
msgid "Port"
msgstr "Port"

msgid "Predefined roles"
msgstr "Vordefinierte Rollen"

msgid "Press the keyboard shortcut in the desktop app to fill in the login."
msgstr "Drücke das Tastenkürzel oben in der gewünschten Desktop-App, um den Login einzufüllen."

msgid "Preview"
msgstr "Vorschau"

msgid "Previous"
msgstr "Zurück"

msgid "Price"
msgstr "Preis"

msgid "Privacy policy"
msgstr "Datenschutzerklärung"

msgid "Privacy Policy"
msgstr "Datenschutzerklärung"

msgid "Private"
msgstr "Privat"

msgid "Private account"
msgstr "Privater Account"

msgid "Private Account"
msgstr "Privater Account"

msgctxt "KeeperImport"
msgid "Private key"
msgstr "Private Key"

msgid "Private messages"
msgstr "Private Nachrichten"

msgid "Professional skills"
msgstr "Berufliche Fähigkeiten"

msgid "Profile photos"
msgstr "Profilfotos"

msgid "Promote a second admin"
msgstr "Bestimme einen zweiten Admin"

msgid "promote to admin"
msgstr "zum Admin bestimmen"

msgid "Properties"
msgstr "Eigenschaften"

msgid "Protected by a swipe on your smartphone"
msgstr "Geschützt durch einen Swipe auf deinem Handy"

msgid "Protected by your security key"
msgstr "Geschützt durch deinen Sicherheitsschlüssel"

msgid "Proton Pass"
msgstr "Proton Pass"

msgctxt "KeeperImport"
msgid "Public key"
msgstr "Public Key"

msgid "Purchases"
msgstr "Käufe"

msgid "Purchasing habits"
msgstr "Kaufgewohnheiten"

msgid "Pwnitoring"
msgstr "Pwnitoring"

msgid "Pwnitoring for company domains"
msgstr "Pwnitoring für alle Firmen-Domains"

msgid "Pwnitoring is currently not available. Please try again later."
msgstr "Pwnitoring ist aktuell nicht verfügbar. Versuche es später erneut."

msgctxt "KeeperImport"
msgid "Question"
msgstr "Frage"

msgid "Quick Access"
msgstr "Schnellzugriff"

msgid "Quick access window screenshot"
msgstr "Screenshot vom Schnellzugriffs-Fenster"

msgid "Races"
msgstr "Rassen"

msgid "Rate now"
msgstr "Jetzt bewerten"

msgid "Rate us in the Chrome Web Store"
msgstr "Bewerte uns im Chrome Web Store"

msgid "Rate us in the Mac App Store"
msgstr "Bewerte uns im Mac App Store"

msgid "Rate us in the Microsoft Store"
msgstr "Bewerte uns im Microsoft Store"

msgid "Rate us on addons.mozilla.org"
msgstr "Bewerte uns auf addons.mozilla.org"

msgctxt "Read [access]"
msgid "Read"
msgstr "Lesezugriff"

msgid "Read access"
msgstr "Lesezugriff"

msgid "Read access (Password hidden)"
msgstr "Lesezugriff (Passwort verborgen)"

msgid "Really change your role?"
msgstr "Deine Rolle wirklich ändern?"

msgid "Really delete login?"
msgstr "Login wirklich löschen?"

msgid "Really delete organization?"
msgstr "Organisation wirklich löschen?"

msgid "Really delete team?"
msgstr "Team wirklich löschen?"

msgid "Really delete your login inbox?"
msgstr "Login-Posteingang wirklich löschen?"

msgid "Really leave beta?"
msgstr "Beta wirklich verlassen?"

msgid "Really leave team?"
msgstr "Team wirklich verlassen?"

msgid "Really remove shared login?"
msgstr "Geteiltes Login wirklich entfernen?"

msgid "Really remove your own permissions?"
msgstr "Eigene Rechte wirklich entfernen?"

msgid "Recipient should start with “age1”. Please use age-keygen to create a recipient."
msgstr "Der Age-Empfänger sollte mit „age1“ anfangen. Bitte verwende age-keygen, um einen Age-Empfänger zu erstellen."

msgid "Reconnect"
msgstr "Neu verbinden"

msgid "Recovery email addresses"
msgstr "Wiederherstellungs-E-Mail-Adressen"

msgid "Recycle bin"
msgstr "Papierkorb"

msgid "Redeem for"
msgstr "Einlösen für"

msgid "Redeem your coupon"
msgstr "Coupon einlösen"

msgid "Regenerate all vaults"
msgstr "Alle Vaults regenerieren"

msgctxt "KeeperImport"
msgid "Region"
msgstr "Region"

msgid "Registration failed. Please reload the page to make sure you use the latest version of heylogin and try again"
msgstr "Registrierung fehlgeschlagen. Bitte lade die Seite neu, um sicherzustellen, dass du die aktuelle Version von heylogin verwendest und versuche es nochmal"

msgid "Registration with heylogin"
msgstr "Registrierung mit heylogin"

msgid "Relationship statuses"
msgstr "Beziehungsstatus"

msgid "Religions"
msgstr "Religionen"

msgid "Remove"
msgstr "Entfernen"

#. placeholder {0}: manager.email
msgid "Remove {0}?"
msgstr "{0} entfernen?"

msgid "Remove filter"
msgstr "Filter entfernen"

msgid "Remove from team"
msgstr "Aus Team entfernen"

msgid "Remove group"
msgstr "Gruppe entfernen"

msgid "Remove icon"
msgstr "Icon entfernen"

msgid "Remove managed organizations first"
msgstr "Entferne zuerst verwaltete Organisationen"

msgid "Remove permissions"
msgstr "Rechte entfernen"

msgid "Removing…"
msgstr "Wird entfernt…"

msgid "Rename label"
msgstr "Label umbenennen"

msgid "Request denied"
msgstr "Anfrage abgelehnt"

msgid "Request failed"
msgstr "Anfrage fehlgeschlagen"

msgid "Request PIN from phone"
msgstr "PIN von Handy anfordern"

msgid "Required characters"
msgstr "Benötigte Zeichen"

msgid "Resend email invites"
msgstr "E-Mail-Einladungen erneut schicken"

msgid "Resend verification email"
msgstr "Bestätigung erneut schicken"

msgid "Resending…"
msgstr "Wird erneut geschickt…"

msgid "Reset"
msgstr "Zurücksetzen"

msgid "Reset to default"
msgstr "Auf Standard zurücksetzen"

msgid "Responsible organization"
msgstr "Verantwortliche Organisation"

msgid "Restore"
msgstr "Wiederherstellen"

msgid "Retry"
msgstr "Nochmal versuchen"

msgid "Revoking…"
msgstr "Wird widerrufen…"

msgid "Reward program balances"
msgstr "Prämienprogramm-Salden"

msgid "Role"
msgstr "Rolle"

msgid "Role editor"
msgstr "Rollen-Editor"

msgid "Role for new users"
msgstr "Rolle für neue Nutzer"

msgid "Role name"
msgstr "Rollen-Name"

msgid "Roles"
msgstr "Rollen"

msgctxt "KeeperImport"
msgid "Routing number"
msgstr "Bankleitzahl"

msgid "Safari"
msgstr "Safari"

msgid "Safari 14 is required for <0>Swipe to Login</0>"
msgstr "Für <0>Swipe to Login</0> brauchst du Safari 14"

msgid "Safari 14 is required for Swipe to Login"
msgstr "Für Swipe to Login brauchst du Safari 14"

msgctxt "Storybook"
msgid "Sales"
msgstr "Sales"

msgid "Salutations"
msgstr "Anreden"

msgid "Save"
msgstr "Speichern"

msgid "Save and move"
msgstr "Speichern und verschieben"

msgid "Save and then move?"
msgstr "Speichern und dann verschieben?"

msgid "Save changes"
msgstr "Änderungen speichern"

msgid "Save the file by clicking “Save” and then “OK”."
msgstr "Speichere die Datei durch Klicken auf „Speichern“ und dann „OK“."

msgid "Saving"
msgstr "Wird gespeichert"

msgid "Scan this QR code"
msgstr "Scanne den QR-Code"

msgid "School grades (class levels)"
msgstr "Schulnoten (Klassenstufen)"

msgid "Scroll to selection"
msgstr "Zur Auswahl scrollen"

msgid "Search"
msgstr "Suchen"

msgid "Search accounts"
msgstr "Accounts durchsuchen"

msgid "Search apps/platforms"
msgstr "Apps/Plattformen durchsuchen"

msgid "Search entries"
msgstr "Einträge suchen"

msgid "Search events"
msgstr "Ereignisse suchen"

msgid "Search groups"
msgstr "Gruppen durchsuchen"

msgid "Search in all logins"
msgstr "Alle Logins durchsuchen"

msgid "Search organizations"
msgstr "Organisationen suchen"

msgid "Search user"
msgstr "Nutzer suchen"

msgid "Search users"
msgstr "Nutzer suchen"

#. placeholder {0}: breachData.totalBreachCount
msgid "Searched accounts: <0>{localizedTotalPwnCountBillions} bn ({0} breaches)</0>"
msgstr "Durchsuchte Accounts: <0>{localizedTotalPwnCountBillions} Mrd. ({0} Vorfälle)</0>"

msgid "Searching device"
msgstr "Gerät wird gesucht"

msgid "Searching for “{searchString}”"
msgstr "Suche nach „{searchString}“"

msgctxt "KeeperImport"
msgid "Secret"
msgstr "Geheimnis"

msgid "Secrets API"
msgstr "Secrets API"

msgid "Secure note information"
msgstr "Notiz-Informationen"

msgid "Security"
msgstr "Sicherheit"

msgid "Security code copied"
msgstr "Sicherheitscode kopiert"

msgid "Security code inserted"
msgstr "Sicherheitscode eingefügt"

msgid "Security code shown"
msgstr "Sicherheitscode angezeigt"

msgid "Security key"
msgstr "Sicherheitsschlüssel"

msgid "Security Key"
msgstr "Sicherheitsschlüssel"

#. placeholder {0}: status.name
msgid "Security key ({0})"
msgstr "Sicherheitsschlüssel ({0})"

msgid "Security key connected"
msgstr "Sicherheitsschlüssel verbunden"

msgid "Security key operation canceled."
msgstr "Sicherheitsschlüssel-Operation abgebrochen."

msgctxt "KeeperImport"
msgid "Security question"
msgstr "Sicherheitsfrage"

msgid "Security questions and answers"
msgstr "Sicherheitsfragen und -antworten"

msgid "Select “.json” as file format (not “.json (Encrypted)”)."
msgstr "Wähle „.json“ als Dateiformat (nicht „.json (Verschlüsselt)“)."

msgid "Select “.json” as file format, and save the file."
msgstr "Wähle „.json“ als Dateiformat und speichere die Datei."

msgid "Select “Autofill” on the left side."
msgstr "Wähle den Punkt „Automatisches Ausfüllen“ auf der linken Seite."

msgid "Select “Export Logins...”."
msgstr "Wähle „Zugangsdaten exportieren...“ aus."

msgid "Select “Export Vault”."
msgstr "Wähle „Tresor exportieren“ aus."

msgid "Select “Export”."
msgstr "Wähle „Export“ aus."

msgid "Select “File”, then “Export”."
msgstr "Wähle „Datei“ aus, dann „Export“."

msgid "Select “KeePass KDBX (2.x)”."
msgstr "Wähle „KeePass KDBX (2.x)“ aus."

msgid "Select “Passwords”."
msgstr "Wähle den Punkt „Passwörter“ aus."

msgctxt "EdgeImportGuide"
msgid "Select “Passwords”."
msgstr "Wähle den Punkt „Kennwörter“ aus."

msgid "Select “Settings”."
msgstr "Wähle den Punkt „Einstellungen“ aus."

msgctxt "NordpassImportGuide"
msgid "Select “Settings”."
msgstr "Wähle „Einstellungen“ („Settings“) aus."

msgid "Select a CSV file"
msgstr "Wähle eine CSV-Datei aus"

msgid "Select a managing organization"
msgstr "Wähle eine verwaltende Organisation"

msgid "Select a role"
msgstr "Wähle eine Rolle"

msgid "Select a target"
msgstr "Wähle ein Ziel"

msgid "Select a target to move logins"
msgstr "Wähle ein Ziel aus, um Logins zu verschieben"

msgid "Select a user"
msgstr "Nutzer auswählen"

msgid "Select a user to transfer to"
msgstr "Wähle einen Nutzer zur Übertragung aus"

msgid "Select all"
msgstr "Alle auswählen"

msgid "Select an image file"
msgstr "Wähle eine Bilddatei aus"

msgid "Select at least one group"
msgstr "Wähle mindestens eine Gruppe"

msgid "Select the tab “Export”."
msgstr "Öffne den Reiter „Export“."

msgid "Select users by status"
msgstr "Nutzer nach Status auswählen"

msgid "Select ZIP as the file format."
msgstr "Wähle ZIP als das Dateiformat."

msgid "Send again"
msgstr "Erneut übermitteln"

msgid "Send email invites"
msgstr "E-Mail-Einladungen schicken"

msgid "Send feedback"
msgstr "Feedback senden"

msgid "Send invite email"
msgstr "Einladungs-Mail schicken"

msgid "Send request"
msgstr "Anfrage senden"

msgid "Sender"
msgstr "Absender"

msgid "Sending request"
msgstr "Anfrage wird gesendet"

msgid "Sending…"
msgstr "Wird gesendet…"

msgid "Service"
msgstr "Service"

msgid "Service application connected"
msgstr "Service-App verbunden"

msgid "Service User"
msgstr "Service-Nutzer"

msgid "Service User ID"
msgstr "Service-Nutzer-ID"

msgid "Set up"
msgstr "Einrichten"

msgid "Set up backup code"
msgstr "Backup-Code einrichten"

msgid "Set up Microsoft Entra ({stepIndex}/3)"
msgstr "Microsoft Entra einrichten ({stepIndex}/3)"

msgid "Set up password policy"
msgstr "Passwort-Policy einrichten"

msgid "Set up security key"
msgstr "Sicherheitsschlüssel einrichten"

msgid "Set up security key?"
msgstr "Sicherheitsschlüssel einrichten?"

msgid "Set up Touch ID"
msgstr "Touch ID einrichten"

msgid "Set up Touch ID?"
msgstr "Touch ID einrichten?"

msgid "Set up Windows Hello"
msgstr "Windows Hello einrichten"

msgid "Set up Windows Hello?"
msgstr "Windows Hello einrichten?"

msgid "Set up your account"
msgstr "Account einrichten"

msgid "Set up your security key"
msgstr "Richte deinen Sicherheitsschlüssel ein"

msgid "Set:"
msgstr "Gesetzt:"

msgid "Settings"
msgstr "Einstellungen"

msgid "Setup failed in this browser. Please use Chrome to set up your security key. It will work in this browser afterwards"
msgstr "Einrichtung in diesem Browser fehlgeschlagen. Bitte benutze Chrome, um deinen Sicherheitsschlüssel einzurichten. Nach der Einrichtung funktioniert er auch in diesem Browser."

msgid "Sexual fetishes"
msgstr "Sexuelle Fetische"

msgid "Sexual orientations"
msgstr "Sexuelle Orientierungen"

msgid "Share link created"
msgstr "Geteilter Link erstellt"

msgid "Share login"
msgstr "Login teilen"

msgid "Share logins with a simple, end-to-end encrypted API."
msgstr "Teile Logins mit einer einfachen, Ende-zu-Ende-verschlüsselten API."

msgid "Shared by me"
msgstr "Von mir geteilt"

msgid "Shared secret created"
msgstr "Geteiltes Secret erstellt"

msgid "Shared with {profiles, plural, one {# user} other {# users}} and {vaults, plural, one {# team} other {# teams}}."
msgstr "Geteilt mit {profiles, plural, one {# Nutzer} other {# Nutzern}} und {vaults, plural, one {# Team} other {# Teams}}."

msgid "Shared with {profiles, plural, one {# user} other {# users}}."
msgstr "Geteilt mit {profiles, plural, one {# Nutzer} other {# Nutzern}}."

msgid "Shared with {vaults, plural, one {# team} other {# teams}}."
msgstr "Geteilt mit {vaults, plural, one {# Team} other {# Teams}}."

msgid "Shared with me"
msgstr "Mit mir geteilt"

msgid "Shared with:"
msgstr "Geteilt mit:"

msgid "Shortcut:"
msgstr "Tastenkürzel:"

msgid "Show"
msgstr "Anzeigen"

msgid "Show backup code"
msgstr "Backup-Code anzeigen"

msgid "Show credit card once"
msgstr "Kreditkarte einmalig anzeigen"

msgid "Show details"
msgstr "Details anzeigen"

msgid "Show edit history"
msgstr "Bearbeitungsverlauf anzeigen"

msgid "Show ELSTER certificate once"
msgstr "ELSTER-Zertifikat einmal anzeigen"

msgid "Show emails"
msgstr "E-Mails anzeigen"

msgid "Show instructions"
msgstr "Anleitung anzeigen"

msgid "Show login once"
msgstr "Login einmalig anzeigen"

msgid "Show logins on mobile devices"
msgstr "Logins auf Mobilgeräten anzeigen"

msgid "Show organization"
msgstr "Organisation anzeigen"

msgid "Show personal logins on mobile devices"
msgstr "Persönliche Logins auf Mobilgeräten anzeigen"

msgid "Show secure note once"
msgstr "Sichere Notiz einmalig anzeigen"

msgid "Show start codes"
msgstr "Startcodes anzeigen"

msgid "Show Wi-Fi once"
msgstr "WLAN einmalig anzeigen"

msgid "simon@example.com"
msgstr "simon@beispiel.de"

msgid "Simplify the login process in your team"
msgstr "Login-Prozess im Team vereinfachen"

msgid "Simplify your login process"
msgstr "Vereinfache deinen Login-Prozess"

msgid "Simply get the app and create your heylogin account, and you can redeem your coupon on this page."
msgstr "Hole dir einfach die App und erstelle deinen heylogin-Account. Dann kannst du deinen Coupon-Code auf dieser Seite einlösen."

msgid "Site notice"
msgstr "Impressum"

msgid "Skip warning"
msgstr "Warnung überspringen"

msgid "Skipped entries"
msgstr "Davon übersprungene Einträge"

msgid "Smoking habits"
msgstr "Rauchgewohnheiten"

msgid "SMS messages"
msgstr "SMS-Nachrichten"

msgid "Social connections"
msgstr "Soziale Verbindungen"

msgid "Social media profiles"
msgstr "Social-Media-Profile"

msgid "Social security numbers"
msgstr "Sozialversicherungsnummern"

msgid "Some organization members are not displayed because their login device is disconnected."
msgstr "Einige Organisations-Mitglieder werden nicht angezeigt, weil ihr Login-Gerät getrennt ist."

msgid "Something went wrong accessing your Entra tenant."
msgstr "Beim Zugriff auf deinen Entra-Tenant ist etwas schiefgelaufen."

msgid "Something went wrong accessing your Google Workspace."
msgstr "Beim Zugriff auf deinen Google Workspace ist etwas schiefgelaufen."

msgid "Something went wrong while setting up your security key."
msgstr "Etwas ist beim Einrichten deines Sicherheitsschlüssels schiefgelaufen."

msgid "Sort by:"
msgstr "Sortieren nach:"

msgid "Spoken languages"
msgstr "Gesprochene Sprachen"

msgid "Spouses' names"
msgstr "Namen der Ehepartner"

msgid "SSH keys are not supported. Please use age-keygen to create a recipient."
msgstr "SSH-Schlüssel werden nicht unterstützt. Bitte verwende age-keygen, um einen Age-Empfänger zu erstellen."

msgid "Start code"
msgstr "Startcode"

#. placeholder {0}: profileIndex + 1
#. placeholder {1}: profileStartCodes.length
msgid "Start code {0} of {1}"
msgstr "Startcode {0} von {1}"

msgid "Start code expired after 30 days"
msgstr "Startcode nach 30 Tagen abgelaufen"

msgid "Start code for:"
msgstr "Startcode für:"

#. placeholder {0}: userGroup.changeRelativeDate
msgid "Start code generated {0}"
msgstr "Startcode {0} generiert"

msgid "Start code generated at {formattedStartCodeGeneratedDate}"
msgstr "Startcode generiert am {formattedStartCodeGeneratedDate}"

msgid "Start code may not be empty!"
msgstr "Startcode darf nicht leer sein!"

msgid "Start for free"
msgstr "Kostenlos starten"

msgctxt "KeeperImport"
msgid "State"
msgstr "Bundesland"

msgid "Status"
msgstr "Status"

msgid "STEP {step}"
msgstr "SCHRITT {step}"

msgid "Step 1 - Download app"
msgstr "Schritt 1 - App herunterladen"

msgid "Step 1 - Receive start code"
msgstr "Schritt 1 - Startcode erhalten"

msgid "Step 2 - Connect app via PIN"
msgstr "Schritt 2 - App per PIN verbinden"

msgid "Step 2 - Enter company email"
msgstr "Schritt 2 - Firmen-E-Mail eingeben"

msgid "Step 2 - Scan the QR code"
msgstr "Schritt 2 - QR-Code scannen"

msgid "StickyPassword"
msgstr "StickyPassword"

msgctxt "KeeperImport"
msgid "Street address line 1"
msgstr "Straße"

msgctxt "KeeperImport"
msgid "Street address line 2"
msgstr "Zusatz"

msgid "Subject"
msgstr "Betreff"

msgid "Subject may not be empty!"
msgstr "Betreff darf nicht leer sein!"

msgid "Successfully connected"
msgstr "Verbinden erfolgreich"

msgid "Support by e-mail"
msgstr "Support per E-Mail"

msgid "Support by phone"
msgstr "Support per Telefon"

msgid "Support tickets"
msgstr "Support-Tickets"

msgid "Survey results"
msgstr "Umfrageergebnisse"

msgid "Swipe to login"
msgstr "Swipe to login"

msgid "Swipe to Login"
msgstr "Swipe to Login"

msgid "Swipe to Login is not available in this browser"
msgstr "Swipe to Login ist in diesem Browser nicht verfügbar"

msgid "Sync existing Accounts"
msgstr "Synchronisiere bestehende Accounts"

msgid "Synced"
msgstr "Synchronisiert"

msgid "Synchronize groups"
msgstr "Gruppen synchronisieren"

msgid "Synchronize groups in heylogin"
msgstr "Synchronisiere Gruppen in heylogin"

msgid "Synchronize users from Entra ID to heylogin automatically."
msgstr "Synchronisiere Nutzer aus Entra ID automatisch zu heylogin."

msgid "Syncing…"
msgstr "Wird synchronisiert…"

msgid "System-wide access to this feature is only supported in Chrome and Microsoft Edge."
msgstr "Systemweiter Zugriff auf dieses Feature wird nur in Chrome und Microsoft Edge unterstützt."

msgid "Tags"
msgstr "Suchtags"

msgid "Tap “heylogin – Password Manager” again"
msgstr "Tippe erneut auf „heylogin – Passwort-Manager“"

msgid "Tap <0>“<1/>”</0> in the address bar"
msgstr "Tippe in der Adresszeile <0>auf „<1/>“</0>"

msgid "Target"
msgstr "Speicherort"

msgid "Target user"
msgstr "Ziel-Nutzer"

msgid "Target users"
msgstr "Ziel-Nutzer"

#. placeholder {0}: getFullLoginVaultLabel(entry.targetVaultMetadata, entry.organizationMetadata)
msgid "Target: <0>{0}</0>"
msgstr "Ziel: <0>{0}</0>"

msgid "Taxation records"
msgstr "Steuerunterlagen"

msgid "Team"
msgstr "Team"

msgid "Team (heylogin)"
msgstr "Team (heylogin)"

msgid "Team Admin"
msgstr "Team-Admin"

msgid "Team description"
msgstr "Teambeschreibung"

msgid "Team management"
msgstr "Team-Verwaltung"

msgid "Team name"
msgstr "Teamname"

msgid "Team name may not be empty!"
msgstr "Der Teamname darf nicht leer sein!"

msgid "Team settings"
msgstr "Teameinstellungen"

msgid "Team users are automatically provisioned from a <0>group in Microsoft Entra</0>."
msgstr "Nutzer in diesem Team werden automatisch aus einer <0>Gruppe in Microsoft Entra</0> provisioniert."

msgid "Teams"
msgstr "Teams"

msgid "Teams (heylogin)"
msgstr "Teams (heylogin)"

msgid "Telecommunications carrier"
msgstr "Telekommunikationsanbieter"

msgid "Terms of use"
msgstr "Nutzungsbedingungen"

msgid "Terms of Use"
msgstr "Nutzungsbedingungen"

msgid "Test phase"
msgstr "Testphase"

msgctxt "KeeperImport"
msgid "Text"
msgstr "Text"

msgid "Text line 1"
msgstr "Textzeile 1"

msgid "Text line 2"
msgstr "Textzeile 2"

msgid "Thank you"
msgstr "Vielen Dank"

msgid "Thank you for your feedback"
msgstr "Vielen Dank für dein Feedback"

msgid "Thank you for your purchase."
msgstr "Vielen Dank für deinen Kauf."

msgid "The account will still be usable"
msgstr "Der Account ist weiterhin nutzbar"

msgid "The additional licenses are available <0>now</0>. An order confirmation will be sent to you soon."
msgstr "Die zusätzlichen Lizenzen stehen <0>ab sofort</0> zur Verfügung. Eine Bestellbestätigung wird in Kürze zugeschickt."

msgid "The additional licenses will be available <0>immediately</0>."
msgstr "Die zusätzlichen Lizenzen stehen dir nach dem Kauf <0>direkt</0> zur Verfügung."

msgid "The additional licenses will be billed according to the terms of your contract."
msgstr "Die Abrechnung erfolgt gemäß den vertraglichen Vereinbarungen."

msgid "The admin role can always manage users"
msgstr "Die Admin-Rolle kann Nutzer immer verwalten"

msgid "The admin role can always view the user list"
msgstr "Die Admin-Rolle kann die Nutzerliste immer einsehen"

msgid "The authorization has been revoked"
msgstr "Die Autorisierung wurde entzogen"

msgid "The authorization was canceled"
msgstr "Die Autorisierung wurde abgebrochen"

msgid "The backup code lets you set up heylogin if you lose access to your login devices."
msgstr "Wenn du keinen Zugriff auf deine Login-Geräte hast, hilft dir der Backup-Code heylogin einzurichten."

msgid "The CSV file is missing an email column"
msgstr "Die CSV-Datei hat keine E-Mail-Spalte"

msgid "The CSV file should have the following format:"
msgstr "Die CSV-Datei muss das folgende Format haben:"

msgid "The default password policy follows recommendations from the <0>CIS Password Policy Guide</0> and <1>NIST SP 800-63B</1>."
msgstr "Die voreingestellte Passwort-Policy folgt den Empfehlungen des <0>CIS Password Policy Guide</0> und <1>NIST SP 800-63B</1>."

msgid "The delegated admin role can always manage users"
msgstr "Die Delegierter-Admin-Rolle kann Nutzer immer verwalten"

msgid "The delegated admin role can always view the user list"
msgstr "Die Delegierter-Admin-Rolle kann die Nutzerliste immer einsehen"

msgid "The deletion request for this organization has been cancelled."
msgstr "Die Löschanfrage für diese Organisation wurde abgebrochen."

msgid "The device you used is not supported. Please use a FIDO2 compatible USB key."
msgstr "Das verwendete Gerät wird nicht unterstützt. Bitte benutze einen FIDO2-kompatiblen USB-Stick."

msgid "The displayed data might be outdated."
msgstr "Die angezeigten Daten könnten veraltet sein."

msgid "The edit history of all logins you have access to will be deleted. The previous versions can not be restored!"
msgstr "Der Bearbeitungsverlauf aller Logins, auf die du Zugriff hast, wird gelöscht. Die alten Versionen können nicht wiederhergestellt werden!"

msgid "The email address is already taken."
msgstr "Die E-Mail-Adresse wird bereits benutzt."

msgid "The email address is not valid."
msgstr "Die E-Mail-Adresse ist nicht gültig."

msgid "The file contains a column named “email”"
msgstr "Die Datei enthält eine Spalte mit dem Namen „email“"

msgid "The first line is a header line"
msgstr "Die erste Zeile ist eine Titelzeile"

msgid "The following credit card was shared with you:"
msgstr "Folgende Kreditkarte wurde mit dir geteilt:"

msgid "The following ELSTER certificate was shared with you:"
msgstr "Folgendes ELSTER-Zertifikat wurde mit dir geteilt:"

msgid "The following login was shared with you:"
msgstr "Folgendes Login wurde mit dir geteilt:"

msgid "The following secure note was shared with you:"
msgstr "Folgende sichere Notiz wurde mit dir geteilt:"

msgid "The following Wi-Fi was shared with you:"
msgstr "Folgendes WLAN wurde mit dir geteilt:"

msgid "The import is not yet finished, really close?"
msgstr "Import noch nicht abgeschlossen, wirklich abbrechen?"

msgid "The import target does not exist"
msgstr "Das Import-Ziel existiert nicht"

msgid "The login inbox “{slug}” does not exist"
msgstr "Der Login-Posteingang „{slug}“ existiert nicht"

msgid "The login was cancelled from your smartphone"
msgstr "Der Login wurde von deinem Smartphone aus abgebrochen"

msgid "The managing organization will have full access to this organization."
msgstr "Die verwaltende Organisation erhält vollen Zugriff auf diese Organisation."

msgid "The Microsoft Entra integration for heylogin allows you to mirror your Entra tenant in heylogin."
msgstr "Die Microsoft-Entra-Integration für heylogin erlaubt es dir, deinen Entra-Tenant in heylogin abzubilden."

msgid "The organization “{name}” will be deleted irrecoverably."
msgstr "Die Organisation „{name}“ wird unwiederbringlich gelöscht."

msgid "The organization can also be recovered from its managing organization"
msgstr "Die Organisation kann auch von ihrer verwaltenden Organisation wiederhergestellt werden"

msgid "The organization has been deleted with all its data."
msgstr "Diese Organisation wurde mit sämtlichen Daten endgültig gelöscht."

msgid "The organization needs at least one admin."
msgstr "Die Organisation braucht mindestens einen Admin."

msgid "The password and other protected fields are hidden from members with the read-only permission, and can not be copied. Logins can only be used to log in on websites. <0>Learn more</0>"
msgstr "Das Passwort und andere geschützte Felder werden vor Mitgliedern, die nur Lesezugriff haben, verborgen und können nicht kopiert werden. Das Login kann nur zum Einloggen auf Webseiten genutzt werden. <0>Mehr erfahren</0>"

msgid "The password and other protected fields will be hidden from the recipient, and can not be copied. The login can only be used to log in on websites. <0>Learn more</0>"
msgstr "Das Passwort und andere geschützte Felder werden vor dem Empfänger verborgen und können nicht kopiert werden. Das Login kann nur zum Einloggen auf Webseiten genutzt werden. <0>Mehr erfahren</0>"

#. placeholder {0}: childOrganization.name
msgid "The personal logins in “{0}” will be deleted."
msgstr "Die persönlichen Logins in „{0}“ werden gelöscht."

msgid "The plan could not be activated due to a license issue. Please contact support."
msgstr "Der Plan konnte aufgrund eines Lizenzproblems nicht aktiviert werden. Bitte kontaktiere den Support."

msgid "The recycle bin is empty"
msgstr "Der Papierkorb ist leer"

msgid "The role you selected does not have the permission to change roles. You will be unable to undo this yourself."
msgstr "Die ausgewählte Rolle hat keine Berechtigung, Rollen zu ändern. Du kannst das selbst nicht rückgängig machen."

msgid "The security key will be able to unlock all your devices."
msgstr "Der Sicherheitsschlüssel kann dann alle deine Geräte entsperren."

msgid "The selected user/email doesn't exist in your heylogin organization at the moment. Create the user now."
msgstr "Der ausgewählte Nutzer existiert momentan nicht in deiner heylogin-Organisation. Du kannst den Nutzer jetzt anlegen."

msgid "The server could not be reached."
msgstr "Der Server konnte nicht erreicht werden."

msgid "The server could not be reached. Please make sure you have connection to the internet and try again in a few minutes."
msgstr "Der Server konnte nicht erreicht werden. Bitte stell sicher, dass du Verbindung zum Internet hast und versuche es in ein paar Minuten noch einmal."

msgid "The settings changes do not affect these users"
msgstr "Die Einstellungsänderungen beeinflussen diese Nutzer nicht"

msgid "The setup was canceled."
msgstr "Die Einrichtung wurde abgebrochen."

msgid "The start code for this account is no longer valid. Ask your admin to create a new one."
msgstr "Der Startcode für diesen Account ist nicht mehr gültig. Kontaktiere deinen Admin, um einen neuen zu erhalten."

msgid "The team “{truncatedName}” will be deleted irrecoverably."
msgstr "Das Team „{truncatedName}“ wird unwiederbringlich gelöscht."

#. placeholder {0}: organization.name
msgid "The team “Delegated Admins” in {0} will be deleted irrecoverably."
msgstr "Das Team „Delegierte Admins“ in {0} wird unwiederbringlich gelöscht."

msgid "The tenant data is currently unavailable"
msgstr "Die Daten des Tenants sind momentan nicht verfügbar"

msgid "The upload is not yet finished, really close?"
msgstr "Der Upload ist noch nicht abgeschlossen, wirklich schließen?"

msgid "The usage of heylogin is governed exclusively by our <0>Terms of Use</0>."
msgstr "Für die Nutzung von heylogin gelten ausschließlich unsere <0>Nutzungsbedingungen</0>."

msgid "The user does not exist."
msgstr "Dieser Benutzer existiert nicht."

msgid "The verification link is invalid"
msgstr "Der Bestätigungs-Link ist ungültig"

msgid "their personal logins"
msgstr "ihre persönlichen Logins"

msgid "There are currently issues with the LastPass export from the website (see this <0>Reddit thread</0>). If possible, export your data using the LastPass web extension in Google Chrome."
msgstr "Es gibt momentan Probleme mit dem Export von der LastPass-Webseite (siehe diesen <0>Reddit-Thread (englisch)</0>). Exportiere deine Daten, wenn möglich, mit der LastPass-Browser-Erweiterung in Google Chrome."

msgid "There are no entries with this label. You can <0>add a new entry</0> to fill it."
msgstr "Es gibt keine Einträge mit diesem Label. Du kannst <0>einen neuen Eintrag hinzufügen</0>, um es zu füllen."

msgid "There are no known breaches for any of the monitored domains."
msgstr "Es gibt keine bekannten Vorfälle für die überwachten Domains."

msgid "There is no account with the given email address"
msgstr "Es gibt keinen Account mit der angegebenen E-Mail-Adresse"

msgid "There is no phone connected to this account."
msgstr "Es ist kein Handy mit diesem Account verbunden."

msgid "There is no security key connected to this account or the security key is not configured to connect new devices. Please contact your organization admin to get access to the account."
msgstr "Es ist kein Sicherheitsschlüssel mit diesem Account verbunden oder der verbundene Sicherheitsschlüssel kann keine neuen Geräte verbinden. Bitte kontaktiere deinen Organisations-Admin, um Zugriff auf den Account zu erhalten."

msgid "There is no security key connected to this account or the security key is not configured to connect new devices. Please use your phone to connect new devices."
msgstr "Es ist kein Sicherheitsschlüssel mit diesem Account verbunden oder der verbundene Sicherheitsschlüssel kann keine neuen Geräte verbinden. Bitte benutze dein Handy, um neue Geräte zu verbinden."

msgid "There must always be at least one admin or delegated admin for an organization. To remove the last delegated admin, give admin permission to one of the users in this managed organization."
msgstr "Es muss immer mindestens einen Admin oder delegierten Admin in der Organisation geben. Um den letzten delegierten Admin zu entfernen, gib einem Nutzer in dieser verwalteten Organisation Admin-Rechte."

msgid "There was a permission error. Please reconnect."
msgstr "Es ist ein Berechtigungsfehler aufgetreten. Bitte neu verbinden."

msgid "There was an error during import. {pleaseUpdate}"
msgstr "Beim Import ist ein Fehler aufgetreten. {pleaseUpdate}"

msgid "There was an error sending the support request. Please try again or send an email to <0>support@heylogin.com</0>."
msgstr "Beim Absenden der Support-Anfrage ist ein Fehler aufgetreten. Bitte versuche es erneut oder sende eine E-Mail an <0>support@heylogin.com</0>."

msgid "These settings are enabled for you due to an ongoing support case. Please <0>contact support</0> once the issue is resolved."
msgstr "Diese Einstellungen sind aufgrund eines laufenden Supportfalls für dich aktiviert. Bitte <0>kontaktiere den Support</0>, wenn das Problem behoben ist."

msgid "These users cannot be removed:"
msgstr "Diese Nutzer können nicht entfernt werden:"

msgid "This account can't be used with a security key."
msgstr "Dieser Account kann nicht mit einem Sicherheitsschlüssel genutzt werden."

msgid "This account is already connected. Please contact your admin."
msgstr "Dieser Account ist bereits verbunden. Bitte kontaktiere deinen Admin."

msgid "This account was deleted. Please contact your admin."
msgstr "Dieser Account wurde gelöscht. Bitte kontaktiere deinen Admin."

msgid "This address already belongs to an account. Contact your admin to get access to the account."
msgstr "Diese Adresse gehört schon zu einem Account. Kontaktiere deinen Admin, um Zugriff auf den Account zu erhalten."

msgid "This address already belongs to an account. If this is your account, contact your admin to regain access."
msgstr "Diese Adresse gehört schon zu einem Account. Wenn das dein Account ist, kontaktiere deinen Admin, um den Zugriff wiederherzustellen."

msgid "This address belongs to an organization. An admin of that organization must set up an account for you to use."
msgstr "Diese Adresse gehört zu einer Organisation. Ein Admin der Organisation muss einen Account für dich erstellen."

msgid "This address is already in use"
msgstr "Diese Adresse ist bereits belegt"

msgid "This address is already in use. If you have lost your login device you can restore your accounts using your backup code."
msgstr "Diese Adresse ist bereits belegt. Wenn du dein Login-Gerät verloren hast, kannst du deine Accounts mit deinem Backup-Code wiederherstellen."

msgid "This address is already in use. If you have lost your login device, please contact support."
msgstr "Diese Adresse ist bereits belegt. Wenn du dein Login-Gerät verloren hast, kontaktiere bitte den Support."

msgid "This contact information is shown in heylogin and serves users as their point of contact in case of questions or problems."
msgstr "Diese Kontaktinformationen werden in heylogin angezeigt und dienen Nutzern als Anlaufstelle für Fragen oder Probleme."

msgid "This coupon code is not compatible with the current license"
msgstr "Dieser Coupon ist nicht kompatibel mit der aktuellen Lizenz"

msgid "This coupon has already been redeemed"
msgstr "Dieser Coupon wurde bereits eingelöst"

msgid "This creates an export of all teams in your organization, including teams that you are not a member of."
msgstr "Diese Option erzeugt einen Export aller Teams in deiner Organisation, inklusive derer, in denen du kein Mitglied bist."

msgid "This email address already belongs to an organization. Please contact your admin to receive a start code."
msgstr "Diese E-Mail-Adresse gehört bereits zu einer Organisation. Bitte wende dich an den Admin, um einen Startcode zu erhalten."

msgid "This email address belongs to an organization. It can't be used to set up a private account."
msgstr "Diese E-Mail-Adresse gehört zu einer Organisation. Sie kann nicht zur Erstellung eines privaten Accounts verwendet werden."

msgid "This email address has no associated start code. Please contact your admin."
msgstr "Mit dieser E-Mail-Adresse ist kein Startcode verknüpft. Bitte wende dich an den Admin, um einen Startcode zu erhalten."

msgid "This email address is already taken."
msgstr "Diese Adresse ist bereits belegt."

msgid "This email address is reserved by an organization."
msgstr "Diese Adresse ist von einer Organisation reserviert."

msgid "This email address is reserved in another organization."
msgstr "Diese Adresse ist bereits in einer anderen Organisation reserviert."

msgid "This feature is not supported by your browser ({browserDescription})."
msgstr "Dieses Feature wird von deinem Browser ({browserDescription}) nicht unterstützt."

msgid "This feature is not supported by your browser."
msgstr "Dieses Feature wird von deinem Browser nicht unterstützt."

msgid "This feature is only available on Microsoft Windows"
msgstr "Dieses Feature ist nur unter Microsoft Windows verfügbar"

msgid "This information will be displayed to identify you as the owner of <0>{displayLink}</0>"
msgstr "Diese Informationen werden angezeigt, um dich als Eigentümer von <0>{displayLink}</0> zu identifizieren"

msgid "This is a service user. It can be connected to the heylogin backup client to perform an on-premises backup of your organization."
msgstr "Dies ist ein Service-Nutzer. Er kann mit dem heylogin-Backup-Client verbunden werden, um ein On-Premises-Backup deiner Organisation anzulegen."

msgid "This is how heylogin works everywhere"
msgstr "So funktioniert heylogin überall"

msgid "This is how you activate 1-click login for your iPhone or iPad"
msgstr "So kannst du 1-Klick-Login für dein iPhone oder iPad aktivieren"

msgid "This link is no longer valid!"
msgstr "Dieser Link ist nicht mehr gültig"

msgid "This link seems to be invalid. Please contact the sender of this link."
msgstr "Dieser Link scheint nicht mehr gültig zu sein. Wende dich an den Absender des Links."

msgid "This login has unsaved changes"
msgstr "Dieses Login hat ungespeicherte Änderungen"

msgid "This login uses the login scopes beta."
msgstr "Dieses Login benutzt die Beta für Login-Matcher."

msgid "This looks like a start code. To join an existing organization, use the “Join” tab."
msgstr "Das sieht aus wie ein Startcode. Um einer bestehenden Organisation beizutreten, nutze den Reiter „Beitreten“."

msgid "This may be related to missing support by your browser or operating system."
msgstr "Das kann an fehlender Unterstützung durch deinen Browser oder dein Betriebssystem liegen."

msgid "This may take a few minutes."
msgstr "Dies kann einige Minuten dauern."

msgid "This operation cannot be undone."
msgstr "Diese Operation kann nicht rückgängig gemacht werden."

msgid "This organization deletion link is invalid."
msgstr "Dieser Löschungsanfrage-Link ist ungültig."

msgid "This organization has already been deleted."
msgstr "Diese Organisation wurde bereits gelöscht."

#. placeholder {0}: parentOrganizationInfo.name
msgid "This organization is managed by <0>{0}</0>."
msgstr "Diese Organisation wird von <0>{0}</0> administriert."

msgid "This organization still has managed organizations. To delete it, remove the managed organizations first"
msgstr "Diese Organisation verwaltet andere Organisationen. Um sie zu löschen, entferne zuerst die verwalteten Organisationen"

msgid "This role can always recover the organization."
msgstr "Diese Rolle kann die Organisation immer wiederherstellen."

msgid "This role is still assigned to users"
msgstr "Diese Rolle ist noch Nutzern zugewiesen"

msgid "This role is used for service users. The permissions for this role cannot be changed."
msgstr "Diese Rolle wird für Service-Nutzer verwendet. Die Berechtigungen für diese Rolle können nicht geändert werden."

#. placeholder {0}: unlockTimeOrgCap.orgName
msgid "This setting is limited by “{0}”."
msgstr "Diese Einstellung ist limitiert durch „{0}“."

msgid "This team is currently empty. Other team members can add new entries for you to use."
msgstr "Dieses Team ist momentan leer. Andere Team-Mitglieder können neue Einträge hinzufügen, die du benutzen kannst."

msgid "This team is empty. You can <0>import entries</0> or <1>add a new entry</1> to fill it."
msgstr "Dieses Team ist leer. Du kannst <0>Einträge importieren</0> oder <1>einen neuen Eintrag hinzufügen</1>, um es zu füllen."

msgid "This team is synchronized automatically."
msgstr "Dieses Team wird automatisch synchronisiert."

msgid "This user does not have a private account."
msgstr "Dieser Benutzer hat keinen privaten Account."

msgid "This user is already a member of this organization."
msgstr "Der Nutzer ist bereits Mitglied in dieser Organisation."

msgid "This user is already a member of this organization. Remove or reassign them in the organization management."
msgstr "Dieser Nutzer ist bereits Mitglied in dieser Organisation. Nutze das Organisationsmanagement um ihn neu zu verbinden oder zu entfernen."

msgid "This user needs to update their account to allow login sharing. Please instruct the user to visit heylogin.app to perform the update."
msgstr "Der Nutzer muss seinen Account für die Login-Freigabe aktualisieren. Bitte weise den Nutzer an, heylogin.app zu besuchen, um das Update durchzuführen."

msgid "This will delete all your login inboxes and all logins contained in them."
msgstr "Dadurch werden alle deine Login-Posteingänge und darin enthaltene Logins gelöscht."

msgid "Time"
msgstr "Zeit"

msgid "Time until device lock can be selected by user, up to 8 hours."
msgstr "Die Zeit, bis ein Gerät gesperrt wird, kann vom Nutzer gewählt werden, bis zu 8 Stunden."

msgid "Time zones"
msgstr "Zeitzonen"

msgid "Title"
msgstr "Titel"

msgid "To be able to use the quick access outside your browser as well, make sure to set the keyboard shortcut to “Global”."
msgstr "Um den Schnellzugriff auch außerhalb deines Browsers zu verwenden, setze das Tastenkürzel auf „Global“."

msgid "To change your billing email, please <0>contact support</0>."
msgstr "Um die Rechnungs-E-Mail zu ändern, <0>kontaktiere den Support</0>."

msgid "To connect your security key and gain access again, you will need a new start code from your admin."
msgstr "Um deinen Sicherheitsschlüssel zu verbinden und wieder Zugriff zu bekommen, brauchst du einen neuen Startcode von deinem Admin."

msgid "To continue using heylogin, please continue your heylogin plan."
msgstr "Setze deinen Plan fort, um heylogin weiter zu nutzen."

msgid "To continue using heylogin, please upgrade your plan."
msgstr "Upgrade deinen Plan, um heylogin weiter zu nutzen."

msgid "To continue using team features after that date, please upgrade your plan."
msgstr "Upgrade deinen Plan, um die Team-Features nach der Testphase weiter zu nutzen."

msgid "To continue using team features after the trial, please upgrade your plan."
msgstr "Upgrade deinen Plan, um die Team-Features nach der Testphase weiter zu nutzen."

msgid "To continue using team features, please upgrade your plan."
msgstr "Upgrade deinen Plan, um Team-Features weiter zu nutzen."

msgid "To delete this organization, you must remove all managed organizations first."
msgstr "Um diese Organisation zu löschen, musst du zuerst alle verwalteten Organisationen entfernen."

msgid "to log in"
msgstr "um dich einzuloggen"

msgid "to Opera from the Chrome Web Store"
msgstr "zu Opera aus dem Chrome Web Store"

msgid "To purchase more than 100 additional licenses, please contact sales"
msgstr "Um mehr als 100 zusätzliche Lizenzen zu kaufen, kontaktiere bitte unseren Vertrieb"

msgid "To redeem your coupon, open this website on your PC or Mac."
msgstr "Öffne diese Seite auf deinem PC oder Mac, um deinen Coupon einzulösen."

msgid "To register with a security key, you need a start code or an email invite from your admin."
msgstr "Um dich mit einem Sicherheitsschlüssel zu registrieren, brauchst du einen Startcode oder eine E-Mail-Einladung von deinem Admin."

msgid "To use a different heylogin account on this device, you'll need to disconnect your security key."
msgstr "Um einen anderen heylogin-Account auf diesem Gerät zu benutzen, musst du die Verbindung zu deinem Sicherheitsschlüssel trennen."

msgid "To use all of heylogin's features, add the browser extension."
msgstr "Um heylogin im vollen Umfang nutzen zu können, füge die Browser-Erweiterung hinzu."

msgid "To use Swipe to Login on this device, add the heylogin <0>browser extension</0> {installFromStore}."
msgstr "Um Swipe to Login auf diesem Gerät zu nutzen, installiere die <0>Browser-Erweiterung</0> {installFromStore}."

msgid "today"
msgstr "heute"

msgid "tomorrow"
msgstr "morgen"

msgid "Too few fields"
msgstr "Zu wenige Felder"

msgid "Too many failed attempts. Try again tomorrow or ask your admin to generate a new start code."
msgstr "Zu viele Fehlversuche. Versuch es morgen noch einmal oder frage deinen Admin nach einem neuen Startcode."

msgid "Total imported logins"
msgstr "Insgesamt importierte Logins"

msgid "Total number of entries"
msgstr "Gesamtzahl der Einträge"

msgid "Total sync users"
msgstr "Gesamtzahl synchronisierter Nutzer"

msgid "TOTP secret"
msgstr "TOTP-Schlüssel"

msgid "TOTP secret shown"
msgstr "TOTP-Schlüssel angezeigt"

msgid "Touch ID (macOS)"
msgstr "Touch ID (macOS)"

msgid "Transfer another login"
msgstr "Weiteres Login übermitteln"

msgid "Transfer encrypted login"
msgstr "Login verschlüsselt übermitteln"

#. placeholder {0}: transferTarget.email
msgid "Transfer login to {0}"
msgstr "Login an {0} übertragen"

msgid "Transfer to personal logins of"
msgstr "Übertragen in die persönlichen Logins von"

msgid "Transfer to user"
msgstr "An Nutzer übertragen"

msgid "Transferred logins will be listed here. You can then drag and drop them into teams or your personal logins."
msgstr "Übermittelte Logins werden hier aufgelistet. Du kannst sie danach einfach per Drag & Drop verschieben."

msgid "Transferring…"
msgstr "Wird übermittelt…"

msgid "Trashed"
msgstr "Papierkorb"

msgid "Travel habits"
msgstr "Reisegewohnheiten"

msgid "Trial expired"
msgstr "Testphase abgelaufen"

msgid "Troubleshooting"
msgstr "Fehlerbehandlung"

msgctxt "unlocking"
msgid "Try again"
msgstr "Erneut versuchen"

msgid "two hours"
msgstr "zwei Stunden"

msgctxt "KeeperImport"
msgid "Two-factor code"
msgstr "Zwei-Faktor-Code"

msgctxt "KeeperImport"
msgid "Type"
msgstr "Typ"

msgid "Types"
msgstr "Typen"

msgid "Unchanged users"
msgstr "Unveränderte Nutzer"

msgid "Undo"
msgstr "Rückgängig"

msgid "Unknown"
msgstr "Unbekannt"

msgid "Unknown Browser"
msgstr "Unbekannter Browser"

msgid "Unknown device"
msgstr "Unbekanntes Gerät"

msgid "Unknown event"
msgstr "Unbekanntes Ereignis"

msgid "Unknown field"
msgstr "Unbekanntes Feld"

msgid "Unknown login"
msgstr "Unbekanntes Login"

msgid "Unknown login location"
msgstr "Unbekannter Login-Speicherort"

msgid "Unknown Operating System"
msgstr "Unbekanntes Betriebssystem"

msgid "Unknown Organization"
msgstr "Unbekannte Organisation"

msgid "Unknown password policy"
msgstr "Unbekannte Passwort-Policy"

msgid "Unknown role"
msgstr "Unbekannte Rolle"

msgid "Unknown time"
msgstr "Unbekannter Zeitpunkt"

msgid "Unknown user"
msgstr "Unbekannter Nutzer"

msgid "Unknown value"
msgstr "Unbekannter Wert"

msgid "Unlock"
msgstr "Entsperren"

msgid "Unlock license"
msgstr "Lizenz freischalten"

msgid "Unlock your heylogin license"
msgstr "Schalte deine heylogin-Lizenz frei"

msgid "Unnamed role"
msgstr "Unbenannte Rolle"

msgid "Unnamed Team"
msgstr "Unbenanntes Team"

msgid "Unverified"
msgstr "Unbestätigt"

msgid "up to"
msgstr "bis zu"

msgid "Update"
msgstr "Aktualisieren"

msgid "Update monitored domains"
msgstr "Überwachte Domains anpassen"

msgid "Update Safari now"
msgstr "Jetzt Safari aktualisieren"

msgid "Upgrade later"
msgstr "Später upgraden"

msgid "Upgrade now"
msgstr "Jetzt upgraden"

msgid "Upgrade plan"
msgstr "Plan upgraden"

msgid "Upgrade to business"
msgstr "Auf Business upgraden"

msgid "Upload"
msgstr "Hochladen"

msgid "Upload CSV file"
msgstr "CSV-Datei hochladen"

msgctxt "KeeperImport"
msgid "URL"
msgstr "Url"

msgid "Use a security key"
msgstr "Mit einem Sicherheitsschlüssel"

msgid "Use Entra groups as heylogin teams to mirror your organizational structure in heylogin."
msgstr "Übernimm Entra-Gruppen als heylogin-Teams, um deine Organisationsstruktur direkt in heylogin abzubilden."

msgid "Use existing account"
msgstr "Bestehenden Account nutzen"

msgid "Use heylogin for your private logins"
msgstr "Nutze heylogin auch privat"

msgid "Use passkeys to log in to websites that support passwordless authentication."
msgstr "Nutze Passkeys, um dich bei Websites anzumelden, die eine passwortlose Authentifizierung unterstützen."

msgid "Use quick access to get easier access to your logins for native apps."
msgstr "Benutze den Schnellzugriff, um aus nativen Apps einfacher auf deine Logins zuzugreifen."

msgid "Use the new format for the scope of logins (websites, Android apps, Windows apps). Logins will be converted to the new format the next time you edit them."
msgstr "Benutze das neue Format für den Geltungsbereich von Logins (Webseiten, Android-Apps, Windows-Apps). Logins werden in das neue Format umgewandelt, wenn du sie das nächste Mal bearbeitest."

msgid "Use your FIDO2 compatible security key"
msgstr "Verwende deinen FIDO2-kompatiblen Sicherheitsschlüssel"

msgid "User"
msgstr "Nutzer"

msgid "User created"
msgstr "Nutzer erstellt"

msgid "User deleted"
msgstr "Nutzer gelöscht"

msgid "User demoted from admin"
msgstr "Nutzer Admin-Rechte entzogen"

msgid "User disconnected"
msgstr "Nutzer getrennt"

msgid "User joined"
msgstr "Nutzer beigetreten"

msgid "User Management"
msgstr "Nutzer-Verwaltung"

msgid "User not found."
msgstr "Nutzer nicht gefunden."

msgid "User promoted to admin"
msgstr "Nutzer zum Admin befördert"

msgid "User settings"
msgstr "Nutzereinstellungen"

msgid "User statuses"
msgstr "Benutzerstatus"

msgid "User website URLs"
msgstr "Benutzer-Website-URLs"

msgid "User/Email"
msgstr "Nutzer/E-Mail"

msgid "Username or e-mail address"
msgstr "Benutzername oder E-Mail-Adresse"

msgid "Usernames"
msgstr "Benutzernamen"

msgid "Users"
msgstr "Nutzer"

msgid "Users and teams"
msgstr "Nutzer und Teams"

msgid "Users disabled in Entra will be disconnected in heylogin"
msgstr "In Entra deaktivierte Nutzer werden von heylogin getrennt"

msgid "Users suggested for creation"
msgstr "Zum Erstellen vorgeschlagene Nutzer"

msgid "Utility bills"
msgstr "Versorgungsrechnungen"

msgid "Vault name"
msgstr "Tresorname"

msgid "Vehicle details"
msgstr "Fahrzeugdetails"

msgid "Vehicle identification numbers (VINs)"
msgstr "Fahrzeug-Identifikationsnummern (VINs)"

msgid "Verification email resent!"
msgstr "Bestätigung erneut verschickt!"

msgid "Verification email sent"
msgstr "Bestätigungs-E-Mail verschickt"

msgid "Verify your email address to create a login inbox."
msgstr "Bestätige deine E-Mail-Adresse, um einen Login-Posteingang zu erstellen."

msgid "Verify your email address to update your login inbox link."
msgstr "Bestätige deine E-Mail-Adresse, um deinen Login-Posteingangs-Link zu ändern."

msgid "Version of {formattedEditTime}, after edit by {editProfileEmail}."
msgstr "Version vom {formattedEditTime}, nach Bearbeitung durch {editProfileEmail}."

msgid "Version of {formattedEditTime}."
msgstr "Version vom {formattedEditTime}."

msgid "View all managed organizations"
msgstr "Alle verwalteten Organisationen einsehen"

msgid "View Auditlog"
msgstr "Auditlog einsehen"

msgid "View feature"
msgstr "Feature anzeigen"

msgid "View Pwnitoring"
msgstr "Pwnitoring einsehen"

msgid "View user list"
msgstr "Nutzerliste einsehen"

#. placeholder {0}: events.length
msgid "Viewing {0} out of {totalEvents} events"
msgstr "{0} von {totalEvents} Ereignissen sichtbar"

msgid "We could not establish a connection to the secure device."
msgstr "Wir konnten keine Verbindung zu dem hinterlegten Gerät herstellen."

msgid "We don't use tracking cookies. Could you help out our marketing person?"
msgstr "Wir verwenden keine Tracking-Cookies. Deine Auskunft hilft unserem Marketing."

msgid "We sent an email for verification to {emailAddress}."
msgstr "Eine E-Mail zur Bestätigung wurde an {emailAddress} verschickt."

msgid "We will reply as soon as possible to <0>{email}</0>"
msgstr "Wir melden uns umgehend mit einer Antwort an <0>{email}</0>"

msgid "We will reply to"
msgstr "Wir antworten dir an"

msgid "Website"
msgstr "Webseite"

msgid "Website activity"
msgstr "Webseitenaktivität"

msgid "Website login"
msgstr "Webseiten-Login"

msgid "Welcome"
msgstr "Willkommen"

msgid "Welcome back!"
msgstr "Willkommen zurück!"

msgid "Welcome to heylogin!"
msgstr "Willkommen bei heylogin!"

msgid "Wi-Fi information"
msgstr "WLAN-Informationen"

msgid "Wi-Fi network name (SSID)"
msgstr "WLAN-Netzwerkname (SSID)"

msgid "Wi-Fi QR code shown"
msgstr "WLAN-QR-Code angezeigt"

msgid "Windows Hello"
msgstr "Windows Hello"

msgid "With a login inbox you can easily and securely receive logins from your customers."
msgstr "Mit einem Login-Posteingang kannst du einfach und sicher Logins von deinen Kunden empfangen."

msgid "With a security key"
msgstr "Mit einem Sicherheitsschlüssel"

msgid "With an active password policy, users in the organization are warned if their passwords violate it."
msgstr "Bei aktiver Passwort-Policy werden Nutzer innerhalb der Organisation gewarnt, wenn ihre Passwörter dagegen verstoßen."

msgid "With heylogin you can securely and easily transmit your logins"
msgstr "Mit heylogin können Sie Ihre Logins einfach und sicher übermitteln"

msgid "With heylogin.me you can create an inbox to receive logins. Your customers can send their securely encrypted logins directly to your inbox via a link."
msgstr "Mit heylogin.me kannst du einen Posteingang erstellen, um Logins zu empfangen. Deine Kunden können per Link ihre Logins sicher verschlüsselt direkt an deinen Posteingang schicken."

msgid "With my phone"
msgstr "Mit meinem Handy"

msgid "With our audit log, admins get an overview of all activities in their heylogin organization. This way, they stay on top of all changes and can act immediately on abuse of confidence."
msgstr "Mit unserem Audit Log bekommen Admins eine genaue Datenübersicht über alle Aktivitäten in ihrer heylogin-Organisation. So sind sie über alle Änderungen informiert und können bei Vertrauensmissbrauch sofort handeln."

msgid "with the heylogin app"
msgstr "mit der heylogin-App"

msgid "With your feedback we improve heylogin every day. Thank you!"
msgstr "Mit deinem Feedback machen wir heylogin täglich ein Stück besser. Danke."

msgid "Work habits"
msgstr "Arbeitsgewohnheiten"

msgctxt "Write [access]"
msgid "Write"
msgstr "Schreibzugriff"

msgid "Write access"
msgstr "Schreibzugriff"

msgid "Write down your backup code"
msgstr "Schreibe deinen Backup-Code auf"

msgid "Yearly"
msgstr "Jährlich"

msgid "Years of professional experience"
msgstr "Jahre Berufserfahrung"

msgid "yesterday"
msgstr "gestern"

msgid "You"
msgstr "Du"

msgid "You are already a member of this organization."
msgstr "Du bist bereits Mitglied in dieser Organisation."

msgid "You are currently not managing any organizations"
msgstr "Du verwaltest momentan keine Organisationen"

msgid "You are just three steps away from unlocking your license coupon for heylogin!"
msgstr "Nur noch drei Schritte trennen dich von deiner heylogin-Lizenz"

msgid "You are logged out"
msgstr "Du bist ausgeloggt"

msgid "You can also <0>check out our help center</0> for answers to common questions."
msgstr "Antworten auf häufige Fragen findest du auch in unserem <0>Help-Center</0>."

msgid "You can look at your logins and manage them here"
msgstr "Hier kannst du deine Logins einsehen und managen"

msgid "You can not disconnect your own login device."
msgstr "Du kannst die Verbindung zu deinem eigenen Login-Gerät nicht trennen."

msgid "You can now close this tab."
msgstr "Du kannst diesen Tab jetzt schließen."

msgid "You can now log in on any website with 1-click login."
msgstr "Du kannst dich jetzt auf jeder Webseite per 1-Klick-Login einloggen."

msgid "You can now make sync settings"
msgstr "Du kannst jetzt einstellen, was synchronisiert werden soll"

msgid "You can only add a new security key if you've logged in recently. Please <0>log out</0>, then log in and try again."
msgstr "Du kannst neue Sicherheitsschlüssel nur hinzufügen, wenn du dich vor Kurzem eingeloggt hast. Bitte <0>logge dich aus</0> und wieder ein und versuche es dann nochmal."

msgid "You can only delete this organization if you are the last remaining admin."
msgstr "Du kannst diese Organisation nur löschen, wenn du der letzte verbliebene Admin bist."

msgid "You can't leave the organization because that would leave it without an admin. Please give another user admin permissions and try again. If you want to delete the organization, you can do so in the <0>organization settings</0>."
msgstr "Du kannst die Organisation nicht verlassen, da sie dann keinen Admin mehr hat. Bitte mache einen anderen Nutzer zum Admin und versuche es nochmal. Falls du die Organisation löschen möchtest, kannst du dies in den <0>Organisationseinstellungen</0> machen."

msgid "You can't remove your only security key. If you want to use another heylogin account on this device, you can disconnect in <0>account settings</0>."
msgstr "Du kannst deinen einzigen Sicherheitsschlüssel nicht entfernen. Wenn du einen anderen heylogin-Account auf diesem Gerät benutzen willst, kannst du die Verbindung in den <0>Account-Einstellungen</0> trennen."

#. placeholder {0}: skippedVaults[0].label
msgid "You cannot export from “{0}”, because you are not allowed to see passwords. Please contact the team admin."
msgstr "Du kannst keine Logins aus „{0}“ exportieren, da du nicht die Berechtigung hast, Passwörter einzusehen. Bitte kontaktiere den Team-Admin."

msgid "You cannot export logins, because you are not allowed to see passwords in these teams."
msgstr "Du kannst keine Logins exportieren, da du nicht die Berechtigung hast, Passwörter einzusehen."

msgid "You cannot remove your own account."
msgstr "Du kannst deinen eigenen Account nicht entfernen."

msgid "You do not have the permission to access managed organizations. To gain access, please contact your admin."
msgstr "Du hast nicht die benötigte Berechtigung, um auf verwaltete Organisationen zuzugreifen. Kontaktiere deinen Admin, um Zugriff zu erhalten."

msgid "You do not have the permission to create managed organizations."
msgstr "Du hast nicht die Berechtigung, verwaltete Organisationen zu erstellen."

msgid "You do not have the permission to export logins from here. Please contact your organization admin."
msgstr "Du hast nicht die Berechtigung, Logins von hier zu exportieren. Bitte wende dich an deinen Organisations-Admin."

#. placeholder {0}: targetVault.label
msgid "You do not have the permission to import logins to “{0}”. Select another location or contact your admin to get the required permission."
msgstr "Du hast nicht die Berechtigung, Logins nach „{0}“ zu importieren. Wähle einen anderen Ort oder kontaktiere deinen Admin, um die benötigte Berechtigung zu erhalten."

#. placeholder {0}: selectedOrganization.name
msgid "You do not have the permission to redeem a coupon for {0}."
msgstr "Du hast nicht die Berechtigung, Coupons für {0} einzulösen."

msgid "You don’t have the permission to remove users"
msgstr "Du hast die Berechtigung zum Entfernen von Nutzern nicht"

msgid "You get your start code via email or from your admin."
msgstr "Du erhältst deinen Startcode per E-Mail oder von deinem Admin."

msgid "You have <0>{numberOfLogins}</0> personal {numberOfLogins, plural, one {login} other {logins}}"
msgstr "Du hast <0>{numberOfLogins}</0> persönliche {numberOfLogins, plural, one {Login} other {Logins}}"

msgid "You have <0>{numberOfLogins}</0> private {numberOfLogins, plural, one {login} other {logins}}"
msgstr "Du hast <0>{numberOfLogins}</0> private {numberOfLogins, plural, one {Login} other {Logins}}"

msgid "You have reached the maximum number of delegated admins for this organization. Please contact sales to increase your limit."
msgstr "Die maximale Anzahl delegierter Admins für diese Organisation wurde erreicht. Um das Limit zu erhöhen, kontaktiere bitte den Vertrieb."

msgid "You have reached the user count included in your license."
msgstr "Du hast die Nutzer-Anzahl erreicht, die in deiner Lizenz enthalten ist."

msgid "You have unsaved changes, really close?"
msgstr "Ungespeicherte Änderungen, wirklich verlassen?"

msgid "You may close this window now"
msgstr "Du kannst dieses Fenster jetzt schließen"

msgid "You may not join this organization because you already have another account."
msgstr "Du kannst dieser Organisation nicht beitreten, da du bereits einen anderen Account hast."

msgid "You must be admin (delegated) of this organization to access it."
msgstr "Du musst Admin (delegiert) dieser Organisation sein, um Zugriff zu haben."

msgid "You must move or delete your <0>personal logins</0> before you can turn this organization into a managed organization."
msgstr "Du musst deine <0>persönlichen Logins</0> verschieben oder löschen, bevor du diese Organisation in eine verwaltete Organisation umwandeln kannst."

msgid "You must verify your email address to activate your login inbox. Go to <0>Account settings</0> to verify your email address."
msgstr "Du musst deine E-Mail-Adresse bestätigen, um deinen Login-Posteingang zu aktivieren. Gehe in die <0>Account-Einstellungen</0>, um deine E-Mail-Adresse zu bestätigen."

msgid "You need to export your data in the 1pux format. Follow the <0>1Password export guide</0> to export your data."
msgstr "Du musst deine Daten in das 1pux-Format exportieren. Folge der <0>1Password Export-Anleitung</0>, um deine Daten zu exportieren."

msgid "You need to remove all delegated admins before converting to an independent organization"
msgstr "Du musst alle delegierten Admins entfernen, bevor du die Organisation in eine eigenständige Organisation umwandeln kannst"

msgid "You received a confirmation via Email."
msgstr "Du hast eine Bestätigung per Mail erhalten."

msgid "You used a different security key. Please use the selected security key to enable connecting devices."
msgstr "Du hast einen anderen Sicherheitsschlüssel verwendet. Bitte verwende den ausgewählten Sicherheitsschlüssel, um das Verbinden von Geräten zu aktivieren."

msgid "You were invited to this team by “{recentlyJoinedAddedByEmail}”."
msgstr "Du wurdest von „{recentlyJoinedAddedByEmail}“ in dieses Team eingeladen."

msgid "You will be forwarded in a few seconds"
msgstr "Du wirst in wenigen Sekunden weitergeleitet"

#. placeholder {0}: getLoginVaultLabel(vaultMetadata)
msgid "You will no longer be able to access this login in “{0}”."
msgstr "Du kannst auf dieses Login dann nicht mehr in „{0}“ zugreifen."

#. placeholder {0}: childOrganization.name
msgid "You will no longer be able to manage “{0}”."
msgstr "Danach kannst du „{0}“ nicht mehr verwalten."

#. placeholder {0}: organization.name
msgid "You will no longer be able to manage {0} from this interface."
msgstr "Du kannst danach {0} nicht mehr über dieses Interface verwalten."

msgid "You will receive your start code from your organization admin."
msgstr "Du erhältst deinen Startcode von deinem Organisations-Admin."

msgid "You'll be able to unlock this device with it."
msgstr "Du kannst damit dann dieses Gerät entsperren."

msgid "You'll be unable to undo this yourself."
msgstr "Du kannst das selbst nicht rückgängig machen."

msgid "You'll no longer be able to access logins."
msgstr "Du kannst danach nicht mehr auf Logins zugreifen."

#. placeholder {0}: organization.name
msgid "You're about to join the organization “{0}”"
msgstr "Du wirst der Organisation „{0}“ beitreten"

msgid "You’ve successfully <0/>set up heylogin"
msgstr "heylogin <0/>erfolgreich eingerichtet"

msgid "You’ve successfully set up heylogin for Safari"
msgstr "Du hast heylogin für Safari erfolgreich eingerichtet"

msgid "Your account is being set up. This may take up to a few minutes."
msgstr "Dein Account wird gerade fertig eingerichtet. Dies kann bis zu einigen Minuten dauern."

msgid "Your backup code"
msgstr "Dein Backup-Code"

msgid "Your backup code can recover your account if you lose access to your login devices."
msgstr "Dein Backup-Code kann deinen Account wiederherstellen, falls du keinen Zugriff mehr auf deine Login-Geräte hast."

msgid "Your browser ({browserDescription}) does not support additional login devices."
msgstr "Dein Browser ({browserDescription}) unterstützt keine zusätzlichen Login-Geräte."

msgid "Your browser ({browserDescription}) has only restricted support for additional login devices."
msgstr "Dein Browser ({browserDescription}) unterstützt zusätzliche Login-Geräte nur eingeschränkt."

msgid "Your browser does not support security keys."
msgstr "Dein Browser unterstützt Sicherheitsschlüssel nicht."

msgid "Your browser is not fully supported"
msgstr "Dein Browser wird nicht vollständig unterstützt"

msgid "Your browser is not fully supported."
msgstr "Dein Browser wird nicht vollständig unterstützt."

msgid "Your browser is out of date. Please update your browser to use heylogin."
msgstr "Dein Browser ist veraltet. Bitte aktualisiere deinen Browser, um heylogin zu nutzen."

msgid "Your browser was unable to access the security key. You may need to grant permissions in your operating system."
msgstr "Dein Browser konnte nicht auf den Sicherheitsschlüssel zugreifen. Erlaube den Zugriff in den Systemeinstellungen."

msgid "Your company (optional)"
msgstr "Ihre Firma (optional)"

msgid "Your contact"
msgstr "Dein Ansprechpartner"

msgid "Your coupon code"
msgstr "Dein Coupon-Code"

msgid "Your download starts automatically. If not, click the button to download the exported data."
msgstr "Dein Download startet automatisch. Wenn nicht, klicke den Button, um die exportierten Daten herunterzuladen."

msgid "Your e-mail address has been confirmed"
msgstr "Deine E-Mail-Adresse wurde bestätigt"

msgid "Your email address"
msgstr "Deine E-Mail-Adresse"

msgid "Your inbox link:"
msgstr "Dein Posteingangs-Link:"

msgid "Your login was transferred successfully"
msgstr "Ihr Login wurde erfolgreich übertragen"

msgid "Your login will be saved automatically."
msgstr "Dein Login wird danach automatisch gespeichert."

msgid "Your logins will be added automatically"
msgstr "Deine Logins werden automatisch hinzugefügt"

msgid "Your message"
msgstr "Deine Nachricht"

msgid "Your name"
msgstr "Ihr Vor- und Nachname"

msgid "Your operating system/browser does not support the PRF extension or your security key does not support the HMAC-Secret extension. These are needed to connect devices."
msgstr "Dein Betriebssystem/Browser unterstützt die PRF-Erweiterung nicht oder dein Sicherheitsschlüssel unterstützt die HMAC-Secret-Erweiterung nicht. Diese werden benötigt, um Geräte zu verbinden."

msgid "Your organization has unpaid invoices. Please contact your administrator."
msgstr "Diese Organisation hat offene Rechnungen. Bitte kontaktiere deinen Administrator."

msgid "Your organization has unpaid invoices. Please resolve the outstanding balance."
msgstr "Diese Organisation hat offene Rechnungen. Bitte begleiche den ausstehenden Betrag."

msgid "Your organization only allows heylogin with the browser extension on devices managed by its administrators. Please contact your administrator."
msgstr "Deine Organisation erlaubt heylogin nur mit der Browser-Erweiterung auf Geräten, die von ihren Administratoren verwaltet werden. Bitte kontaktiere deinen Administrator."

msgid "Your personal logins are empty. You can <0>import entries</0> or <1>add a new entry</1> to fill them."
msgstr "Deine persönlichen Logins sind leer. Du kannst <0>Einträge importieren</0> oder <1>einen neuen Eintrag hinzufügen</1>, um sie zu füllen."

msgid "Your previous backup code will be invalidated. Please write down the new backup code and keep it in a safe place."
msgstr "Dein vorheriger Backup-Code wird ungültig gemacht. Bitte notiere dir den neuen Backup-Code und bewahre ihn an einem sicheren Ort auf."

#. placeholder {0}: profileInfo.email
msgid "Your private account “{0}” and all its logins will be deleted."
msgstr "Dein privater Account „{0}“ und all seine Logins werden gelöscht."

msgid "Your private account is independent of all organizations you join."
msgstr "Dein privater Account ist unabhängig von Organisationen, denen du beitrittst."

msgid "Your private account is separate from all organizations you are a member in."
msgstr "Dein privater Account ist getrennt von Organisationen, in denen du Mitglied bist."

#. placeholder {0}: orgMembershipStatus.name
msgid "Your private account is separate from the organization “{0}”."
msgstr "Dein privater Account ist getrennt von der Organisation „{0}“."

msgid "Your private logins are empty. You can <0>import entries</0> or <1>add a new entry</1> to fill them."
msgstr "Deine privaten Logins sind leer. Du kannst <0>Einträge importieren</0> oder <1>einen neuen Eintrag hinzufügen</1>, um sie zu füllen."

msgid "Your security key does not support the HMAC-Secret extension, which is needed to connect devices."
msgstr "Dein Sicherheitsschlüssel unterstützt die HMAC-Secret-Erweiterung nicht, die benötigt wird, um Geräte zu verbinden."

msgid "Your security key will be disconnected from this account."
msgstr "Dein Sicherheitsschlüssel wird von diesem Account getrennt."

msgid "Your trial ended on {trialEnd}."
msgstr "Die Testphase ist am {trialEnd} abgelaufen."

msgid "Your trial ends on {trialEnd}."
msgstr "Die Testphase endet am {trialEnd}."

msgctxt "KeeperImport"
msgid "Zip"
msgstr "PLZ"
